/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as DemoRouteImport } from './routes/demo'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BlastroConnectRouteImport } from './routes/blastro.connect'
import { Route as AuthPreviewTestRouteImport } from './routes/_auth/preview-test'
import { Route as AuthDocsIndexRouteImport } from './routes/_auth/docs.index'
import { Route as BlastroSiteIdConnectRouteImport } from './routes/blastro.$siteId.connect'
import { Route as AuthSettingsNotificationsRouteImport } from './routes/_auth/settings.notifications'
import { Route as AuthSettingsNotificationRejectsRouteImport } from './routes/_auth/settings.notification-rejects'
import { Route as AuthDocsSiteIdRouteImport } from './routes/_auth/docs.$siteId'
import { Route as AuthComposeTextSiteIdRouteImport } from './routes/_auth/compose-text.$siteId'
import { Route as AuthBrandOnboardingSiteIdRouteImport } from './routes/_auth/brand-onboarding.$siteId'
import { Route as AuthAppleMessagesConnectRouteImport } from './routes/_auth/apple-messages/connect'
import { Route as AuthSkuStoreSiteIdRouteRouteImport } from './routes/_auth/sku-store.$siteId/route'
import { Route as AuthSettingsSiteIdRouteRouteImport } from './routes/_auth/settings.$siteId/route'
import { Route as AuthPeopleSiteIdRouteRouteImport } from './routes/_auth/people.$siteId/route'
import { Route as AuthMarketingCalendarSiteIdRouteRouteImport } from './routes/_auth/marketing-calendar.$siteId/route'
import { Route as AuthGenlabSiteIdRouteRouteImport } from './routes/_auth/genlab.$siteId/route'
import { Route as AuthGenerationsSiteIdRouteRouteImport } from './routes/_auth/generations.$siteId/route'
import { Route as AuthExchangesSiteIdRouteRouteImport } from './routes/_auth/exchanges.$siteId/route'
import { Route as AuthDragonTilesSiteIdRouteRouteImport } from './routes/_auth/dragon-tiles.$siteId/route'
import { Route as AuthDimensionsSiteIdRouteRouteImport } from './routes/_auth/dimensions.$siteId/route'
import { Route as AuthCreativeSphereSiteIdRouteRouteImport } from './routes/_auth/creative-sphere.$siteId/route'
import { Route as AuthBlocksSiteIdRouteRouteImport } from './routes/_auth/blocks.$siteId/route'
import { Route as AuthBestiesSiteIdRouteRouteImport } from './routes/_auth/besties.$siteId/route'
import { Route as AuthAssetsSiteIdRouteRouteImport } from './routes/_auth/assets.$siteId/route'
import { Route as AuthSkuStoreSiteIdIndexRouteImport } from './routes/_auth/sku-store.$siteId/index'
import { Route as AuthSettingsSiteIdIndexRouteImport } from './routes/_auth/settings.$siteId/index'
import { Route as AuthMarketingCalendarSiteIdIndexRouteImport } from './routes/_auth/marketing-calendar.$siteId/index'
import { Route as AuthGenlabSiteIdIndexRouteImport } from './routes/_auth/genlab.$siteId/index'
import { Route as AuthGenerationsSiteIdIndexRouteImport } from './routes/_auth/generations.$siteId/index'
import { Route as AuthDragonTilesSiteIdIndexRouteImport } from './routes/_auth/dragon-tiles.$siteId/index'
import { Route as AuthDimensionsSiteIdIndexRouteImport } from './routes/_auth/dimensions.$siteId/index'
import { Route as AuthCreativeSphereSiteIdIndexRouteImport } from './routes/_auth/creative-sphere.$siteId/index'
import { Route as AuthBestiesSiteIdIndexRouteImport } from './routes/_auth/besties.$siteId/index'
import { Route as AuthSkuStoreSiteIdMappingRouteImport } from './routes/_auth/sku-store.$siteId/mapping'
import { Route as AuthSettingsSiteIdTextRouteImport } from './routes/_auth/settings.$siteId/text'
import { Route as AuthSettingsSiteIdSmsRegistrationRouteImport } from './routes/_auth/settings.$siteId/sms-registration'
import { Route as AuthSettingsSiteIdSeedBestiesSitesRouteImport } from './routes/_auth/settings.$siteId/seed-besties-sites'
import { Route as AuthSettingsSiteIdReportingRouteImport } from './routes/_auth/settings.$siteId/reporting'
import { Route as AuthSettingsSiteIdRecommendationExclusionsRouteImport } from './routes/_auth/settings.$siteId/recommendation-exclusions'
import { Route as AuthSettingsSiteIdMockConfigRouteImport } from './routes/_auth/settings.$siteId/mock-config'
import { Route as AuthSettingsSiteIdMachineApplicationsRouteImport } from './routes/_auth/settings.$siteId/machine-applications'
import { Route as AuthSettingsSiteIdGeneralRouteImport } from './routes/_auth/settings.$siteId/general'
import { Route as AuthSettingsSiteIdFeatureFlagsRouteImport } from './routes/_auth/settings.$siteId/feature-flags'
import { Route as AuthSettingsSiteIdEmailRouteImport } from './routes/_auth/settings.$siteId/email'
import { Route as AuthSettingsSiteIdBillingRouteImport } from './routes/_auth/settings.$siteId/billing'
import { Route as AuthMarketingCalendarSiteIdNewRouteImport } from './routes/_auth/marketing-calendar.$siteId/new'
import { Route as AuthExchangesSiteIdNewRouteImport } from './routes/_auth/exchanges.$siteId/new'
import { Route as AuthDimensionsSiteIdPeopleRouteImport } from './routes/_auth/dimensions.$siteId/people'
import { Route as AuthDimensionsSiteIdExchangesRouteImport } from './routes/_auth/dimensions.$siteId/exchanges'
import { Route as AuthBrandOnboardingSiteIdStepIdRouteImport } from './routes/_auth/brand-onboarding.$siteId.$stepId'
import { Route as AuthBestiesSiteIdRevenueRouteImport } from './routes/_auth/besties.$siteId/revenue'
import { Route as AuthBestiesSiteIdReportingRouteImport } from './routes/_auth/besties.$siteId/reporting'
import { Route as AuthBestiesSiteIdOnboardingRouteImport } from './routes/_auth/besties.$siteId/onboarding'
import { Route as AuthAssetsSiteIdAssetKeyRouteImport } from './routes/_auth/assets.$siteId/$assetKey'
import { Route as AuthSkuStoreSiteIdSkuIdRouteRouteImport } from './routes/_auth/sku-store.$siteId/$skuId/route'
import { Route as AuthSettingsSiteIdCouponCodesRouteRouteImport } from './routes/_auth/settings.$siteId/coupon-codes/route'
import { Route as AuthSettingsSiteIdConnectorsRouteRouteImport } from './routes/_auth/settings.$siteId/connectors/route'
import { Route as AuthSettingsSiteIdZeroAdminRouteRouteImport } from './routes/_auth/settings.$siteId/_zeroAdmin/route'
import { Route as AuthPeopleSiteIdProfilesRouteRouteImport } from './routes/_auth/people.$siteId/profiles/route'
import { Route as AuthPeopleSiteIdListsRouteRouteImport } from './routes/_auth/people.$siteId/lists/route'
import { Route as AuthPeopleSiteIdAudiencesRouteRouteImport } from './routes/_auth/people.$siteId/audiences/route'
import { Route as AuthDragonTilesSiteIdConnectorsRouteRouteImport } from './routes/_auth/dragon-tiles.$siteId/connectors/route'
import { Route as AuthDragonTilesSiteIdByocRouteRouteImport } from './routes/_auth/dragon-tiles.$siteId/byoc/route'
import { Route as AuthDragonTilesSiteIdBroadcastV2RouteRouteImport } from './routes/_auth/dragon-tiles.$siteId/broadcastV2/route'
import { Route as AuthDragonTilesSiteIdBroadcastRouteRouteImport } from './routes/_auth/dragon-tiles.$siteId/broadcast/route'
import { Route as AuthDragonTilesSiteIdParentTileRouteRouteImport } from './routes/_auth/dragon-tiles.$siteId/$parentTile/route'
import { Route as AuthSkuStoreSiteIdSkuIdIndexRouteImport } from './routes/_auth/sku-store.$siteId/$skuId/index'
import { Route as AuthSettingsSiteIdConnectorsIndexRouteImport } from './routes/_auth/settings.$siteId/connectors/index'
import { Route as AuthPeopleSiteIdProfilesIndexRouteImport } from './routes/_auth/people.$siteId/profiles/index'
import { Route as AuthPeopleSiteIdListsIndexRouteImport } from './routes/_auth/people.$siteId/lists/index'
import { Route as AuthPeopleSiteIdAudiencesIndexRouteImport } from './routes/_auth/people.$siteId/audiences/index'
import { Route as AuthDragonTilesSiteIdConnectorsIndexRouteImport } from './routes/_auth/dragon-tiles.$siteId/connectors/index'
import { Route as AuthSkuStoreSiteIdSkuIdVariantsRouteImport } from './routes/_auth/sku-store.$siteId/$skuId/variants'
import { Route as AuthSkuStoreSiteIdSkuIdReviewsRouteImport } from './routes/_auth/sku-store.$siteId/$skuId/reviews'
import { Route as AuthSkuStoreSiteIdSkuIdMediaRouteImport } from './routes/_auth/sku-store.$siteId/$skuId/media'
import { Route as AuthSkuStoreSiteIdSkuIdMappingRouteImport } from './routes/_auth/sku-store.$siteId/$skuId/mapping'
import { Route as AuthSkuStoreSiteIdSkuIdEngagementRouteImport } from './routes/_auth/sku-store.$siteId/$skuId/engagement'
import { Route as AuthSkuStoreSiteIdSkuIdCopyRouteImport } from './routes/_auth/sku-store.$siteId/$skuId/copy'
import { Route as AuthSkuStoreSiteIdSkuIdAssociationsRouteImport } from './routes/_auth/sku-store.$siteId/$skuId/associations'
import { Route as AuthSettingsSiteIdCouponCodesNewRouteImport } from './routes/_auth/settings.$siteId/coupon-codes/new'
import { Route as AuthSettingsSiteIdCouponCodesAddCodesRouteImport } from './routes/_auth/settings.$siteId/coupon-codes/add-codes'
import { Route as AuthSettingsSiteIdConnectorsInstalledRouteImport } from './routes/_auth/settings.$siteId/connectors/installed'
import { Route as AuthSettingsSiteIdConnectorsAllRouteImport } from './routes/_auth/settings.$siteId/connectors/all'
import { Route as AuthSettingsSiteIdConnectorsConnectorIdRouteImport } from './routes/_auth/settings.$siteId/connectors/$connectorId'
import { Route as AuthSettingsSiteIdZeroAdminCopyFramesRouteImport } from './routes/_auth/settings.$siteId/_zeroAdmin/copy-frames'
import { Route as AuthPeopleSiteIdListsListIdRouteImport } from './routes/_auth/people.$siteId/lists/$listId'
import { Route as AuthPeopleSiteIdAudiencesNewRouteImport } from './routes/_auth/people.$siteId/audiences/new'
import { Route as AuthPeopleSiteIdAudiencesExportsRouteImport } from './routes/_auth/people.$siteId/audiences/exports'
import { Route as AuthExchangesSiteIdIdEditRouteImport } from './routes/_auth/exchanges.$siteId/$id.edit'
import { Route as AuthDragonTilesSiteIdNewVariantRouteImport } from './routes/_auth/dragon-tiles.$siteId/new.$variant'
import { Route as AuthDragonTilesSiteIdConnectorsParentTileRouteImport } from './routes/_auth/dragon-tiles.$siteId/connectors/$parentTile'
import { Route as AuthDragonTilesSiteIdBroadcastListRouteImport } from './routes/_auth/dragon-tiles.$siteId/broadcast/list'
import { Route as AuthDragonTilesSiteIdFrameIdVariantRouteImport } from './routes/_auth/dragon-tiles.$siteId/$frameId.$variant'
import { Route as AuthConnectorsSiteIdYotpoInstallRouteImport } from './routes/_auth/connectors.$siteId/yotpo/install'
import { Route as AuthBestiesSiteIdOnboardingBrandIdRouteImport } from './routes/_auth/besties.$siteId/onboarding_.$brandId'
import { Route as AuthPeopleSiteIdProfilesProfileIdRouteRouteImport } from './routes/_auth/people.$siteId/profiles/$profileId/route'
import { Route as AuthGenerationsSiteIdNewPilotRouteRouteImport } from './routes/_auth/generations.$siteId/new/pilot/route'
import { Route as AuthGenerationsSiteIdNewCollectionRouteRouteImport } from './routes/_auth/generations.$siteId/new/collection/route'
import { Route as AuthSkuStoreSiteIdSkuIdStoriesIndexRouteImport } from './routes/_auth/sku-store.$siteId/$skuId/stories/index'
import { Route as AuthSettingsSiteIdZeroAdminSitesIndexRouteImport } from './routes/_auth/settings.$siteId/_zeroAdmin/sites/index'
import { Route as AuthSettingsSiteIdZeroAdminOnboardingIndexRouteImport } from './routes/_auth/settings.$siteId/_zeroAdmin/onboarding/index'
import { Route as AuthSettingsSiteIdZeroAdminNotificationsIndexRouteImport } from './routes/_auth/settings.$siteId/_zeroAdmin/notifications/index'
import { Route as AuthSettingsSiteIdZeroAdminNotificationRejectsIndexRouteImport } from './routes/_auth/settings.$siteId/_zeroAdmin/notification-rejects/index'
import { Route as AuthSettingsSiteIdZeroAdminBlueprintsIndexRouteImport } from './routes/_auth/settings.$siteId/_zeroAdmin/blueprints/index'
import { Route as AuthSettingsSiteIdZeroAdminAccountsIndexRouteImport } from './routes/_auth/settings.$siteId/_zeroAdmin/accounts/index'
import { Route as AuthPeopleSiteIdProfilesProfileIdIndexRouteImport } from './routes/_auth/people.$siteId/profiles/$profileId/index'
import { Route as AuthPeopleSiteIdListsListIdIndexRouteImport } from './routes/_auth/people.$siteId/lists/$listId.index'
import { Route as AuthSkuStoreSiteIdSkuIdStoriesNewRouteImport } from './routes/_auth/sku-store.$siteId/$skuId/stories/new'
import { Route as AuthSettingsSiteIdCouponCodesNewUniqueRouteImport } from './routes/_auth/settings.$siteId/coupon-codes/new.unique'
import { Route as AuthSettingsSiteIdCouponCodesNewStaticRouteImport } from './routes/_auth/settings.$siteId/coupon-codes/new.static'
import { Route as AuthSettingsSiteIdCouponCodesEditOfferSlugRouteImport } from './routes/_auth/settings.$siteId/coupon-codes/edit.$offerSlug'
import { Route as AuthSettingsSiteIdZeroAdminSitesRjIdRouteImport } from './routes/_auth/settings.$siteId/_zeroAdmin/sites/$rjId'
import { Route as AuthSettingsSiteIdZeroAdminBlueprintsBlueprintIdRouteImport } from './routes/_auth/settings.$siteId/_zeroAdmin/blueprints/$blueprintId'
import { Route as AuthSettingsSiteIdZeroAdminAccountsAccountIdRouteImport } from './routes/_auth/settings.$siteId/_zeroAdmin/accounts/$accountId'
import { Route as AuthPeopleSiteIdAudiencesAudienceIdEditRouteImport } from './routes/_auth/people.$siteId/audiences/$audienceId/edit'
import { Route as AuthGenlabSiteIdPresetsEditPresetIdRouteImport } from './routes/_auth/genlab.$siteId/presets/edit.$presetId'
import { Route as AuthGenerationsSiteIdNewPilotStepIdRouteImport } from './routes/_auth/generations.$siteId/new/pilot/$stepId'
import { Route as AuthGenerationsSiteIdNewCollectionStepIdRouteImport } from './routes/_auth/generations.$siteId/new/collection/$stepId'
import { Route as AuthDragonTilesSiteIdByocTileFrameIdRouteImport } from './routes/_auth/dragon-tiles.$siteId/byoc/tile.$frameId'
import { Route as AuthDragonTilesSiteIdBroadcastV2NewSmsRouteImport } from './routes/_auth/dragon-tiles.$siteId/broadcastV2/new.sms'
import { Route as AuthDragonTilesSiteIdBroadcastV2NewEmailRouteImport } from './routes/_auth/dragon-tiles.$siteId/broadcastV2/new.email'
import { Route as AuthDragonTilesSiteIdBroadcastV2BroadcastIdSmsRouteImport } from './routes/_auth/dragon-tiles.$siteId/broadcastV2/$broadcastId.sms'
import { Route as AuthDragonTilesSiteIdBroadcastV2BroadcastIdEmailRouteImport } from './routes/_auth/dragon-tiles.$siteId/broadcastV2/$broadcastId.email'
import { Route as AuthDragonTilesSiteIdParentTileTileFrameIdRouteImport } from './routes/_auth/dragon-tiles.$siteId/$parentTile/tile.$frameId'
import { Route as AuthPeopleSiteIdAudiencesAudienceIdMembersIndexRouteImport } from './routes/_auth/people.$siteId/audiences/$audienceId/members/index'
import { Route as AuthSkuStoreSiteIdSkuIdStoriesEditStoryIdRouteImport } from './routes/_auth/sku-store.$siteId/$skuId/stories/edit.$storyId'
import { Route as AuthSettingsSiteIdCouponCodesNewUniqueShopifyRouteImport } from './routes/_auth/settings.$siteId/coupon-codes/new.unique.shopify'
import { Route as AuthSettingsSiteIdCouponCodesNewUniqueFoxyRouteImport } from './routes/_auth/settings.$siteId/coupon-codes/new.unique.foxy'
import { Route as AuthSettingsSiteIdCouponCodesNewUniqueCsvRouteImport } from './routes/_auth/settings.$siteId/coupon-codes/new.unique.csv'
import { Route as AuthGenlabSiteIdPresetsSceneEditPresetIdRouteImport } from './routes/_auth/genlab.$siteId/presets/scene.edit.$presetId'
import { Route as AuthGenlabSiteIdPresetsCompositionEditPresetIdRouteImport } from './routes/_auth/genlab.$siteId/presets/composition.edit.$presetId'
import { Route as AuthGenlabSiteIdPresetsCastingEditPresetIdRouteImport } from './routes/_auth/genlab.$siteId/presets/casting.edit.$presetId'
import { Route as AuthDragonTilesSiteIdConnectorsParentTileTileFrameIdRouteImport } from './routes/_auth/dragon-tiles.$siteId/connectors/$parentTile/tile.$frameId'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoRoute = DemoRouteImport.update({
  id: '/demo',
  path: '/demo',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const BlastroConnectRoute = BlastroConnectRouteImport.update({
  id: '/blastro/connect',
  path: '/blastro/connect',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthPreviewTestRoute = AuthPreviewTestRouteImport.update({
  id: '/preview-test',
  path: '/preview-test',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthDocsIndexRoute = AuthDocsIndexRouteImport.update({
  id: '/docs/',
  path: '/docs/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const BlastroSiteIdConnectRoute = BlastroSiteIdConnectRouteImport.update({
  id: '/blastro/$siteId/connect',
  path: '/blastro/$siteId/connect',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSettingsNotificationsRoute =
  AuthSettingsNotificationsRouteImport.update({
    id: '/settings/notifications',
    path: '/settings/notifications',
    getParentRoute: () => AuthRouteRoute,
  } as any)
const AuthSettingsNotificationRejectsRoute =
  AuthSettingsNotificationRejectsRouteImport.update({
    id: '/settings/notification-rejects',
    path: '/settings/notification-rejects',
    getParentRoute: () => AuthRouteRoute,
  } as any)
const AuthDocsSiteIdRoute = AuthDocsSiteIdRouteImport.update({
  id: '/docs/$siteId',
  path: '/docs/$siteId',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthComposeTextSiteIdRoute = AuthComposeTextSiteIdRouteImport.update({
  id: '/compose-text/$siteId',
  path: '/compose-text/$siteId',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthBrandOnboardingSiteIdRoute =
  AuthBrandOnboardingSiteIdRouteImport.update({
    id: '/brand-onboarding/$siteId',
    path: '/brand-onboarding/$siteId',
    getParentRoute: () => AuthRouteRoute,
  } as any)
const AuthAppleMessagesConnectRoute =
  AuthAppleMessagesConnectRouteImport.update({
    id: '/apple-messages/connect',
    path: '/apple-messages/connect',
    getParentRoute: () => AuthRouteRoute,
  } as any)
const AuthSkuStoreSiteIdRouteRoute = AuthSkuStoreSiteIdRouteRouteImport.update({
  id: '/sku-store/$siteId',
  path: '/sku-store/$siteId',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSettingsSiteIdRouteRoute = AuthSettingsSiteIdRouteRouteImport.update({
  id: '/settings/$siteId',
  path: '/settings/$siteId',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthPeopleSiteIdRouteRoute = AuthPeopleSiteIdRouteRouteImport.update({
  id: '/people/$siteId',
  path: '/people/$siteId',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthMarketingCalendarSiteIdRouteRoute =
  AuthMarketingCalendarSiteIdRouteRouteImport.update({
    id: '/marketing-calendar/$siteId',
    path: '/marketing-calendar/$siteId',
    getParentRoute: () => AuthRouteRoute,
  } as any)
const AuthGenlabSiteIdRouteRoute = AuthGenlabSiteIdRouteRouteImport.update({
  id: '/genlab/$siteId',
  path: '/genlab/$siteId',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthGenerationsSiteIdRouteRoute =
  AuthGenerationsSiteIdRouteRouteImport.update({
    id: '/generations/$siteId',
    path: '/generations/$siteId',
    getParentRoute: () => AuthRouteRoute,
  } as any)
const AuthExchangesSiteIdRouteRoute =
  AuthExchangesSiteIdRouteRouteImport.update({
    id: '/exchanges/$siteId',
    path: '/exchanges/$siteId',
    getParentRoute: () => AuthRouteRoute,
  } as any)
const AuthDragonTilesSiteIdRouteRoute =
  AuthDragonTilesSiteIdRouteRouteImport.update({
    id: '/dragon-tiles/$siteId',
    path: '/dragon-tiles/$siteId',
    getParentRoute: () => AuthRouteRoute,
  } as any)
const AuthDimensionsSiteIdRouteRoute =
  AuthDimensionsSiteIdRouteRouteImport.update({
    id: '/dimensions/$siteId',
    path: '/dimensions/$siteId',
    getParentRoute: () => AuthRouteRoute,
  } as any)
const AuthCreativeSphereSiteIdRouteRoute =
  AuthCreativeSphereSiteIdRouteRouteImport.update({
    id: '/creative-sphere/$siteId',
    path: '/creative-sphere/$siteId',
    getParentRoute: () => AuthRouteRoute,
  } as any)
const AuthBlocksSiteIdRouteRoute = AuthBlocksSiteIdRouteRouteImport.update({
  id: '/blocks/$siteId',
  path: '/blocks/$siteId',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthBestiesSiteIdRouteRoute = AuthBestiesSiteIdRouteRouteImport.update({
  id: '/besties/$siteId',
  path: '/besties/$siteId',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthAssetsSiteIdRouteRoute = AuthAssetsSiteIdRouteRouteImport.update({
  id: '/assets/$siteId',
  path: '/assets/$siteId',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSkuStoreSiteIdIndexRoute = AuthSkuStoreSiteIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthSkuStoreSiteIdRouteRoute,
} as any)
const AuthSettingsSiteIdIndexRoute = AuthSettingsSiteIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthSettingsSiteIdRouteRoute,
} as any)
const AuthMarketingCalendarSiteIdIndexRoute =
  AuthMarketingCalendarSiteIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthMarketingCalendarSiteIdRouteRoute,
  } as any)
const AuthGenlabSiteIdIndexRoute = AuthGenlabSiteIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthGenlabSiteIdRouteRoute,
} as any)
const AuthGenerationsSiteIdIndexRoute =
  AuthGenerationsSiteIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthGenerationsSiteIdRouteRoute,
  } as any)
const AuthDragonTilesSiteIdIndexRoute =
  AuthDragonTilesSiteIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthDragonTilesSiteIdRouteRoute,
  } as any)
const AuthDimensionsSiteIdIndexRoute =
  AuthDimensionsSiteIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthDimensionsSiteIdRouteRoute,
  } as any)
const AuthCreativeSphereSiteIdIndexRoute =
  AuthCreativeSphereSiteIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthCreativeSphereSiteIdRouteRoute,
  } as any)
const AuthBestiesSiteIdIndexRoute = AuthBestiesSiteIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthBestiesSiteIdRouteRoute,
} as any)
const AuthSkuStoreSiteIdMappingRoute =
  AuthSkuStoreSiteIdMappingRouteImport.update({
    id: '/mapping',
    path: '/mapping',
    getParentRoute: () => AuthSkuStoreSiteIdRouteRoute,
  } as any)
const AuthSettingsSiteIdTextRoute = AuthSettingsSiteIdTextRouteImport.update({
  id: '/text',
  path: '/text',
  getParentRoute: () => AuthSettingsSiteIdRouteRoute,
} as any)
const AuthSettingsSiteIdSmsRegistrationRoute =
  AuthSettingsSiteIdSmsRegistrationRouteImport.update({
    id: '/sms-registration',
    path: '/sms-registration',
    getParentRoute: () => AuthSettingsSiteIdRouteRoute,
  } as any)
const AuthSettingsSiteIdSeedBestiesSitesRoute =
  AuthSettingsSiteIdSeedBestiesSitesRouteImport.update({
    id: '/seed-besties-sites',
    path: '/seed-besties-sites',
    getParentRoute: () => AuthSettingsSiteIdRouteRoute,
  } as any)
const AuthSettingsSiteIdReportingRoute =
  AuthSettingsSiteIdReportingRouteImport.update({
    id: '/reporting',
    path: '/reporting',
    getParentRoute: () => AuthSettingsSiteIdRouteRoute,
  } as any)
const AuthSettingsSiteIdRecommendationExclusionsRoute =
  AuthSettingsSiteIdRecommendationExclusionsRouteImport.update({
    id: '/recommendation-exclusions',
    path: '/recommendation-exclusions',
    getParentRoute: () => AuthSettingsSiteIdRouteRoute,
  } as any)
const AuthSettingsSiteIdMockConfigRoute =
  AuthSettingsSiteIdMockConfigRouteImport.update({
    id: '/mock-config',
    path: '/mock-config',
    getParentRoute: () => AuthSettingsSiteIdRouteRoute,
  } as any)
const AuthSettingsSiteIdMachineApplicationsRoute =
  AuthSettingsSiteIdMachineApplicationsRouteImport.update({
    id: '/machine-applications',
    path: '/machine-applications',
    getParentRoute: () => AuthSettingsSiteIdRouteRoute,
  } as any)
const AuthSettingsSiteIdGeneralRoute =
  AuthSettingsSiteIdGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => AuthSettingsSiteIdRouteRoute,
  } as any)
const AuthSettingsSiteIdFeatureFlagsRoute =
  AuthSettingsSiteIdFeatureFlagsRouteImport.update({
    id: '/feature-flags',
    path: '/feature-flags',
    getParentRoute: () => AuthSettingsSiteIdRouteRoute,
  } as any)
const AuthSettingsSiteIdEmailRoute = AuthSettingsSiteIdEmailRouteImport.update({
  id: '/email',
  path: '/email',
  getParentRoute: () => AuthSettingsSiteIdRouteRoute,
} as any)
const AuthSettingsSiteIdBillingRoute =
  AuthSettingsSiteIdBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthSettingsSiteIdRouteRoute,
  } as any)
const AuthMarketingCalendarSiteIdNewRoute =
  AuthMarketingCalendarSiteIdNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthMarketingCalendarSiteIdRouteRoute,
  } as any)
const AuthExchangesSiteIdNewRoute = AuthExchangesSiteIdNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthExchangesSiteIdRouteRoute,
} as any)
const AuthDimensionsSiteIdPeopleRoute =
  AuthDimensionsSiteIdPeopleRouteImport.update({
    id: '/people',
    path: '/people',
    getParentRoute: () => AuthDimensionsSiteIdRouteRoute,
  } as any)
const AuthDimensionsSiteIdExchangesRoute =
  AuthDimensionsSiteIdExchangesRouteImport.update({
    id: '/exchanges',
    path: '/exchanges',
    getParentRoute: () => AuthDimensionsSiteIdRouteRoute,
  } as any)
const AuthBrandOnboardingSiteIdStepIdRoute =
  AuthBrandOnboardingSiteIdStepIdRouteImport.update({
    id: '/$stepId',
    path: '/$stepId',
    getParentRoute: () => AuthBrandOnboardingSiteIdRoute,
  } as any)
const AuthBestiesSiteIdRevenueRoute =
  AuthBestiesSiteIdRevenueRouteImport.update({
    id: '/revenue',
    path: '/revenue',
    getParentRoute: () => AuthBestiesSiteIdRouteRoute,
  } as any)
const AuthBestiesSiteIdReportingRoute =
  AuthBestiesSiteIdReportingRouteImport.update({
    id: '/reporting',
    path: '/reporting',
    getParentRoute: () => AuthBestiesSiteIdRouteRoute,
  } as any)
const AuthBestiesSiteIdOnboardingRoute =
  AuthBestiesSiteIdOnboardingRouteImport.update({
    id: '/onboarding',
    path: '/onboarding',
    getParentRoute: () => AuthBestiesSiteIdRouteRoute,
  } as any)
const AuthAssetsSiteIdAssetKeyRoute =
  AuthAssetsSiteIdAssetKeyRouteImport.update({
    id: '/$assetKey',
    path: '/$assetKey',
    getParentRoute: () => AuthAssetsSiteIdRouteRoute,
  } as any)
const AuthSkuStoreSiteIdSkuIdRouteRoute =
  AuthSkuStoreSiteIdSkuIdRouteRouteImport.update({
    id: '/$skuId',
    path: '/$skuId',
    getParentRoute: () => AuthSkuStoreSiteIdRouteRoute,
  } as any)
const AuthSettingsSiteIdCouponCodesRouteRoute =
  AuthSettingsSiteIdCouponCodesRouteRouteImport.update({
    id: '/coupon-codes',
    path: '/coupon-codes',
    getParentRoute: () => AuthSettingsSiteIdRouteRoute,
  } as any)
const AuthSettingsSiteIdConnectorsRouteRoute =
  AuthSettingsSiteIdConnectorsRouteRouteImport.update({
    id: '/connectors',
    path: '/connectors',
    getParentRoute: () => AuthSettingsSiteIdRouteRoute,
  } as any)
const AuthSettingsSiteIdZeroAdminRouteRoute =
  AuthSettingsSiteIdZeroAdminRouteRouteImport.update({
    id: '/_zeroAdmin',
    getParentRoute: () => AuthSettingsSiteIdRouteRoute,
  } as any)
const AuthPeopleSiteIdProfilesRouteRoute =
  AuthPeopleSiteIdProfilesRouteRouteImport.update({
    id: '/profiles',
    path: '/profiles',
    getParentRoute: () => AuthPeopleSiteIdRouteRoute,
  } as any)
const AuthPeopleSiteIdListsRouteRoute =
  AuthPeopleSiteIdListsRouteRouteImport.update({
    id: '/lists',
    path: '/lists',
    getParentRoute: () => AuthPeopleSiteIdRouteRoute,
  } as any)
const AuthPeopleSiteIdAudiencesRouteRoute =
  AuthPeopleSiteIdAudiencesRouteRouteImport.update({
    id: '/audiences',
    path: '/audiences',
    getParentRoute: () => AuthPeopleSiteIdRouteRoute,
  } as any)
const AuthDragonTilesSiteIdConnectorsRouteRoute =
  AuthDragonTilesSiteIdConnectorsRouteRouteImport.update({
    id: '/connectors',
    path: '/connectors',
    getParentRoute: () => AuthDragonTilesSiteIdRouteRoute,
  } as any)
const AuthDragonTilesSiteIdByocRouteRoute =
  AuthDragonTilesSiteIdByocRouteRouteImport.update({
    id: '/byoc',
    path: '/byoc',
    getParentRoute: () => AuthDragonTilesSiteIdRouteRoute,
  } as any)
const AuthDragonTilesSiteIdBroadcastV2RouteRoute =
  AuthDragonTilesSiteIdBroadcastV2RouteRouteImport.update({
    id: '/broadcastV2',
    path: '/broadcastV2',
    getParentRoute: () => AuthDragonTilesSiteIdRouteRoute,
  } as any)
const AuthDragonTilesSiteIdBroadcastRouteRoute =
  AuthDragonTilesSiteIdBroadcastRouteRouteImport.update({
    id: '/broadcast',
    path: '/broadcast',
    getParentRoute: () => AuthDragonTilesSiteIdRouteRoute,
  } as any)
const AuthDragonTilesSiteIdParentTileRouteRoute =
  AuthDragonTilesSiteIdParentTileRouteRouteImport.update({
    id: '/$parentTile',
    path: '/$parentTile',
    getParentRoute: () => AuthDragonTilesSiteIdRouteRoute,
  } as any)
const AuthSkuStoreSiteIdSkuIdIndexRoute =
  AuthSkuStoreSiteIdSkuIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthSkuStoreSiteIdSkuIdRouteRoute,
  } as any)
const AuthSettingsSiteIdConnectorsIndexRoute =
  AuthSettingsSiteIdConnectorsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthSettingsSiteIdConnectorsRouteRoute,
  } as any)
const AuthPeopleSiteIdProfilesIndexRoute =
  AuthPeopleSiteIdProfilesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthPeopleSiteIdProfilesRouteRoute,
  } as any)
const AuthPeopleSiteIdListsIndexRoute =
  AuthPeopleSiteIdListsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthPeopleSiteIdListsRouteRoute,
  } as any)
const AuthPeopleSiteIdAudiencesIndexRoute =
  AuthPeopleSiteIdAudiencesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthPeopleSiteIdAudiencesRouteRoute,
  } as any)
const AuthDragonTilesSiteIdConnectorsIndexRoute =
  AuthDragonTilesSiteIdConnectorsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthDragonTilesSiteIdConnectorsRouteRoute,
  } as any)
const AuthSkuStoreSiteIdSkuIdVariantsRoute =
  AuthSkuStoreSiteIdSkuIdVariantsRouteImport.update({
    id: '/variants',
    path: '/variants',
    getParentRoute: () => AuthSkuStoreSiteIdSkuIdRouteRoute,
  } as any)
const AuthSkuStoreSiteIdSkuIdReviewsRoute =
  AuthSkuStoreSiteIdSkuIdReviewsRouteImport.update({
    id: '/reviews',
    path: '/reviews',
    getParentRoute: () => AuthSkuStoreSiteIdSkuIdRouteRoute,
  } as any)
const AuthSkuStoreSiteIdSkuIdMediaRoute =
  AuthSkuStoreSiteIdSkuIdMediaRouteImport.update({
    id: '/media',
    path: '/media',
    getParentRoute: () => AuthSkuStoreSiteIdSkuIdRouteRoute,
  } as any)
const AuthSkuStoreSiteIdSkuIdMappingRoute =
  AuthSkuStoreSiteIdSkuIdMappingRouteImport.update({
    id: '/mapping',
    path: '/mapping',
    getParentRoute: () => AuthSkuStoreSiteIdSkuIdRouteRoute,
  } as any)
const AuthSkuStoreSiteIdSkuIdEngagementRoute =
  AuthSkuStoreSiteIdSkuIdEngagementRouteImport.update({
    id: '/engagement',
    path: '/engagement',
    getParentRoute: () => AuthSkuStoreSiteIdSkuIdRouteRoute,
  } as any)
const AuthSkuStoreSiteIdSkuIdCopyRoute =
  AuthSkuStoreSiteIdSkuIdCopyRouteImport.update({
    id: '/copy',
    path: '/copy',
    getParentRoute: () => AuthSkuStoreSiteIdSkuIdRouteRoute,
  } as any)
const AuthSkuStoreSiteIdSkuIdAssociationsRoute =
  AuthSkuStoreSiteIdSkuIdAssociationsRouteImport.update({
    id: '/associations',
    path: '/associations',
    getParentRoute: () => AuthSkuStoreSiteIdSkuIdRouteRoute,
  } as any)
const AuthSettingsSiteIdCouponCodesNewRoute =
  AuthSettingsSiteIdCouponCodesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthSettingsSiteIdCouponCodesRouteRoute,
  } as any)
const AuthSettingsSiteIdCouponCodesAddCodesRoute =
  AuthSettingsSiteIdCouponCodesAddCodesRouteImport.update({
    id: '/add-codes',
    path: '/add-codes',
    getParentRoute: () => AuthSettingsSiteIdCouponCodesRouteRoute,
  } as any)
const AuthSettingsSiteIdConnectorsInstalledRoute =
  AuthSettingsSiteIdConnectorsInstalledRouteImport.update({
    id: '/installed',
    path: '/installed',
    getParentRoute: () => AuthSettingsSiteIdConnectorsRouteRoute,
  } as any)
const AuthSettingsSiteIdConnectorsAllRoute =
  AuthSettingsSiteIdConnectorsAllRouteImport.update({
    id: '/all',
    path: '/all',
    getParentRoute: () => AuthSettingsSiteIdConnectorsRouteRoute,
  } as any)
const AuthSettingsSiteIdConnectorsConnectorIdRoute =
  AuthSettingsSiteIdConnectorsConnectorIdRouteImport.update({
    id: '/$connectorId',
    path: '/$connectorId',
    getParentRoute: () => AuthSettingsSiteIdConnectorsRouteRoute,
  } as any)
const AuthSettingsSiteIdZeroAdminCopyFramesRoute =
  AuthSettingsSiteIdZeroAdminCopyFramesRouteImport.update({
    id: '/copy-frames',
    path: '/copy-frames',
    getParentRoute: () => AuthSettingsSiteIdZeroAdminRouteRoute,
  } as any)
const AuthPeopleSiteIdListsListIdRoute =
  AuthPeopleSiteIdListsListIdRouteImport.update({
    id: '/$listId',
    path: '/$listId',
    getParentRoute: () => AuthPeopleSiteIdListsRouteRoute,
  } as any)
const AuthPeopleSiteIdAudiencesNewRoute =
  AuthPeopleSiteIdAudiencesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthPeopleSiteIdAudiencesRouteRoute,
  } as any)
const AuthPeopleSiteIdAudiencesExportsRoute =
  AuthPeopleSiteIdAudiencesExportsRouteImport.update({
    id: '/exports',
    path: '/exports',
    getParentRoute: () => AuthPeopleSiteIdAudiencesRouteRoute,
  } as any)
const AuthExchangesSiteIdIdEditRoute =
  AuthExchangesSiteIdIdEditRouteImport.update({
    id: '/$id/edit',
    path: '/$id/edit',
    getParentRoute: () => AuthExchangesSiteIdRouteRoute,
  } as any)
const AuthDragonTilesSiteIdNewVariantRoute =
  AuthDragonTilesSiteIdNewVariantRouteImport.update({
    id: '/new/$variant',
    path: '/new/$variant',
    getParentRoute: () => AuthDragonTilesSiteIdRouteRoute,
  } as any)
const AuthDragonTilesSiteIdConnectorsParentTileRoute =
  AuthDragonTilesSiteIdConnectorsParentTileRouteImport.update({
    id: '/$parentTile',
    path: '/$parentTile',
    getParentRoute: () => AuthDragonTilesSiteIdConnectorsRouteRoute,
  } as any)
const AuthDragonTilesSiteIdBroadcastListRoute =
  AuthDragonTilesSiteIdBroadcastListRouteImport.update({
    id: '/list',
    path: '/list',
    getParentRoute: () => AuthDragonTilesSiteIdBroadcastRouteRoute,
  } as any)
const AuthDragonTilesSiteIdFrameIdVariantRoute =
  AuthDragonTilesSiteIdFrameIdVariantRouteImport.update({
    id: '/$frameId/$variant',
    path: '/$frameId/$variant',
    getParentRoute: () => AuthDragonTilesSiteIdRouteRoute,
  } as any)
const AuthConnectorsSiteIdYotpoInstallRoute =
  AuthConnectorsSiteIdYotpoInstallRouteImport.update({
    id: '/connectors/$siteId/yotpo/install',
    path: '/connectors/$siteId/yotpo/install',
    getParentRoute: () => AuthRouteRoute,
  } as any)
const AuthBestiesSiteIdOnboardingBrandIdRoute =
  AuthBestiesSiteIdOnboardingBrandIdRouteImport.update({
    id: '/onboarding_/$brandId',
    path: '/onboarding/$brandId',
    getParentRoute: () => AuthBestiesSiteIdRouteRoute,
  } as any)
const AuthPeopleSiteIdProfilesProfileIdRouteRoute =
  AuthPeopleSiteIdProfilesProfileIdRouteRouteImport.update({
    id: '/$profileId',
    path: '/$profileId',
    getParentRoute: () => AuthPeopleSiteIdProfilesRouteRoute,
  } as any)
const AuthGenerationsSiteIdNewPilotRouteRoute =
  AuthGenerationsSiteIdNewPilotRouteRouteImport.update({
    id: '/new/pilot',
    path: '/new/pilot',
    getParentRoute: () => AuthGenerationsSiteIdRouteRoute,
  } as any)
const AuthGenerationsSiteIdNewCollectionRouteRoute =
  AuthGenerationsSiteIdNewCollectionRouteRouteImport.update({
    id: '/new/collection',
    path: '/new/collection',
    getParentRoute: () => AuthGenerationsSiteIdRouteRoute,
  } as any)
const AuthSkuStoreSiteIdSkuIdStoriesIndexRoute =
  AuthSkuStoreSiteIdSkuIdStoriesIndexRouteImport.update({
    id: '/stories/',
    path: '/stories/',
    getParentRoute: () => AuthSkuStoreSiteIdSkuIdRouteRoute,
  } as any)
const AuthSettingsSiteIdZeroAdminSitesIndexRoute =
  AuthSettingsSiteIdZeroAdminSitesIndexRouteImport.update({
    id: '/sites/',
    path: '/sites/',
    getParentRoute: () => AuthSettingsSiteIdZeroAdminRouteRoute,
  } as any)
const AuthSettingsSiteIdZeroAdminOnboardingIndexRoute =
  AuthSettingsSiteIdZeroAdminOnboardingIndexRouteImport.update({
    id: '/onboarding/',
    path: '/onboarding/',
    getParentRoute: () => AuthSettingsSiteIdZeroAdminRouteRoute,
  } as any)
const AuthSettingsSiteIdZeroAdminNotificationsIndexRoute =
  AuthSettingsSiteIdZeroAdminNotificationsIndexRouteImport.update({
    id: '/notifications/',
    path: '/notifications/',
    getParentRoute: () => AuthSettingsSiteIdZeroAdminRouteRoute,
  } as any)
const AuthSettingsSiteIdZeroAdminNotificationRejectsIndexRoute =
  AuthSettingsSiteIdZeroAdminNotificationRejectsIndexRouteImport.update({
    id: '/notification-rejects/',
    path: '/notification-rejects/',
    getParentRoute: () => AuthSettingsSiteIdZeroAdminRouteRoute,
  } as any)
const AuthSettingsSiteIdZeroAdminBlueprintsIndexRoute =
  AuthSettingsSiteIdZeroAdminBlueprintsIndexRouteImport.update({
    id: '/blueprints/',
    path: '/blueprints/',
    getParentRoute: () => AuthSettingsSiteIdZeroAdminRouteRoute,
  } as any)
const AuthSettingsSiteIdZeroAdminAccountsIndexRoute =
  AuthSettingsSiteIdZeroAdminAccountsIndexRouteImport.update({
    id: '/accounts/',
    path: '/accounts/',
    getParentRoute: () => AuthSettingsSiteIdZeroAdminRouteRoute,
  } as any)
const AuthPeopleSiteIdProfilesProfileIdIndexRoute =
  AuthPeopleSiteIdProfilesProfileIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthPeopleSiteIdProfilesProfileIdRouteRoute,
  } as any)
const AuthPeopleSiteIdListsListIdIndexRoute =
  AuthPeopleSiteIdListsListIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthPeopleSiteIdListsListIdRoute,
  } as any)
const AuthSkuStoreSiteIdSkuIdStoriesNewRoute =
  AuthSkuStoreSiteIdSkuIdStoriesNewRouteImport.update({
    id: '/stories/new',
    path: '/stories/new',
    getParentRoute: () => AuthSkuStoreSiteIdSkuIdRouteRoute,
  } as any)
const AuthSettingsSiteIdCouponCodesNewUniqueRoute =
  AuthSettingsSiteIdCouponCodesNewUniqueRouteImport.update({
    id: '/unique',
    path: '/unique',
    getParentRoute: () => AuthSettingsSiteIdCouponCodesNewRoute,
  } as any)
const AuthSettingsSiteIdCouponCodesNewStaticRoute =
  AuthSettingsSiteIdCouponCodesNewStaticRouteImport.update({
    id: '/static',
    path: '/static',
    getParentRoute: () => AuthSettingsSiteIdCouponCodesNewRoute,
  } as any)
const AuthSettingsSiteIdCouponCodesEditOfferSlugRoute =
  AuthSettingsSiteIdCouponCodesEditOfferSlugRouteImport.update({
    id: '/edit/$offerSlug',
    path: '/edit/$offerSlug',
    getParentRoute: () => AuthSettingsSiteIdCouponCodesRouteRoute,
  } as any)
const AuthSettingsSiteIdZeroAdminSitesRjIdRoute =
  AuthSettingsSiteIdZeroAdminSitesRjIdRouteImport.update({
    id: '/sites/$rjId',
    path: '/sites/$rjId',
    getParentRoute: () => AuthSettingsSiteIdZeroAdminRouteRoute,
  } as any)
const AuthSettingsSiteIdZeroAdminBlueprintsBlueprintIdRoute =
  AuthSettingsSiteIdZeroAdminBlueprintsBlueprintIdRouteImport.update({
    id: '/blueprints/$blueprintId',
    path: '/blueprints/$blueprintId',
    getParentRoute: () => AuthSettingsSiteIdZeroAdminRouteRoute,
  } as any)
const AuthSettingsSiteIdZeroAdminAccountsAccountIdRoute =
  AuthSettingsSiteIdZeroAdminAccountsAccountIdRouteImport.update({
    id: '/accounts/$accountId',
    path: '/accounts/$accountId',
    getParentRoute: () => AuthSettingsSiteIdZeroAdminRouteRoute,
  } as any)
const AuthPeopleSiteIdAudiencesAudienceIdEditRoute =
  AuthPeopleSiteIdAudiencesAudienceIdEditRouteImport.update({
    id: '/$audienceId/edit',
    path: '/$audienceId/edit',
    getParentRoute: () => AuthPeopleSiteIdAudiencesRouteRoute,
  } as any)
const AuthGenlabSiteIdPresetsEditPresetIdRoute =
  AuthGenlabSiteIdPresetsEditPresetIdRouteImport.update({
    id: '/presets/edit/$presetId',
    path: '/presets/edit/$presetId',
    getParentRoute: () => AuthGenlabSiteIdRouteRoute,
  } as any)
const AuthGenerationsSiteIdNewPilotStepIdRoute =
  AuthGenerationsSiteIdNewPilotStepIdRouteImport.update({
    id: '/$stepId',
    path: '/$stepId',
    getParentRoute: () => AuthGenerationsSiteIdNewPilotRouteRoute,
  } as any)
const AuthGenerationsSiteIdNewCollectionStepIdRoute =
  AuthGenerationsSiteIdNewCollectionStepIdRouteImport.update({
    id: '/$stepId',
    path: '/$stepId',
    getParentRoute: () => AuthGenerationsSiteIdNewCollectionRouteRoute,
  } as any)
const AuthDragonTilesSiteIdByocTileFrameIdRoute =
  AuthDragonTilesSiteIdByocTileFrameIdRouteImport.update({
    id: '/tile/$frameId',
    path: '/tile/$frameId',
    getParentRoute: () => AuthDragonTilesSiteIdByocRouteRoute,
  } as any)
const AuthDragonTilesSiteIdBroadcastV2NewSmsRoute =
  AuthDragonTilesSiteIdBroadcastV2NewSmsRouteImport.update({
    id: '/new/sms',
    path: '/new/sms',
    getParentRoute: () => AuthDragonTilesSiteIdBroadcastV2RouteRoute,
  } as any)
const AuthDragonTilesSiteIdBroadcastV2NewEmailRoute =
  AuthDragonTilesSiteIdBroadcastV2NewEmailRouteImport.update({
    id: '/new/email',
    path: '/new/email',
    getParentRoute: () => AuthDragonTilesSiteIdBroadcastV2RouteRoute,
  } as any)
const AuthDragonTilesSiteIdBroadcastV2BroadcastIdSmsRoute =
  AuthDragonTilesSiteIdBroadcastV2BroadcastIdSmsRouteImport.update({
    id: '/$broadcastId/sms',
    path: '/$broadcastId/sms',
    getParentRoute: () => AuthDragonTilesSiteIdBroadcastV2RouteRoute,
  } as any)
const AuthDragonTilesSiteIdBroadcastV2BroadcastIdEmailRoute =
  AuthDragonTilesSiteIdBroadcastV2BroadcastIdEmailRouteImport.update({
    id: '/$broadcastId/email',
    path: '/$broadcastId/email',
    getParentRoute: () => AuthDragonTilesSiteIdBroadcastV2RouteRoute,
  } as any)
const AuthDragonTilesSiteIdParentTileTileFrameIdRoute =
  AuthDragonTilesSiteIdParentTileTileFrameIdRouteImport.update({
    id: '/tile/$frameId',
    path: '/tile/$frameId',
    getParentRoute: () => AuthDragonTilesSiteIdParentTileRouteRoute,
  } as any)
const AuthPeopleSiteIdAudiencesAudienceIdMembersIndexRoute =
  AuthPeopleSiteIdAudiencesAudienceIdMembersIndexRouteImport.update({
    id: '/$audienceId/members/',
    path: '/$audienceId/members/',
    getParentRoute: () => AuthPeopleSiteIdAudiencesRouteRoute,
  } as any)
const AuthSkuStoreSiteIdSkuIdStoriesEditStoryIdRoute =
  AuthSkuStoreSiteIdSkuIdStoriesEditStoryIdRouteImport.update({
    id: '/stories/edit/$storyId',
    path: '/stories/edit/$storyId',
    getParentRoute: () => AuthSkuStoreSiteIdSkuIdRouteRoute,
  } as any)
const AuthSettingsSiteIdCouponCodesNewUniqueShopifyRoute =
  AuthSettingsSiteIdCouponCodesNewUniqueShopifyRouteImport.update({
    id: '/shopify',
    path: '/shopify',
    getParentRoute: () => AuthSettingsSiteIdCouponCodesNewUniqueRoute,
  } as any)
const AuthSettingsSiteIdCouponCodesNewUniqueFoxyRoute =
  AuthSettingsSiteIdCouponCodesNewUniqueFoxyRouteImport.update({
    id: '/foxy',
    path: '/foxy',
    getParentRoute: () => AuthSettingsSiteIdCouponCodesNewUniqueRoute,
  } as any)
const AuthSettingsSiteIdCouponCodesNewUniqueCsvRoute =
  AuthSettingsSiteIdCouponCodesNewUniqueCsvRouteImport.update({
    id: '/csv',
    path: '/csv',
    getParentRoute: () => AuthSettingsSiteIdCouponCodesNewUniqueRoute,
  } as any)
const AuthGenlabSiteIdPresetsSceneEditPresetIdRoute =
  AuthGenlabSiteIdPresetsSceneEditPresetIdRouteImport.update({
    id: '/presets/scene/edit/$presetId',
    path: '/presets/scene/edit/$presetId',
    getParentRoute: () => AuthGenlabSiteIdRouteRoute,
  } as any)
const AuthGenlabSiteIdPresetsCompositionEditPresetIdRoute =
  AuthGenlabSiteIdPresetsCompositionEditPresetIdRouteImport.update({
    id: '/presets/composition/edit/$presetId',
    path: '/presets/composition/edit/$presetId',
    getParentRoute: () => AuthGenlabSiteIdRouteRoute,
  } as any)
const AuthGenlabSiteIdPresetsCastingEditPresetIdRoute =
  AuthGenlabSiteIdPresetsCastingEditPresetIdRouteImport.update({
    id: '/presets/casting/edit/$presetId',
    path: '/presets/casting/edit/$presetId',
    getParentRoute: () => AuthGenlabSiteIdRouteRoute,
  } as any)
const AuthDragonTilesSiteIdConnectorsParentTileTileFrameIdRoute =
  AuthDragonTilesSiteIdConnectorsParentTileTileFrameIdRouteImport.update({
    id: '/tile/$frameId',
    path: '/tile/$frameId',
    getParentRoute: () => AuthDragonTilesSiteIdConnectorsParentTileRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/demo': typeof DemoRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/preview-test': typeof AuthPreviewTestRoute
  '/blastro/connect': typeof BlastroConnectRoute
  '/assets/$siteId': typeof AuthAssetsSiteIdRouteRouteWithChildren
  '/besties/$siteId': typeof AuthBestiesSiteIdRouteRouteWithChildren
  '/blocks/$siteId': typeof AuthBlocksSiteIdRouteRoute
  '/creative-sphere/$siteId': typeof AuthCreativeSphereSiteIdRouteRouteWithChildren
  '/dimensions/$siteId': typeof AuthDimensionsSiteIdRouteRouteWithChildren
  '/dragon-tiles/$siteId': typeof AuthDragonTilesSiteIdRouteRouteWithChildren
  '/exchanges/$siteId': typeof AuthExchangesSiteIdRouteRouteWithChildren
  '/generations/$siteId': typeof AuthGenerationsSiteIdRouteRouteWithChildren
  '/genlab/$siteId': typeof AuthGenlabSiteIdRouteRouteWithChildren
  '/marketing-calendar/$siteId': typeof AuthMarketingCalendarSiteIdRouteRouteWithChildren
  '/people/$siteId': typeof AuthPeopleSiteIdRouteRouteWithChildren
  '/settings/$siteId': typeof AuthSettingsSiteIdZeroAdminRouteRouteWithChildren
  '/sku-store/$siteId': typeof AuthSkuStoreSiteIdRouteRouteWithChildren
  '/apple-messages/connect': typeof AuthAppleMessagesConnectRoute
  '/brand-onboarding/$siteId': typeof AuthBrandOnboardingSiteIdRouteWithChildren
  '/compose-text/$siteId': typeof AuthComposeTextSiteIdRoute
  '/docs/$siteId': typeof AuthDocsSiteIdRoute
  '/settings/notification-rejects': typeof AuthSettingsNotificationRejectsRoute
  '/settings/notifications': typeof AuthSettingsNotificationsRoute
  '/blastro/$siteId/connect': typeof BlastroSiteIdConnectRoute
  '/docs/': typeof AuthDocsIndexRoute
  '/dragon-tiles/$siteId/$parentTile': typeof AuthDragonTilesSiteIdParentTileRouteRouteWithChildren
  '/dragon-tiles/$siteId/broadcast': typeof AuthDragonTilesSiteIdBroadcastRouteRouteWithChildren
  '/dragon-tiles/$siteId/broadcastV2': typeof AuthDragonTilesSiteIdBroadcastV2RouteRouteWithChildren
  '/dragon-tiles/$siteId/byoc': typeof AuthDragonTilesSiteIdByocRouteRouteWithChildren
  '/dragon-tiles/$siteId/connectors': typeof AuthDragonTilesSiteIdConnectorsRouteRouteWithChildren
  '/people/$siteId/audiences': typeof AuthPeopleSiteIdAudiencesRouteRouteWithChildren
  '/people/$siteId/lists': typeof AuthPeopleSiteIdListsRouteRouteWithChildren
  '/people/$siteId/profiles': typeof AuthPeopleSiteIdProfilesRouteRouteWithChildren
  '/settings/$siteId/connectors': typeof AuthSettingsSiteIdConnectorsRouteRouteWithChildren
  '/settings/$siteId/coupon-codes': typeof AuthSettingsSiteIdCouponCodesRouteRouteWithChildren
  '/sku-store/$siteId/$skuId': typeof AuthSkuStoreSiteIdSkuIdRouteRouteWithChildren
  '/assets/$siteId/$assetKey': typeof AuthAssetsSiteIdAssetKeyRoute
  '/besties/$siteId/onboarding': typeof AuthBestiesSiteIdOnboardingRoute
  '/besties/$siteId/reporting': typeof AuthBestiesSiteIdReportingRoute
  '/besties/$siteId/revenue': typeof AuthBestiesSiteIdRevenueRoute
  '/brand-onboarding/$siteId/$stepId': typeof AuthBrandOnboardingSiteIdStepIdRoute
  '/dimensions/$siteId/exchanges': typeof AuthDimensionsSiteIdExchangesRoute
  '/dimensions/$siteId/people': typeof AuthDimensionsSiteIdPeopleRoute
  '/exchanges/$siteId/new': typeof AuthExchangesSiteIdNewRoute
  '/marketing-calendar/$siteId/new': typeof AuthMarketingCalendarSiteIdNewRoute
  '/settings/$siteId/billing': typeof AuthSettingsSiteIdBillingRoute
  '/settings/$siteId/email': typeof AuthSettingsSiteIdEmailRoute
  '/settings/$siteId/feature-flags': typeof AuthSettingsSiteIdFeatureFlagsRoute
  '/settings/$siteId/general': typeof AuthSettingsSiteIdGeneralRoute
  '/settings/$siteId/machine-applications': typeof AuthSettingsSiteIdMachineApplicationsRoute
  '/settings/$siteId/mock-config': typeof AuthSettingsSiteIdMockConfigRoute
  '/settings/$siteId/recommendation-exclusions': typeof AuthSettingsSiteIdRecommendationExclusionsRoute
  '/settings/$siteId/reporting': typeof AuthSettingsSiteIdReportingRoute
  '/settings/$siteId/seed-besties-sites': typeof AuthSettingsSiteIdSeedBestiesSitesRoute
  '/settings/$siteId/sms-registration': typeof AuthSettingsSiteIdSmsRegistrationRoute
  '/settings/$siteId/text': typeof AuthSettingsSiteIdTextRoute
  '/sku-store/$siteId/mapping': typeof AuthSkuStoreSiteIdMappingRoute
  '/besties/$siteId/': typeof AuthBestiesSiteIdIndexRoute
  '/creative-sphere/$siteId/': typeof AuthCreativeSphereSiteIdIndexRoute
  '/dimensions/$siteId/': typeof AuthDimensionsSiteIdIndexRoute
  '/dragon-tiles/$siteId/': typeof AuthDragonTilesSiteIdIndexRoute
  '/generations/$siteId/': typeof AuthGenerationsSiteIdIndexRoute
  '/genlab/$siteId/': typeof AuthGenlabSiteIdIndexRoute
  '/marketing-calendar/$siteId/': typeof AuthMarketingCalendarSiteIdIndexRoute
  '/settings/$siteId/': typeof AuthSettingsSiteIdIndexRoute
  '/sku-store/$siteId/': typeof AuthSkuStoreSiteIdIndexRoute
  '/generations/$siteId/new/collection': typeof AuthGenerationsSiteIdNewCollectionRouteRouteWithChildren
  '/generations/$siteId/new/pilot': typeof AuthGenerationsSiteIdNewPilotRouteRouteWithChildren
  '/people/$siteId/profiles/$profileId': typeof AuthPeopleSiteIdProfilesProfileIdRouteRouteWithChildren
  '/besties/$siteId/onboarding/$brandId': typeof AuthBestiesSiteIdOnboardingBrandIdRoute
  '/connectors/$siteId/yotpo/install': typeof AuthConnectorsSiteIdYotpoInstallRoute
  '/dragon-tiles/$siteId/$frameId/$variant': typeof AuthDragonTilesSiteIdFrameIdVariantRoute
  '/dragon-tiles/$siteId/broadcast/list': typeof AuthDragonTilesSiteIdBroadcastListRoute
  '/dragon-tiles/$siteId/connectors/$parentTile': typeof AuthDragonTilesSiteIdConnectorsParentTileRouteWithChildren
  '/dragon-tiles/$siteId/new/$variant': typeof AuthDragonTilesSiteIdNewVariantRoute
  '/exchanges/$siteId/$id/edit': typeof AuthExchangesSiteIdIdEditRoute
  '/people/$siteId/audiences/exports': typeof AuthPeopleSiteIdAudiencesExportsRoute
  '/people/$siteId/audiences/new': typeof AuthPeopleSiteIdAudiencesNewRoute
  '/people/$siteId/lists/$listId': typeof AuthPeopleSiteIdListsListIdRouteWithChildren
  '/settings/$siteId/copy-frames': typeof AuthSettingsSiteIdZeroAdminCopyFramesRoute
  '/settings/$siteId/connectors/$connectorId': typeof AuthSettingsSiteIdConnectorsConnectorIdRoute
  '/settings/$siteId/connectors/all': typeof AuthSettingsSiteIdConnectorsAllRoute
  '/settings/$siteId/connectors/installed': typeof AuthSettingsSiteIdConnectorsInstalledRoute
  '/settings/$siteId/coupon-codes/add-codes': typeof AuthSettingsSiteIdCouponCodesAddCodesRoute
  '/settings/$siteId/coupon-codes/new': typeof AuthSettingsSiteIdCouponCodesNewRouteWithChildren
  '/sku-store/$siteId/$skuId/associations': typeof AuthSkuStoreSiteIdSkuIdAssociationsRoute
  '/sku-store/$siteId/$skuId/copy': typeof AuthSkuStoreSiteIdSkuIdCopyRoute
  '/sku-store/$siteId/$skuId/engagement': typeof AuthSkuStoreSiteIdSkuIdEngagementRoute
  '/sku-store/$siteId/$skuId/mapping': typeof AuthSkuStoreSiteIdSkuIdMappingRoute
  '/sku-store/$siteId/$skuId/media': typeof AuthSkuStoreSiteIdSkuIdMediaRoute
  '/sku-store/$siteId/$skuId/reviews': typeof AuthSkuStoreSiteIdSkuIdReviewsRoute
  '/sku-store/$siteId/$skuId/variants': typeof AuthSkuStoreSiteIdSkuIdVariantsRoute
  '/dragon-tiles/$siteId/connectors/': typeof AuthDragonTilesSiteIdConnectorsIndexRoute
  '/people/$siteId/audiences/': typeof AuthPeopleSiteIdAudiencesIndexRoute
  '/people/$siteId/lists/': typeof AuthPeopleSiteIdListsIndexRoute
  '/people/$siteId/profiles/': typeof AuthPeopleSiteIdProfilesIndexRoute
  '/settings/$siteId/connectors/': typeof AuthSettingsSiteIdConnectorsIndexRoute
  '/sku-store/$siteId/$skuId/': typeof AuthSkuStoreSiteIdSkuIdIndexRoute
  '/dragon-tiles/$siteId/$parentTile/tile/$frameId': typeof AuthDragonTilesSiteIdParentTileTileFrameIdRoute
  '/dragon-tiles/$siteId/broadcastV2/$broadcastId/email': typeof AuthDragonTilesSiteIdBroadcastV2BroadcastIdEmailRoute
  '/dragon-tiles/$siteId/broadcastV2/$broadcastId/sms': typeof AuthDragonTilesSiteIdBroadcastV2BroadcastIdSmsRoute
  '/dragon-tiles/$siteId/broadcastV2/new/email': typeof AuthDragonTilesSiteIdBroadcastV2NewEmailRoute
  '/dragon-tiles/$siteId/broadcastV2/new/sms': typeof AuthDragonTilesSiteIdBroadcastV2NewSmsRoute
  '/dragon-tiles/$siteId/byoc/tile/$frameId': typeof AuthDragonTilesSiteIdByocTileFrameIdRoute
  '/generations/$siteId/new/collection/$stepId': typeof AuthGenerationsSiteIdNewCollectionStepIdRoute
  '/generations/$siteId/new/pilot/$stepId': typeof AuthGenerationsSiteIdNewPilotStepIdRoute
  '/genlab/$siteId/presets/edit/$presetId': typeof AuthGenlabSiteIdPresetsEditPresetIdRoute
  '/people/$siteId/audiences/$audienceId/edit': typeof AuthPeopleSiteIdAudiencesAudienceIdEditRoute
  '/settings/$siteId/accounts/$accountId': typeof AuthSettingsSiteIdZeroAdminAccountsAccountIdRoute
  '/settings/$siteId/blueprints/$blueprintId': typeof AuthSettingsSiteIdZeroAdminBlueprintsBlueprintIdRoute
  '/settings/$siteId/sites/$rjId': typeof AuthSettingsSiteIdZeroAdminSitesRjIdRoute
  '/settings/$siteId/coupon-codes/edit/$offerSlug': typeof AuthSettingsSiteIdCouponCodesEditOfferSlugRoute
  '/settings/$siteId/coupon-codes/new/static': typeof AuthSettingsSiteIdCouponCodesNewStaticRoute
  '/settings/$siteId/coupon-codes/new/unique': typeof AuthSettingsSiteIdCouponCodesNewUniqueRouteWithChildren
  '/sku-store/$siteId/$skuId/stories/new': typeof AuthSkuStoreSiteIdSkuIdStoriesNewRoute
  '/people/$siteId/lists/$listId/': typeof AuthPeopleSiteIdListsListIdIndexRoute
  '/people/$siteId/profiles/$profileId/': typeof AuthPeopleSiteIdProfilesProfileIdIndexRoute
  '/settings/$siteId/accounts/': typeof AuthSettingsSiteIdZeroAdminAccountsIndexRoute
  '/settings/$siteId/blueprints/': typeof AuthSettingsSiteIdZeroAdminBlueprintsIndexRoute
  '/settings/$siteId/notification-rejects/': typeof AuthSettingsSiteIdZeroAdminNotificationRejectsIndexRoute
  '/settings/$siteId/notifications/': typeof AuthSettingsSiteIdZeroAdminNotificationsIndexRoute
  '/settings/$siteId/onboarding/': typeof AuthSettingsSiteIdZeroAdminOnboardingIndexRoute
  '/settings/$siteId/sites/': typeof AuthSettingsSiteIdZeroAdminSitesIndexRoute
  '/sku-store/$siteId/$skuId/stories/': typeof AuthSkuStoreSiteIdSkuIdStoriesIndexRoute
  '/dragon-tiles/$siteId/connectors/$parentTile/tile/$frameId': typeof AuthDragonTilesSiteIdConnectorsParentTileTileFrameIdRoute
  '/genlab/$siteId/presets/casting/edit/$presetId': typeof AuthGenlabSiteIdPresetsCastingEditPresetIdRoute
  '/genlab/$siteId/presets/composition/edit/$presetId': typeof AuthGenlabSiteIdPresetsCompositionEditPresetIdRoute
  '/genlab/$siteId/presets/scene/edit/$presetId': typeof AuthGenlabSiteIdPresetsSceneEditPresetIdRoute
  '/settings/$siteId/coupon-codes/new/unique/csv': typeof AuthSettingsSiteIdCouponCodesNewUniqueCsvRoute
  '/settings/$siteId/coupon-codes/new/unique/foxy': typeof AuthSettingsSiteIdCouponCodesNewUniqueFoxyRoute
  '/settings/$siteId/coupon-codes/new/unique/shopify': typeof AuthSettingsSiteIdCouponCodesNewUniqueShopifyRoute
  '/sku-store/$siteId/$skuId/stories/edit/$storyId': typeof AuthSkuStoreSiteIdSkuIdStoriesEditStoryIdRoute
  '/people/$siteId/audiences/$audienceId/members/': typeof AuthPeopleSiteIdAudiencesAudienceIdMembersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/demo': typeof DemoRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/preview-test': typeof AuthPreviewTestRoute
  '/blastro/connect': typeof BlastroConnectRoute
  '/assets/$siteId': typeof AuthAssetsSiteIdRouteRouteWithChildren
  '/blocks/$siteId': typeof AuthBlocksSiteIdRouteRoute
  '/exchanges/$siteId': typeof AuthExchangesSiteIdRouteRouteWithChildren
  '/people/$siteId': typeof AuthPeopleSiteIdRouteRouteWithChildren
  '/apple-messages/connect': typeof AuthAppleMessagesConnectRoute
  '/brand-onboarding/$siteId': typeof AuthBrandOnboardingSiteIdRouteWithChildren
  '/compose-text/$siteId': typeof AuthComposeTextSiteIdRoute
  '/docs/$siteId': typeof AuthDocsSiteIdRoute
  '/settings/notification-rejects': typeof AuthSettingsNotificationRejectsRoute
  '/settings/notifications': typeof AuthSettingsNotificationsRoute
  '/blastro/$siteId/connect': typeof BlastroSiteIdConnectRoute
  '/docs': typeof AuthDocsIndexRoute
  '/dragon-tiles/$siteId/$parentTile': typeof AuthDragonTilesSiteIdParentTileRouteRouteWithChildren
  '/dragon-tiles/$siteId/broadcast': typeof AuthDragonTilesSiteIdBroadcastRouteRouteWithChildren
  '/dragon-tiles/$siteId/broadcastV2': typeof AuthDragonTilesSiteIdBroadcastV2RouteRouteWithChildren
  '/dragon-tiles/$siteId/byoc': typeof AuthDragonTilesSiteIdByocRouteRouteWithChildren
  '/settings/$siteId': typeof AuthSettingsSiteIdIndexRoute
  '/settings/$siteId/coupon-codes': typeof AuthSettingsSiteIdCouponCodesRouteRouteWithChildren
  '/assets/$siteId/$assetKey': typeof AuthAssetsSiteIdAssetKeyRoute
  '/besties/$siteId/onboarding': typeof AuthBestiesSiteIdOnboardingRoute
  '/besties/$siteId/reporting': typeof AuthBestiesSiteIdReportingRoute
  '/besties/$siteId/revenue': typeof AuthBestiesSiteIdRevenueRoute
  '/brand-onboarding/$siteId/$stepId': typeof AuthBrandOnboardingSiteIdStepIdRoute
  '/dimensions/$siteId/exchanges': typeof AuthDimensionsSiteIdExchangesRoute
  '/dimensions/$siteId/people': typeof AuthDimensionsSiteIdPeopleRoute
  '/exchanges/$siteId/new': typeof AuthExchangesSiteIdNewRoute
  '/marketing-calendar/$siteId/new': typeof AuthMarketingCalendarSiteIdNewRoute
  '/settings/$siteId/billing': typeof AuthSettingsSiteIdBillingRoute
  '/settings/$siteId/email': typeof AuthSettingsSiteIdEmailRoute
  '/settings/$siteId/feature-flags': typeof AuthSettingsSiteIdFeatureFlagsRoute
  '/settings/$siteId/general': typeof AuthSettingsSiteIdGeneralRoute
  '/settings/$siteId/machine-applications': typeof AuthSettingsSiteIdMachineApplicationsRoute
  '/settings/$siteId/mock-config': typeof AuthSettingsSiteIdMockConfigRoute
  '/settings/$siteId/recommendation-exclusions': typeof AuthSettingsSiteIdRecommendationExclusionsRoute
  '/settings/$siteId/reporting': typeof AuthSettingsSiteIdReportingRoute
  '/settings/$siteId/seed-besties-sites': typeof AuthSettingsSiteIdSeedBestiesSitesRoute
  '/settings/$siteId/sms-registration': typeof AuthSettingsSiteIdSmsRegistrationRoute
  '/settings/$siteId/text': typeof AuthSettingsSiteIdTextRoute
  '/sku-store/$siteId/mapping': typeof AuthSkuStoreSiteIdMappingRoute
  '/besties/$siteId': typeof AuthBestiesSiteIdIndexRoute
  '/creative-sphere/$siteId': typeof AuthCreativeSphereSiteIdIndexRoute
  '/dimensions/$siteId': typeof AuthDimensionsSiteIdIndexRoute
  '/dragon-tiles/$siteId': typeof AuthDragonTilesSiteIdIndexRoute
  '/generations/$siteId': typeof AuthGenerationsSiteIdIndexRoute
  '/genlab/$siteId': typeof AuthGenlabSiteIdIndexRoute
  '/marketing-calendar/$siteId': typeof AuthMarketingCalendarSiteIdIndexRoute
  '/sku-store/$siteId': typeof AuthSkuStoreSiteIdIndexRoute
  '/generations/$siteId/new/collection': typeof AuthGenerationsSiteIdNewCollectionRouteRouteWithChildren
  '/generations/$siteId/new/pilot': typeof AuthGenerationsSiteIdNewPilotRouteRouteWithChildren
  '/besties/$siteId/onboarding/$brandId': typeof AuthBestiesSiteIdOnboardingBrandIdRoute
  '/connectors/$siteId/yotpo/install': typeof AuthConnectorsSiteIdYotpoInstallRoute
  '/dragon-tiles/$siteId/$frameId/$variant': typeof AuthDragonTilesSiteIdFrameIdVariantRoute
  '/dragon-tiles/$siteId/broadcast/list': typeof AuthDragonTilesSiteIdBroadcastListRoute
  '/dragon-tiles/$siteId/connectors/$parentTile': typeof AuthDragonTilesSiteIdConnectorsParentTileRouteWithChildren
  '/dragon-tiles/$siteId/new/$variant': typeof AuthDragonTilesSiteIdNewVariantRoute
  '/exchanges/$siteId/$id/edit': typeof AuthExchangesSiteIdIdEditRoute
  '/people/$siteId/audiences/exports': typeof AuthPeopleSiteIdAudiencesExportsRoute
  '/people/$siteId/audiences/new': typeof AuthPeopleSiteIdAudiencesNewRoute
  '/settings/$siteId/copy-frames': typeof AuthSettingsSiteIdZeroAdminCopyFramesRoute
  '/settings/$siteId/connectors/$connectorId': typeof AuthSettingsSiteIdConnectorsConnectorIdRoute
  '/settings/$siteId/connectors/all': typeof AuthSettingsSiteIdConnectorsAllRoute
  '/settings/$siteId/connectors/installed': typeof AuthSettingsSiteIdConnectorsInstalledRoute
  '/settings/$siteId/coupon-codes/add-codes': typeof AuthSettingsSiteIdCouponCodesAddCodesRoute
  '/settings/$siteId/coupon-codes/new': typeof AuthSettingsSiteIdCouponCodesNewRouteWithChildren
  '/sku-store/$siteId/$skuId/associations': typeof AuthSkuStoreSiteIdSkuIdAssociationsRoute
  '/sku-store/$siteId/$skuId/copy': typeof AuthSkuStoreSiteIdSkuIdCopyRoute
  '/sku-store/$siteId/$skuId/engagement': typeof AuthSkuStoreSiteIdSkuIdEngagementRoute
  '/sku-store/$siteId/$skuId/mapping': typeof AuthSkuStoreSiteIdSkuIdMappingRoute
  '/sku-store/$siteId/$skuId/media': typeof AuthSkuStoreSiteIdSkuIdMediaRoute
  '/sku-store/$siteId/$skuId/reviews': typeof AuthSkuStoreSiteIdSkuIdReviewsRoute
  '/sku-store/$siteId/$skuId/variants': typeof AuthSkuStoreSiteIdSkuIdVariantsRoute
  '/dragon-tiles/$siteId/connectors': typeof AuthDragonTilesSiteIdConnectorsIndexRoute
  '/people/$siteId/audiences': typeof AuthPeopleSiteIdAudiencesIndexRoute
  '/people/$siteId/lists': typeof AuthPeopleSiteIdListsIndexRoute
  '/people/$siteId/profiles': typeof AuthPeopleSiteIdProfilesIndexRoute
  '/settings/$siteId/connectors': typeof AuthSettingsSiteIdConnectorsIndexRoute
  '/sku-store/$siteId/$skuId': typeof AuthSkuStoreSiteIdSkuIdIndexRoute
  '/dragon-tiles/$siteId/$parentTile/tile/$frameId': typeof AuthDragonTilesSiteIdParentTileTileFrameIdRoute
  '/dragon-tiles/$siteId/broadcastV2/$broadcastId/email': typeof AuthDragonTilesSiteIdBroadcastV2BroadcastIdEmailRoute
  '/dragon-tiles/$siteId/broadcastV2/$broadcastId/sms': typeof AuthDragonTilesSiteIdBroadcastV2BroadcastIdSmsRoute
  '/dragon-tiles/$siteId/broadcastV2/new/email': typeof AuthDragonTilesSiteIdBroadcastV2NewEmailRoute
  '/dragon-tiles/$siteId/broadcastV2/new/sms': typeof AuthDragonTilesSiteIdBroadcastV2NewSmsRoute
  '/dragon-tiles/$siteId/byoc/tile/$frameId': typeof AuthDragonTilesSiteIdByocTileFrameIdRoute
  '/generations/$siteId/new/collection/$stepId': typeof AuthGenerationsSiteIdNewCollectionStepIdRoute
  '/generations/$siteId/new/pilot/$stepId': typeof AuthGenerationsSiteIdNewPilotStepIdRoute
  '/genlab/$siteId/presets/edit/$presetId': typeof AuthGenlabSiteIdPresetsEditPresetIdRoute
  '/people/$siteId/audiences/$audienceId/edit': typeof AuthPeopleSiteIdAudiencesAudienceIdEditRoute
  '/settings/$siteId/accounts/$accountId': typeof AuthSettingsSiteIdZeroAdminAccountsAccountIdRoute
  '/settings/$siteId/blueprints/$blueprintId': typeof AuthSettingsSiteIdZeroAdminBlueprintsBlueprintIdRoute
  '/settings/$siteId/sites/$rjId': typeof AuthSettingsSiteIdZeroAdminSitesRjIdRoute
  '/settings/$siteId/coupon-codes/edit/$offerSlug': typeof AuthSettingsSiteIdCouponCodesEditOfferSlugRoute
  '/settings/$siteId/coupon-codes/new/static': typeof AuthSettingsSiteIdCouponCodesNewStaticRoute
  '/settings/$siteId/coupon-codes/new/unique': typeof AuthSettingsSiteIdCouponCodesNewUniqueRouteWithChildren
  '/sku-store/$siteId/$skuId/stories/new': typeof AuthSkuStoreSiteIdSkuIdStoriesNewRoute
  '/people/$siteId/lists/$listId': typeof AuthPeopleSiteIdListsListIdIndexRoute
  '/people/$siteId/profiles/$profileId': typeof AuthPeopleSiteIdProfilesProfileIdIndexRoute
  '/settings/$siteId/accounts': typeof AuthSettingsSiteIdZeroAdminAccountsIndexRoute
  '/settings/$siteId/blueprints': typeof AuthSettingsSiteIdZeroAdminBlueprintsIndexRoute
  '/settings/$siteId/notification-rejects': typeof AuthSettingsSiteIdZeroAdminNotificationRejectsIndexRoute
  '/settings/$siteId/notifications': typeof AuthSettingsSiteIdZeroAdminNotificationsIndexRoute
  '/settings/$siteId/onboarding': typeof AuthSettingsSiteIdZeroAdminOnboardingIndexRoute
  '/settings/$siteId/sites': typeof AuthSettingsSiteIdZeroAdminSitesIndexRoute
  '/sku-store/$siteId/$skuId/stories': typeof AuthSkuStoreSiteIdSkuIdStoriesIndexRoute
  '/dragon-tiles/$siteId/connectors/$parentTile/tile/$frameId': typeof AuthDragonTilesSiteIdConnectorsParentTileTileFrameIdRoute
  '/genlab/$siteId/presets/casting/edit/$presetId': typeof AuthGenlabSiteIdPresetsCastingEditPresetIdRoute
  '/genlab/$siteId/presets/composition/edit/$presetId': typeof AuthGenlabSiteIdPresetsCompositionEditPresetIdRoute
  '/genlab/$siteId/presets/scene/edit/$presetId': typeof AuthGenlabSiteIdPresetsSceneEditPresetIdRoute
  '/settings/$siteId/coupon-codes/new/unique/csv': typeof AuthSettingsSiteIdCouponCodesNewUniqueCsvRoute
  '/settings/$siteId/coupon-codes/new/unique/foxy': typeof AuthSettingsSiteIdCouponCodesNewUniqueFoxyRoute
  '/settings/$siteId/coupon-codes/new/unique/shopify': typeof AuthSettingsSiteIdCouponCodesNewUniqueShopifyRoute
  '/sku-store/$siteId/$skuId/stories/edit/$storyId': typeof AuthSkuStoreSiteIdSkuIdStoriesEditStoryIdRoute
  '/people/$siteId/audiences/$audienceId/members': typeof AuthPeopleSiteIdAudiencesAudienceIdMembersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteRouteWithChildren
  '/demo': typeof DemoRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_auth/preview-test': typeof AuthPreviewTestRoute
  '/blastro/connect': typeof BlastroConnectRoute
  '/_auth/assets/$siteId': typeof AuthAssetsSiteIdRouteRouteWithChildren
  '/_auth/besties/$siteId': typeof AuthBestiesSiteIdRouteRouteWithChildren
  '/_auth/blocks/$siteId': typeof AuthBlocksSiteIdRouteRoute
  '/_auth/creative-sphere/$siteId': typeof AuthCreativeSphereSiteIdRouteRouteWithChildren
  '/_auth/dimensions/$siteId': typeof AuthDimensionsSiteIdRouteRouteWithChildren
  '/_auth/dragon-tiles/$siteId': typeof AuthDragonTilesSiteIdRouteRouteWithChildren
  '/_auth/exchanges/$siteId': typeof AuthExchangesSiteIdRouteRouteWithChildren
  '/_auth/generations/$siteId': typeof AuthGenerationsSiteIdRouteRouteWithChildren
  '/_auth/genlab/$siteId': typeof AuthGenlabSiteIdRouteRouteWithChildren
  '/_auth/marketing-calendar/$siteId': typeof AuthMarketingCalendarSiteIdRouteRouteWithChildren
  '/_auth/people/$siteId': typeof AuthPeopleSiteIdRouteRouteWithChildren
  '/_auth/settings/$siteId': typeof AuthSettingsSiteIdRouteRouteWithChildren
  '/_auth/sku-store/$siteId': typeof AuthSkuStoreSiteIdRouteRouteWithChildren
  '/_auth/apple-messages/connect': typeof AuthAppleMessagesConnectRoute
  '/_auth/brand-onboarding/$siteId': typeof AuthBrandOnboardingSiteIdRouteWithChildren
  '/_auth/compose-text/$siteId': typeof AuthComposeTextSiteIdRoute
  '/_auth/docs/$siteId': typeof AuthDocsSiteIdRoute
  '/_auth/settings/notification-rejects': typeof AuthSettingsNotificationRejectsRoute
  '/_auth/settings/notifications': typeof AuthSettingsNotificationsRoute
  '/blastro/$siteId/connect': typeof BlastroSiteIdConnectRoute
  '/_auth/docs/': typeof AuthDocsIndexRoute
  '/_auth/dragon-tiles/$siteId/$parentTile': typeof AuthDragonTilesSiteIdParentTileRouteRouteWithChildren
  '/_auth/dragon-tiles/$siteId/broadcast': typeof AuthDragonTilesSiteIdBroadcastRouteRouteWithChildren
  '/_auth/dragon-tiles/$siteId/broadcastV2': typeof AuthDragonTilesSiteIdBroadcastV2RouteRouteWithChildren
  '/_auth/dragon-tiles/$siteId/byoc': typeof AuthDragonTilesSiteIdByocRouteRouteWithChildren
  '/_auth/dragon-tiles/$siteId/connectors': typeof AuthDragonTilesSiteIdConnectorsRouteRouteWithChildren
  '/_auth/people/$siteId/audiences': typeof AuthPeopleSiteIdAudiencesRouteRouteWithChildren
  '/_auth/people/$siteId/lists': typeof AuthPeopleSiteIdListsRouteRouteWithChildren
  '/_auth/people/$siteId/profiles': typeof AuthPeopleSiteIdProfilesRouteRouteWithChildren
  '/_auth/settings/$siteId/_zeroAdmin': typeof AuthSettingsSiteIdZeroAdminRouteRouteWithChildren
  '/_auth/settings/$siteId/connectors': typeof AuthSettingsSiteIdConnectorsRouteRouteWithChildren
  '/_auth/settings/$siteId/coupon-codes': typeof AuthSettingsSiteIdCouponCodesRouteRouteWithChildren
  '/_auth/sku-store/$siteId/$skuId': typeof AuthSkuStoreSiteIdSkuIdRouteRouteWithChildren
  '/_auth/assets/$siteId/$assetKey': typeof AuthAssetsSiteIdAssetKeyRoute
  '/_auth/besties/$siteId/onboarding': typeof AuthBestiesSiteIdOnboardingRoute
  '/_auth/besties/$siteId/reporting': typeof AuthBestiesSiteIdReportingRoute
  '/_auth/besties/$siteId/revenue': typeof AuthBestiesSiteIdRevenueRoute
  '/_auth/brand-onboarding/$siteId/$stepId': typeof AuthBrandOnboardingSiteIdStepIdRoute
  '/_auth/dimensions/$siteId/exchanges': typeof AuthDimensionsSiteIdExchangesRoute
  '/_auth/dimensions/$siteId/people': typeof AuthDimensionsSiteIdPeopleRoute
  '/_auth/exchanges/$siteId/new': typeof AuthExchangesSiteIdNewRoute
  '/_auth/marketing-calendar/$siteId/new': typeof AuthMarketingCalendarSiteIdNewRoute
  '/_auth/settings/$siteId/billing': typeof AuthSettingsSiteIdBillingRoute
  '/_auth/settings/$siteId/email': typeof AuthSettingsSiteIdEmailRoute
  '/_auth/settings/$siteId/feature-flags': typeof AuthSettingsSiteIdFeatureFlagsRoute
  '/_auth/settings/$siteId/general': typeof AuthSettingsSiteIdGeneralRoute
  '/_auth/settings/$siteId/machine-applications': typeof AuthSettingsSiteIdMachineApplicationsRoute
  '/_auth/settings/$siteId/mock-config': typeof AuthSettingsSiteIdMockConfigRoute
  '/_auth/settings/$siteId/recommendation-exclusions': typeof AuthSettingsSiteIdRecommendationExclusionsRoute
  '/_auth/settings/$siteId/reporting': typeof AuthSettingsSiteIdReportingRoute
  '/_auth/settings/$siteId/seed-besties-sites': typeof AuthSettingsSiteIdSeedBestiesSitesRoute
  '/_auth/settings/$siteId/sms-registration': typeof AuthSettingsSiteIdSmsRegistrationRoute
  '/_auth/settings/$siteId/text': typeof AuthSettingsSiteIdTextRoute
  '/_auth/sku-store/$siteId/mapping': typeof AuthSkuStoreSiteIdMappingRoute
  '/_auth/besties/$siteId/': typeof AuthBestiesSiteIdIndexRoute
  '/_auth/creative-sphere/$siteId/': typeof AuthCreativeSphereSiteIdIndexRoute
  '/_auth/dimensions/$siteId/': typeof AuthDimensionsSiteIdIndexRoute
  '/_auth/dragon-tiles/$siteId/': typeof AuthDragonTilesSiteIdIndexRoute
  '/_auth/generations/$siteId/': typeof AuthGenerationsSiteIdIndexRoute
  '/_auth/genlab/$siteId/': typeof AuthGenlabSiteIdIndexRoute
  '/_auth/marketing-calendar/$siteId/': typeof AuthMarketingCalendarSiteIdIndexRoute
  '/_auth/settings/$siteId/': typeof AuthSettingsSiteIdIndexRoute
  '/_auth/sku-store/$siteId/': typeof AuthSkuStoreSiteIdIndexRoute
  '/_auth/generations/$siteId/new/collection': typeof AuthGenerationsSiteIdNewCollectionRouteRouteWithChildren
  '/_auth/generations/$siteId/new/pilot': typeof AuthGenerationsSiteIdNewPilotRouteRouteWithChildren
  '/_auth/people/$siteId/profiles/$profileId': typeof AuthPeopleSiteIdProfilesProfileIdRouteRouteWithChildren
  '/_auth/besties/$siteId/onboarding_/$brandId': typeof AuthBestiesSiteIdOnboardingBrandIdRoute
  '/_auth/connectors/$siteId/yotpo/install': typeof AuthConnectorsSiteIdYotpoInstallRoute
  '/_auth/dragon-tiles/$siteId/$frameId/$variant': typeof AuthDragonTilesSiteIdFrameIdVariantRoute
  '/_auth/dragon-tiles/$siteId/broadcast/list': typeof AuthDragonTilesSiteIdBroadcastListRoute
  '/_auth/dragon-tiles/$siteId/connectors/$parentTile': typeof AuthDragonTilesSiteIdConnectorsParentTileRouteWithChildren
  '/_auth/dragon-tiles/$siteId/new/$variant': typeof AuthDragonTilesSiteIdNewVariantRoute
  '/_auth/exchanges/$siteId/$id/edit': typeof AuthExchangesSiteIdIdEditRoute
  '/_auth/people/$siteId/audiences/exports': typeof AuthPeopleSiteIdAudiencesExportsRoute
  '/_auth/people/$siteId/audiences/new': typeof AuthPeopleSiteIdAudiencesNewRoute
  '/_auth/people/$siteId/lists/$listId': typeof AuthPeopleSiteIdListsListIdRouteWithChildren
  '/_auth/settings/$siteId/_zeroAdmin/copy-frames': typeof AuthSettingsSiteIdZeroAdminCopyFramesRoute
  '/_auth/settings/$siteId/connectors/$connectorId': typeof AuthSettingsSiteIdConnectorsConnectorIdRoute
  '/_auth/settings/$siteId/connectors/all': typeof AuthSettingsSiteIdConnectorsAllRoute
  '/_auth/settings/$siteId/connectors/installed': typeof AuthSettingsSiteIdConnectorsInstalledRoute
  '/_auth/settings/$siteId/coupon-codes/add-codes': typeof AuthSettingsSiteIdCouponCodesAddCodesRoute
  '/_auth/settings/$siteId/coupon-codes/new': typeof AuthSettingsSiteIdCouponCodesNewRouteWithChildren
  '/_auth/sku-store/$siteId/$skuId/associations': typeof AuthSkuStoreSiteIdSkuIdAssociationsRoute
  '/_auth/sku-store/$siteId/$skuId/copy': typeof AuthSkuStoreSiteIdSkuIdCopyRoute
  '/_auth/sku-store/$siteId/$skuId/engagement': typeof AuthSkuStoreSiteIdSkuIdEngagementRoute
  '/_auth/sku-store/$siteId/$skuId/mapping': typeof AuthSkuStoreSiteIdSkuIdMappingRoute
  '/_auth/sku-store/$siteId/$skuId/media': typeof AuthSkuStoreSiteIdSkuIdMediaRoute
  '/_auth/sku-store/$siteId/$skuId/reviews': typeof AuthSkuStoreSiteIdSkuIdReviewsRoute
  '/_auth/sku-store/$siteId/$skuId/variants': typeof AuthSkuStoreSiteIdSkuIdVariantsRoute
  '/_auth/dragon-tiles/$siteId/connectors/': typeof AuthDragonTilesSiteIdConnectorsIndexRoute
  '/_auth/people/$siteId/audiences/': typeof AuthPeopleSiteIdAudiencesIndexRoute
  '/_auth/people/$siteId/lists/': typeof AuthPeopleSiteIdListsIndexRoute
  '/_auth/people/$siteId/profiles/': typeof AuthPeopleSiteIdProfilesIndexRoute
  '/_auth/settings/$siteId/connectors/': typeof AuthSettingsSiteIdConnectorsIndexRoute
  '/_auth/sku-store/$siteId/$skuId/': typeof AuthSkuStoreSiteIdSkuIdIndexRoute
  '/_auth/dragon-tiles/$siteId/$parentTile/tile/$frameId': typeof AuthDragonTilesSiteIdParentTileTileFrameIdRoute
  '/_auth/dragon-tiles/$siteId/broadcastV2/$broadcastId/email': typeof AuthDragonTilesSiteIdBroadcastV2BroadcastIdEmailRoute
  '/_auth/dragon-tiles/$siteId/broadcastV2/$broadcastId/sms': typeof AuthDragonTilesSiteIdBroadcastV2BroadcastIdSmsRoute
  '/_auth/dragon-tiles/$siteId/broadcastV2/new/email': typeof AuthDragonTilesSiteIdBroadcastV2NewEmailRoute
  '/_auth/dragon-tiles/$siteId/broadcastV2/new/sms': typeof AuthDragonTilesSiteIdBroadcastV2NewSmsRoute
  '/_auth/dragon-tiles/$siteId/byoc/tile/$frameId': typeof AuthDragonTilesSiteIdByocTileFrameIdRoute
  '/_auth/generations/$siteId/new/collection/$stepId': typeof AuthGenerationsSiteIdNewCollectionStepIdRoute
  '/_auth/generations/$siteId/new/pilot/$stepId': typeof AuthGenerationsSiteIdNewPilotStepIdRoute
  '/_auth/genlab/$siteId/presets/edit/$presetId': typeof AuthGenlabSiteIdPresetsEditPresetIdRoute
  '/_auth/people/$siteId/audiences/$audienceId/edit': typeof AuthPeopleSiteIdAudiencesAudienceIdEditRoute
  '/_auth/settings/$siteId/_zeroAdmin/accounts/$accountId': typeof AuthSettingsSiteIdZeroAdminAccountsAccountIdRoute
  '/_auth/settings/$siteId/_zeroAdmin/blueprints/$blueprintId': typeof AuthSettingsSiteIdZeroAdminBlueprintsBlueprintIdRoute
  '/_auth/settings/$siteId/_zeroAdmin/sites/$rjId': typeof AuthSettingsSiteIdZeroAdminSitesRjIdRoute
  '/_auth/settings/$siteId/coupon-codes/edit/$offerSlug': typeof AuthSettingsSiteIdCouponCodesEditOfferSlugRoute
  '/_auth/settings/$siteId/coupon-codes/new/static': typeof AuthSettingsSiteIdCouponCodesNewStaticRoute
  '/_auth/settings/$siteId/coupon-codes/new/unique': typeof AuthSettingsSiteIdCouponCodesNewUniqueRouteWithChildren
  '/_auth/sku-store/$siteId/$skuId/stories/new': typeof AuthSkuStoreSiteIdSkuIdStoriesNewRoute
  '/_auth/people/$siteId/lists/$listId/': typeof AuthPeopleSiteIdListsListIdIndexRoute
  '/_auth/people/$siteId/profiles/$profileId/': typeof AuthPeopleSiteIdProfilesProfileIdIndexRoute
  '/_auth/settings/$siteId/_zeroAdmin/accounts/': typeof AuthSettingsSiteIdZeroAdminAccountsIndexRoute
  '/_auth/settings/$siteId/_zeroAdmin/blueprints/': typeof AuthSettingsSiteIdZeroAdminBlueprintsIndexRoute
  '/_auth/settings/$siteId/_zeroAdmin/notification-rejects/': typeof AuthSettingsSiteIdZeroAdminNotificationRejectsIndexRoute
  '/_auth/settings/$siteId/_zeroAdmin/notifications/': typeof AuthSettingsSiteIdZeroAdminNotificationsIndexRoute
  '/_auth/settings/$siteId/_zeroAdmin/onboarding/': typeof AuthSettingsSiteIdZeroAdminOnboardingIndexRoute
  '/_auth/settings/$siteId/_zeroAdmin/sites/': typeof AuthSettingsSiteIdZeroAdminSitesIndexRoute
  '/_auth/sku-store/$siteId/$skuId/stories/': typeof AuthSkuStoreSiteIdSkuIdStoriesIndexRoute
  '/_auth/dragon-tiles/$siteId/connectors/$parentTile/tile/$frameId': typeof AuthDragonTilesSiteIdConnectorsParentTileTileFrameIdRoute
  '/_auth/genlab/$siteId/presets/casting/edit/$presetId': typeof AuthGenlabSiteIdPresetsCastingEditPresetIdRoute
  '/_auth/genlab/$siteId/presets/composition/edit/$presetId': typeof AuthGenlabSiteIdPresetsCompositionEditPresetIdRoute
  '/_auth/genlab/$siteId/presets/scene/edit/$presetId': typeof AuthGenlabSiteIdPresetsSceneEditPresetIdRoute
  '/_auth/settings/$siteId/coupon-codes/new/unique/csv': typeof AuthSettingsSiteIdCouponCodesNewUniqueCsvRoute
  '/_auth/settings/$siteId/coupon-codes/new/unique/foxy': typeof AuthSettingsSiteIdCouponCodesNewUniqueFoxyRoute
  '/_auth/settings/$siteId/coupon-codes/new/unique/shopify': typeof AuthSettingsSiteIdCouponCodesNewUniqueShopifyRoute
  '/_auth/sku-store/$siteId/$skuId/stories/edit/$storyId': typeof AuthSkuStoreSiteIdSkuIdStoriesEditStoryIdRoute
  '/_auth/people/$siteId/audiences/$audienceId/members/': typeof AuthPeopleSiteIdAudiencesAudienceIdMembersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/demo'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/preview-test'
    | '/blastro/connect'
    | '/assets/$siteId'
    | '/besties/$siteId'
    | '/blocks/$siteId'
    | '/creative-sphere/$siteId'
    | '/dimensions/$siteId'
    | '/dragon-tiles/$siteId'
    | '/exchanges/$siteId'
    | '/generations/$siteId'
    | '/genlab/$siteId'
    | '/marketing-calendar/$siteId'
    | '/people/$siteId'
    | '/settings/$siteId'
    | '/sku-store/$siteId'
    | '/apple-messages/connect'
    | '/brand-onboarding/$siteId'
    | '/compose-text/$siteId'
    | '/docs/$siteId'
    | '/settings/notification-rejects'
    | '/settings/notifications'
    | '/blastro/$siteId/connect'
    | '/docs/'
    | '/dragon-tiles/$siteId/$parentTile'
    | '/dragon-tiles/$siteId/broadcast'
    | '/dragon-tiles/$siteId/broadcastV2'
    | '/dragon-tiles/$siteId/byoc'
    | '/dragon-tiles/$siteId/connectors'
    | '/people/$siteId/audiences'
    | '/people/$siteId/lists'
    | '/people/$siteId/profiles'
    | '/settings/$siteId/connectors'
    | '/settings/$siteId/coupon-codes'
    | '/sku-store/$siteId/$skuId'
    | '/assets/$siteId/$assetKey'
    | '/besties/$siteId/onboarding'
    | '/besties/$siteId/reporting'
    | '/besties/$siteId/revenue'
    | '/brand-onboarding/$siteId/$stepId'
    | '/dimensions/$siteId/exchanges'
    | '/dimensions/$siteId/people'
    | '/exchanges/$siteId/new'
    | '/marketing-calendar/$siteId/new'
    | '/settings/$siteId/billing'
    | '/settings/$siteId/email'
    | '/settings/$siteId/feature-flags'
    | '/settings/$siteId/general'
    | '/settings/$siteId/machine-applications'
    | '/settings/$siteId/mock-config'
    | '/settings/$siteId/recommendation-exclusions'
    | '/settings/$siteId/reporting'
    | '/settings/$siteId/seed-besties-sites'
    | '/settings/$siteId/sms-registration'
    | '/settings/$siteId/text'
    | '/sku-store/$siteId/mapping'
    | '/besties/$siteId/'
    | '/creative-sphere/$siteId/'
    | '/dimensions/$siteId/'
    | '/dragon-tiles/$siteId/'
    | '/generations/$siteId/'
    | '/genlab/$siteId/'
    | '/marketing-calendar/$siteId/'
    | '/settings/$siteId/'
    | '/sku-store/$siteId/'
    | '/generations/$siteId/new/collection'
    | '/generations/$siteId/new/pilot'
    | '/people/$siteId/profiles/$profileId'
    | '/besties/$siteId/onboarding/$brandId'
    | '/connectors/$siteId/yotpo/install'
    | '/dragon-tiles/$siteId/$frameId/$variant'
    | '/dragon-tiles/$siteId/broadcast/list'
    | '/dragon-tiles/$siteId/connectors/$parentTile'
    | '/dragon-tiles/$siteId/new/$variant'
    | '/exchanges/$siteId/$id/edit'
    | '/people/$siteId/audiences/exports'
    | '/people/$siteId/audiences/new'
    | '/people/$siteId/lists/$listId'
    | '/settings/$siteId/copy-frames'
    | '/settings/$siteId/connectors/$connectorId'
    | '/settings/$siteId/connectors/all'
    | '/settings/$siteId/connectors/installed'
    | '/settings/$siteId/coupon-codes/add-codes'
    | '/settings/$siteId/coupon-codes/new'
    | '/sku-store/$siteId/$skuId/associations'
    | '/sku-store/$siteId/$skuId/copy'
    | '/sku-store/$siteId/$skuId/engagement'
    | '/sku-store/$siteId/$skuId/mapping'
    | '/sku-store/$siteId/$skuId/media'
    | '/sku-store/$siteId/$skuId/reviews'
    | '/sku-store/$siteId/$skuId/variants'
    | '/dragon-tiles/$siteId/connectors/'
    | '/people/$siteId/audiences/'
    | '/people/$siteId/lists/'
    | '/people/$siteId/profiles/'
    | '/settings/$siteId/connectors/'
    | '/sku-store/$siteId/$skuId/'
    | '/dragon-tiles/$siteId/$parentTile/tile/$frameId'
    | '/dragon-tiles/$siteId/broadcastV2/$broadcastId/email'
    | '/dragon-tiles/$siteId/broadcastV2/$broadcastId/sms'
    | '/dragon-tiles/$siteId/broadcastV2/new/email'
    | '/dragon-tiles/$siteId/broadcastV2/new/sms'
    | '/dragon-tiles/$siteId/byoc/tile/$frameId'
    | '/generations/$siteId/new/collection/$stepId'
    | '/generations/$siteId/new/pilot/$stepId'
    | '/genlab/$siteId/presets/edit/$presetId'
    | '/people/$siteId/audiences/$audienceId/edit'
    | '/settings/$siteId/accounts/$accountId'
    | '/settings/$siteId/blueprints/$blueprintId'
    | '/settings/$siteId/sites/$rjId'
    | '/settings/$siteId/coupon-codes/edit/$offerSlug'
    | '/settings/$siteId/coupon-codes/new/static'
    | '/settings/$siteId/coupon-codes/new/unique'
    | '/sku-store/$siteId/$skuId/stories/new'
    | '/people/$siteId/lists/$listId/'
    | '/people/$siteId/profiles/$profileId/'
    | '/settings/$siteId/accounts/'
    | '/settings/$siteId/blueprints/'
    | '/settings/$siteId/notification-rejects/'
    | '/settings/$siteId/notifications/'
    | '/settings/$siteId/onboarding/'
    | '/settings/$siteId/sites/'
    | '/sku-store/$siteId/$skuId/stories/'
    | '/dragon-tiles/$siteId/connectors/$parentTile/tile/$frameId'
    | '/genlab/$siteId/presets/casting/edit/$presetId'
    | '/genlab/$siteId/presets/composition/edit/$presetId'
    | '/genlab/$siteId/presets/scene/edit/$presetId'
    | '/settings/$siteId/coupon-codes/new/unique/csv'
    | '/settings/$siteId/coupon-codes/new/unique/foxy'
    | '/settings/$siteId/coupon-codes/new/unique/shopify'
    | '/sku-store/$siteId/$skuId/stories/edit/$storyId'
    | '/people/$siteId/audiences/$audienceId/members/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/demo'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/preview-test'
    | '/blastro/connect'
    | '/assets/$siteId'
    | '/blocks/$siteId'
    | '/exchanges/$siteId'
    | '/people/$siteId'
    | '/apple-messages/connect'
    | '/brand-onboarding/$siteId'
    | '/compose-text/$siteId'
    | '/docs/$siteId'
    | '/settings/notification-rejects'
    | '/settings/notifications'
    | '/blastro/$siteId/connect'
    | '/docs'
    | '/dragon-tiles/$siteId/$parentTile'
    | '/dragon-tiles/$siteId/broadcast'
    | '/dragon-tiles/$siteId/broadcastV2'
    | '/dragon-tiles/$siteId/byoc'
    | '/settings/$siteId'
    | '/settings/$siteId/coupon-codes'
    | '/assets/$siteId/$assetKey'
    | '/besties/$siteId/onboarding'
    | '/besties/$siteId/reporting'
    | '/besties/$siteId/revenue'
    | '/brand-onboarding/$siteId/$stepId'
    | '/dimensions/$siteId/exchanges'
    | '/dimensions/$siteId/people'
    | '/exchanges/$siteId/new'
    | '/marketing-calendar/$siteId/new'
    | '/settings/$siteId/billing'
    | '/settings/$siteId/email'
    | '/settings/$siteId/feature-flags'
    | '/settings/$siteId/general'
    | '/settings/$siteId/machine-applications'
    | '/settings/$siteId/mock-config'
    | '/settings/$siteId/recommendation-exclusions'
    | '/settings/$siteId/reporting'
    | '/settings/$siteId/seed-besties-sites'
    | '/settings/$siteId/sms-registration'
    | '/settings/$siteId/text'
    | '/sku-store/$siteId/mapping'
    | '/besties/$siteId'
    | '/creative-sphere/$siteId'
    | '/dimensions/$siteId'
    | '/dragon-tiles/$siteId'
    | '/generations/$siteId'
    | '/genlab/$siteId'
    | '/marketing-calendar/$siteId'
    | '/sku-store/$siteId'
    | '/generations/$siteId/new/collection'
    | '/generations/$siteId/new/pilot'
    | '/besties/$siteId/onboarding/$brandId'
    | '/connectors/$siteId/yotpo/install'
    | '/dragon-tiles/$siteId/$frameId/$variant'
    | '/dragon-tiles/$siteId/broadcast/list'
    | '/dragon-tiles/$siteId/connectors/$parentTile'
    | '/dragon-tiles/$siteId/new/$variant'
    | '/exchanges/$siteId/$id/edit'
    | '/people/$siteId/audiences/exports'
    | '/people/$siteId/audiences/new'
    | '/settings/$siteId/copy-frames'
    | '/settings/$siteId/connectors/$connectorId'
    | '/settings/$siteId/connectors/all'
    | '/settings/$siteId/connectors/installed'
    | '/settings/$siteId/coupon-codes/add-codes'
    | '/settings/$siteId/coupon-codes/new'
    | '/sku-store/$siteId/$skuId/associations'
    | '/sku-store/$siteId/$skuId/copy'
    | '/sku-store/$siteId/$skuId/engagement'
    | '/sku-store/$siteId/$skuId/mapping'
    | '/sku-store/$siteId/$skuId/media'
    | '/sku-store/$siteId/$skuId/reviews'
    | '/sku-store/$siteId/$skuId/variants'
    | '/dragon-tiles/$siteId/connectors'
    | '/people/$siteId/audiences'
    | '/people/$siteId/lists'
    | '/people/$siteId/profiles'
    | '/settings/$siteId/connectors'
    | '/sku-store/$siteId/$skuId'
    | '/dragon-tiles/$siteId/$parentTile/tile/$frameId'
    | '/dragon-tiles/$siteId/broadcastV2/$broadcastId/email'
    | '/dragon-tiles/$siteId/broadcastV2/$broadcastId/sms'
    | '/dragon-tiles/$siteId/broadcastV2/new/email'
    | '/dragon-tiles/$siteId/broadcastV2/new/sms'
    | '/dragon-tiles/$siteId/byoc/tile/$frameId'
    | '/generations/$siteId/new/collection/$stepId'
    | '/generations/$siteId/new/pilot/$stepId'
    | '/genlab/$siteId/presets/edit/$presetId'
    | '/people/$siteId/audiences/$audienceId/edit'
    | '/settings/$siteId/accounts/$accountId'
    | '/settings/$siteId/blueprints/$blueprintId'
    | '/settings/$siteId/sites/$rjId'
    | '/settings/$siteId/coupon-codes/edit/$offerSlug'
    | '/settings/$siteId/coupon-codes/new/static'
    | '/settings/$siteId/coupon-codes/new/unique'
    | '/sku-store/$siteId/$skuId/stories/new'
    | '/people/$siteId/lists/$listId'
    | '/people/$siteId/profiles/$profileId'
    | '/settings/$siteId/accounts'
    | '/settings/$siteId/blueprints'
    | '/settings/$siteId/notification-rejects'
    | '/settings/$siteId/notifications'
    | '/settings/$siteId/onboarding'
    | '/settings/$siteId/sites'
    | '/sku-store/$siteId/$skuId/stories'
    | '/dragon-tiles/$siteId/connectors/$parentTile/tile/$frameId'
    | '/genlab/$siteId/presets/casting/edit/$presetId'
    | '/genlab/$siteId/presets/composition/edit/$presetId'
    | '/genlab/$siteId/presets/scene/edit/$presetId'
    | '/settings/$siteId/coupon-codes/new/unique/csv'
    | '/settings/$siteId/coupon-codes/new/unique/foxy'
    | '/settings/$siteId/coupon-codes/new/unique/shopify'
    | '/sku-store/$siteId/$skuId/stories/edit/$storyId'
    | '/people/$siteId/audiences/$audienceId/members'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/demo'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/_auth/preview-test'
    | '/blastro/connect'
    | '/_auth/assets/$siteId'
    | '/_auth/besties/$siteId'
    | '/_auth/blocks/$siteId'
    | '/_auth/creative-sphere/$siteId'
    | '/_auth/dimensions/$siteId'
    | '/_auth/dragon-tiles/$siteId'
    | '/_auth/exchanges/$siteId'
    | '/_auth/generations/$siteId'
    | '/_auth/genlab/$siteId'
    | '/_auth/marketing-calendar/$siteId'
    | '/_auth/people/$siteId'
    | '/_auth/settings/$siteId'
    | '/_auth/sku-store/$siteId'
    | '/_auth/apple-messages/connect'
    | '/_auth/brand-onboarding/$siteId'
    | '/_auth/compose-text/$siteId'
    | '/_auth/docs/$siteId'
    | '/_auth/settings/notification-rejects'
    | '/_auth/settings/notifications'
    | '/blastro/$siteId/connect'
    | '/_auth/docs/'
    | '/_auth/dragon-tiles/$siteId/$parentTile'
    | '/_auth/dragon-tiles/$siteId/broadcast'
    | '/_auth/dragon-tiles/$siteId/broadcastV2'
    | '/_auth/dragon-tiles/$siteId/byoc'
    | '/_auth/dragon-tiles/$siteId/connectors'
    | '/_auth/people/$siteId/audiences'
    | '/_auth/people/$siteId/lists'
    | '/_auth/people/$siteId/profiles'
    | '/_auth/settings/$siteId/_zeroAdmin'
    | '/_auth/settings/$siteId/connectors'
    | '/_auth/settings/$siteId/coupon-codes'
    | '/_auth/sku-store/$siteId/$skuId'
    | '/_auth/assets/$siteId/$assetKey'
    | '/_auth/besties/$siteId/onboarding'
    | '/_auth/besties/$siteId/reporting'
    | '/_auth/besties/$siteId/revenue'
    | '/_auth/brand-onboarding/$siteId/$stepId'
    | '/_auth/dimensions/$siteId/exchanges'
    | '/_auth/dimensions/$siteId/people'
    | '/_auth/exchanges/$siteId/new'
    | '/_auth/marketing-calendar/$siteId/new'
    | '/_auth/settings/$siteId/billing'
    | '/_auth/settings/$siteId/email'
    | '/_auth/settings/$siteId/feature-flags'
    | '/_auth/settings/$siteId/general'
    | '/_auth/settings/$siteId/machine-applications'
    | '/_auth/settings/$siteId/mock-config'
    | '/_auth/settings/$siteId/recommendation-exclusions'
    | '/_auth/settings/$siteId/reporting'
    | '/_auth/settings/$siteId/seed-besties-sites'
    | '/_auth/settings/$siteId/sms-registration'
    | '/_auth/settings/$siteId/text'
    | '/_auth/sku-store/$siteId/mapping'
    | '/_auth/besties/$siteId/'
    | '/_auth/creative-sphere/$siteId/'
    | '/_auth/dimensions/$siteId/'
    | '/_auth/dragon-tiles/$siteId/'
    | '/_auth/generations/$siteId/'
    | '/_auth/genlab/$siteId/'
    | '/_auth/marketing-calendar/$siteId/'
    | '/_auth/settings/$siteId/'
    | '/_auth/sku-store/$siteId/'
    | '/_auth/generations/$siteId/new/collection'
    | '/_auth/generations/$siteId/new/pilot'
    | '/_auth/people/$siteId/profiles/$profileId'
    | '/_auth/besties/$siteId/onboarding_/$brandId'
    | '/_auth/connectors/$siteId/yotpo/install'
    | '/_auth/dragon-tiles/$siteId/$frameId/$variant'
    | '/_auth/dragon-tiles/$siteId/broadcast/list'
    | '/_auth/dragon-tiles/$siteId/connectors/$parentTile'
    | '/_auth/dragon-tiles/$siteId/new/$variant'
    | '/_auth/exchanges/$siteId/$id/edit'
    | '/_auth/people/$siteId/audiences/exports'
    | '/_auth/people/$siteId/audiences/new'
    | '/_auth/people/$siteId/lists/$listId'
    | '/_auth/settings/$siteId/_zeroAdmin/copy-frames'
    | '/_auth/settings/$siteId/connectors/$connectorId'
    | '/_auth/settings/$siteId/connectors/all'
    | '/_auth/settings/$siteId/connectors/installed'
    | '/_auth/settings/$siteId/coupon-codes/add-codes'
    | '/_auth/settings/$siteId/coupon-codes/new'
    | '/_auth/sku-store/$siteId/$skuId/associations'
    | '/_auth/sku-store/$siteId/$skuId/copy'
    | '/_auth/sku-store/$siteId/$skuId/engagement'
    | '/_auth/sku-store/$siteId/$skuId/mapping'
    | '/_auth/sku-store/$siteId/$skuId/media'
    | '/_auth/sku-store/$siteId/$skuId/reviews'
    | '/_auth/sku-store/$siteId/$skuId/variants'
    | '/_auth/dragon-tiles/$siteId/connectors/'
    | '/_auth/people/$siteId/audiences/'
    | '/_auth/people/$siteId/lists/'
    | '/_auth/people/$siteId/profiles/'
    | '/_auth/settings/$siteId/connectors/'
    | '/_auth/sku-store/$siteId/$skuId/'
    | '/_auth/dragon-tiles/$siteId/$parentTile/tile/$frameId'
    | '/_auth/dragon-tiles/$siteId/broadcastV2/$broadcastId/email'
    | '/_auth/dragon-tiles/$siteId/broadcastV2/$broadcastId/sms'
    | '/_auth/dragon-tiles/$siteId/broadcastV2/new/email'
    | '/_auth/dragon-tiles/$siteId/broadcastV2/new/sms'
    | '/_auth/dragon-tiles/$siteId/byoc/tile/$frameId'
    | '/_auth/generations/$siteId/new/collection/$stepId'
    | '/_auth/generations/$siteId/new/pilot/$stepId'
    | '/_auth/genlab/$siteId/presets/edit/$presetId'
    | '/_auth/people/$siteId/audiences/$audienceId/edit'
    | '/_auth/settings/$siteId/_zeroAdmin/accounts/$accountId'
    | '/_auth/settings/$siteId/_zeroAdmin/blueprints/$blueprintId'
    | '/_auth/settings/$siteId/_zeroAdmin/sites/$rjId'
    | '/_auth/settings/$siteId/coupon-codes/edit/$offerSlug'
    | '/_auth/settings/$siteId/coupon-codes/new/static'
    | '/_auth/settings/$siteId/coupon-codes/new/unique'
    | '/_auth/sku-store/$siteId/$skuId/stories/new'
    | '/_auth/people/$siteId/lists/$listId/'
    | '/_auth/people/$siteId/profiles/$profileId/'
    | '/_auth/settings/$siteId/_zeroAdmin/accounts/'
    | '/_auth/settings/$siteId/_zeroAdmin/blueprints/'
    | '/_auth/settings/$siteId/_zeroAdmin/notification-rejects/'
    | '/_auth/settings/$siteId/_zeroAdmin/notifications/'
    | '/_auth/settings/$siteId/_zeroAdmin/onboarding/'
    | '/_auth/settings/$siteId/_zeroAdmin/sites/'
    | '/_auth/sku-store/$siteId/$skuId/stories/'
    | '/_auth/dragon-tiles/$siteId/connectors/$parentTile/tile/$frameId'
    | '/_auth/genlab/$siteId/presets/casting/edit/$presetId'
    | '/_auth/genlab/$siteId/presets/composition/edit/$presetId'
    | '/_auth/genlab/$siteId/presets/scene/edit/$presetId'
    | '/_auth/settings/$siteId/coupon-codes/new/unique/csv'
    | '/_auth/settings/$siteId/coupon-codes/new/unique/foxy'
    | '/_auth/settings/$siteId/coupon-codes/new/unique/shopify'
    | '/_auth/sku-store/$siteId/$skuId/stories/edit/$storyId'
    | '/_auth/people/$siteId/audiences/$audienceId/members/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  DemoRoute: typeof DemoRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  BlastroConnectRoute: typeof BlastroConnectRoute
  BlastroSiteIdConnectRoute: typeof BlastroSiteIdConnectRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo': {
      id: '/demo'
      path: '/demo'
      fullPath: '/demo'
      preLoaderRoute: typeof DemoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blastro/connect': {
      id: '/blastro/connect'
      path: '/blastro/connect'
      fullPath: '/blastro/connect'
      preLoaderRoute: typeof BlastroConnectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/preview-test': {
      id: '/_auth/preview-test'
      path: '/preview-test'
      fullPath: '/preview-test'
      preLoaderRoute: typeof AuthPreviewTestRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/docs/': {
      id: '/_auth/docs/'
      path: '/docs'
      fullPath: '/docs/'
      preLoaderRoute: typeof AuthDocsIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/blastro/$siteId/connect': {
      id: '/blastro/$siteId/connect'
      path: '/blastro/$siteId/connect'
      fullPath: '/blastro/$siteId/connect'
      preLoaderRoute: typeof BlastroSiteIdConnectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/settings/notifications': {
      id: '/_auth/settings/notifications'
      path: '/settings/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthSettingsNotificationsRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/settings/notification-rejects': {
      id: '/_auth/settings/notification-rejects'
      path: '/settings/notification-rejects'
      fullPath: '/settings/notification-rejects'
      preLoaderRoute: typeof AuthSettingsNotificationRejectsRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/docs/$siteId': {
      id: '/_auth/docs/$siteId'
      path: '/docs/$siteId'
      fullPath: '/docs/$siteId'
      preLoaderRoute: typeof AuthDocsSiteIdRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/compose-text/$siteId': {
      id: '/_auth/compose-text/$siteId'
      path: '/compose-text/$siteId'
      fullPath: '/compose-text/$siteId'
      preLoaderRoute: typeof AuthComposeTextSiteIdRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/brand-onboarding/$siteId': {
      id: '/_auth/brand-onboarding/$siteId'
      path: '/brand-onboarding/$siteId'
      fullPath: '/brand-onboarding/$siteId'
      preLoaderRoute: typeof AuthBrandOnboardingSiteIdRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/apple-messages/connect': {
      id: '/_auth/apple-messages/connect'
      path: '/apple-messages/connect'
      fullPath: '/apple-messages/connect'
      preLoaderRoute: typeof AuthAppleMessagesConnectRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/sku-store/$siteId': {
      id: '/_auth/sku-store/$siteId'
      path: '/sku-store/$siteId'
      fullPath: '/sku-store/$siteId'
      preLoaderRoute: typeof AuthSkuStoreSiteIdRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/settings/$siteId': {
      id: '/_auth/settings/$siteId'
      path: '/settings/$siteId'
      fullPath: '/settings/$siteId'
      preLoaderRoute: typeof AuthSettingsSiteIdRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/people/$siteId': {
      id: '/_auth/people/$siteId'
      path: '/people/$siteId'
      fullPath: '/people/$siteId'
      preLoaderRoute: typeof AuthPeopleSiteIdRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/marketing-calendar/$siteId': {
      id: '/_auth/marketing-calendar/$siteId'
      path: '/marketing-calendar/$siteId'
      fullPath: '/marketing-calendar/$siteId'
      preLoaderRoute: typeof AuthMarketingCalendarSiteIdRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/genlab/$siteId': {
      id: '/_auth/genlab/$siteId'
      path: '/genlab/$siteId'
      fullPath: '/genlab/$siteId'
      preLoaderRoute: typeof AuthGenlabSiteIdRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/generations/$siteId': {
      id: '/_auth/generations/$siteId'
      path: '/generations/$siteId'
      fullPath: '/generations/$siteId'
      preLoaderRoute: typeof AuthGenerationsSiteIdRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/exchanges/$siteId': {
      id: '/_auth/exchanges/$siteId'
      path: '/exchanges/$siteId'
      fullPath: '/exchanges/$siteId'
      preLoaderRoute: typeof AuthExchangesSiteIdRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/dragon-tiles/$siteId': {
      id: '/_auth/dragon-tiles/$siteId'
      path: '/dragon-tiles/$siteId'
      fullPath: '/dragon-tiles/$siteId'
      preLoaderRoute: typeof AuthDragonTilesSiteIdRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/dimensions/$siteId': {
      id: '/_auth/dimensions/$siteId'
      path: '/dimensions/$siteId'
      fullPath: '/dimensions/$siteId'
      preLoaderRoute: typeof AuthDimensionsSiteIdRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/creative-sphere/$siteId': {
      id: '/_auth/creative-sphere/$siteId'
      path: '/creative-sphere/$siteId'
      fullPath: '/creative-sphere/$siteId'
      preLoaderRoute: typeof AuthCreativeSphereSiteIdRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/blocks/$siteId': {
      id: '/_auth/blocks/$siteId'
      path: '/blocks/$siteId'
      fullPath: '/blocks/$siteId'
      preLoaderRoute: typeof AuthBlocksSiteIdRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/besties/$siteId': {
      id: '/_auth/besties/$siteId'
      path: '/besties/$siteId'
      fullPath: '/besties/$siteId'
      preLoaderRoute: typeof AuthBestiesSiteIdRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/assets/$siteId': {
      id: '/_auth/assets/$siteId'
      path: '/assets/$siteId'
      fullPath: '/assets/$siteId'
      preLoaderRoute: typeof AuthAssetsSiteIdRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/sku-store/$siteId/': {
      id: '/_auth/sku-store/$siteId/'
      path: '/'
      fullPath: '/sku-store/$siteId/'
      preLoaderRoute: typeof AuthSkuStoreSiteIdIndexRouteImport
      parentRoute: typeof AuthSkuStoreSiteIdRouteRoute
    }
    '/_auth/settings/$siteId/': {
      id: '/_auth/settings/$siteId/'
      path: '/'
      fullPath: '/settings/$siteId/'
      preLoaderRoute: typeof AuthSettingsSiteIdIndexRouteImport
      parentRoute: typeof AuthSettingsSiteIdRouteRoute
    }
    '/_auth/marketing-calendar/$siteId/': {
      id: '/_auth/marketing-calendar/$siteId/'
      path: '/'
      fullPath: '/marketing-calendar/$siteId/'
      preLoaderRoute: typeof AuthMarketingCalendarSiteIdIndexRouteImport
      parentRoute: typeof AuthMarketingCalendarSiteIdRouteRoute
    }
    '/_auth/genlab/$siteId/': {
      id: '/_auth/genlab/$siteId/'
      path: '/'
      fullPath: '/genlab/$siteId/'
      preLoaderRoute: typeof AuthGenlabSiteIdIndexRouteImport
      parentRoute: typeof AuthGenlabSiteIdRouteRoute
    }
    '/_auth/generations/$siteId/': {
      id: '/_auth/generations/$siteId/'
      path: '/'
      fullPath: '/generations/$siteId/'
      preLoaderRoute: typeof AuthGenerationsSiteIdIndexRouteImport
      parentRoute: typeof AuthGenerationsSiteIdRouteRoute
    }
    '/_auth/dragon-tiles/$siteId/': {
      id: '/_auth/dragon-tiles/$siteId/'
      path: '/'
      fullPath: '/dragon-tiles/$siteId/'
      preLoaderRoute: typeof AuthDragonTilesSiteIdIndexRouteImport
      parentRoute: typeof AuthDragonTilesSiteIdRouteRoute
    }
    '/_auth/dimensions/$siteId/': {
      id: '/_auth/dimensions/$siteId/'
      path: '/'
      fullPath: '/dimensions/$siteId/'
      preLoaderRoute: typeof AuthDimensionsSiteIdIndexRouteImport
      parentRoute: typeof AuthDimensionsSiteIdRouteRoute
    }
    '/_auth/creative-sphere/$siteId/': {
      id: '/_auth/creative-sphere/$siteId/'
      path: '/'
      fullPath: '/creative-sphere/$siteId/'
      preLoaderRoute: typeof AuthCreativeSphereSiteIdIndexRouteImport
      parentRoute: typeof AuthCreativeSphereSiteIdRouteRoute
    }
    '/_auth/besties/$siteId/': {
      id: '/_auth/besties/$siteId/'
      path: '/'
      fullPath: '/besties/$siteId/'
      preLoaderRoute: typeof AuthBestiesSiteIdIndexRouteImport
      parentRoute: typeof AuthBestiesSiteIdRouteRoute
    }
    '/_auth/sku-store/$siteId/mapping': {
      id: '/_auth/sku-store/$siteId/mapping'
      path: '/mapping'
      fullPath: '/sku-store/$siteId/mapping'
      preLoaderRoute: typeof AuthSkuStoreSiteIdMappingRouteImport
      parentRoute: typeof AuthSkuStoreSiteIdRouteRoute
    }
    '/_auth/settings/$siteId/text': {
      id: '/_auth/settings/$siteId/text'
      path: '/text'
      fullPath: '/settings/$siteId/text'
      preLoaderRoute: typeof AuthSettingsSiteIdTextRouteImport
      parentRoute: typeof AuthSettingsSiteIdRouteRoute
    }
    '/_auth/settings/$siteId/sms-registration': {
      id: '/_auth/settings/$siteId/sms-registration'
      path: '/sms-registration'
      fullPath: '/settings/$siteId/sms-registration'
      preLoaderRoute: typeof AuthSettingsSiteIdSmsRegistrationRouteImport
      parentRoute: typeof AuthSettingsSiteIdRouteRoute
    }
    '/_auth/settings/$siteId/seed-besties-sites': {
      id: '/_auth/settings/$siteId/seed-besties-sites'
      path: '/seed-besties-sites'
      fullPath: '/settings/$siteId/seed-besties-sites'
      preLoaderRoute: typeof AuthSettingsSiteIdSeedBestiesSitesRouteImport
      parentRoute: typeof AuthSettingsSiteIdRouteRoute
    }
    '/_auth/settings/$siteId/reporting': {
      id: '/_auth/settings/$siteId/reporting'
      path: '/reporting'
      fullPath: '/settings/$siteId/reporting'
      preLoaderRoute: typeof AuthSettingsSiteIdReportingRouteImport
      parentRoute: typeof AuthSettingsSiteIdRouteRoute
    }
    '/_auth/settings/$siteId/recommendation-exclusions': {
      id: '/_auth/settings/$siteId/recommendation-exclusions'
      path: '/recommendation-exclusions'
      fullPath: '/settings/$siteId/recommendation-exclusions'
      preLoaderRoute: typeof AuthSettingsSiteIdRecommendationExclusionsRouteImport
      parentRoute: typeof AuthSettingsSiteIdRouteRoute
    }
    '/_auth/settings/$siteId/mock-config': {
      id: '/_auth/settings/$siteId/mock-config'
      path: '/mock-config'
      fullPath: '/settings/$siteId/mock-config'
      preLoaderRoute: typeof AuthSettingsSiteIdMockConfigRouteImport
      parentRoute: typeof AuthSettingsSiteIdRouteRoute
    }
    '/_auth/settings/$siteId/machine-applications': {
      id: '/_auth/settings/$siteId/machine-applications'
      path: '/machine-applications'
      fullPath: '/settings/$siteId/machine-applications'
      preLoaderRoute: typeof AuthSettingsSiteIdMachineApplicationsRouteImport
      parentRoute: typeof AuthSettingsSiteIdRouteRoute
    }
    '/_auth/settings/$siteId/general': {
      id: '/_auth/settings/$siteId/general'
      path: '/general'
      fullPath: '/settings/$siteId/general'
      preLoaderRoute: typeof AuthSettingsSiteIdGeneralRouteImport
      parentRoute: typeof AuthSettingsSiteIdRouteRoute
    }
    '/_auth/settings/$siteId/feature-flags': {
      id: '/_auth/settings/$siteId/feature-flags'
      path: '/feature-flags'
      fullPath: '/settings/$siteId/feature-flags'
      preLoaderRoute: typeof AuthSettingsSiteIdFeatureFlagsRouteImport
      parentRoute: typeof AuthSettingsSiteIdRouteRoute
    }
    '/_auth/settings/$siteId/email': {
      id: '/_auth/settings/$siteId/email'
      path: '/email'
      fullPath: '/settings/$siteId/email'
      preLoaderRoute: typeof AuthSettingsSiteIdEmailRouteImport
      parentRoute: typeof AuthSettingsSiteIdRouteRoute
    }
    '/_auth/settings/$siteId/billing': {
      id: '/_auth/settings/$siteId/billing'
      path: '/billing'
      fullPath: '/settings/$siteId/billing'
      preLoaderRoute: typeof AuthSettingsSiteIdBillingRouteImport
      parentRoute: typeof AuthSettingsSiteIdRouteRoute
    }
    '/_auth/marketing-calendar/$siteId/new': {
      id: '/_auth/marketing-calendar/$siteId/new'
      path: '/new'
      fullPath: '/marketing-calendar/$siteId/new'
      preLoaderRoute: typeof AuthMarketingCalendarSiteIdNewRouteImport
      parentRoute: typeof AuthMarketingCalendarSiteIdRouteRoute
    }
    '/_auth/exchanges/$siteId/new': {
      id: '/_auth/exchanges/$siteId/new'
      path: '/new'
      fullPath: '/exchanges/$siteId/new'
      preLoaderRoute: typeof AuthExchangesSiteIdNewRouteImport
      parentRoute: typeof AuthExchangesSiteIdRouteRoute
    }
    '/_auth/dimensions/$siteId/people': {
      id: '/_auth/dimensions/$siteId/people'
      path: '/people'
      fullPath: '/dimensions/$siteId/people'
      preLoaderRoute: typeof AuthDimensionsSiteIdPeopleRouteImport
      parentRoute: typeof AuthDimensionsSiteIdRouteRoute
    }
    '/_auth/dimensions/$siteId/exchanges': {
      id: '/_auth/dimensions/$siteId/exchanges'
      path: '/exchanges'
      fullPath: '/dimensions/$siteId/exchanges'
      preLoaderRoute: typeof AuthDimensionsSiteIdExchangesRouteImport
      parentRoute: typeof AuthDimensionsSiteIdRouteRoute
    }
    '/_auth/brand-onboarding/$siteId/$stepId': {
      id: '/_auth/brand-onboarding/$siteId/$stepId'
      path: '/$stepId'
      fullPath: '/brand-onboarding/$siteId/$stepId'
      preLoaderRoute: typeof AuthBrandOnboardingSiteIdStepIdRouteImport
      parentRoute: typeof AuthBrandOnboardingSiteIdRoute
    }
    '/_auth/besties/$siteId/revenue': {
      id: '/_auth/besties/$siteId/revenue'
      path: '/revenue'
      fullPath: '/besties/$siteId/revenue'
      preLoaderRoute: typeof AuthBestiesSiteIdRevenueRouteImport
      parentRoute: typeof AuthBestiesSiteIdRouteRoute
    }
    '/_auth/besties/$siteId/reporting': {
      id: '/_auth/besties/$siteId/reporting'
      path: '/reporting'
      fullPath: '/besties/$siteId/reporting'
      preLoaderRoute: typeof AuthBestiesSiteIdReportingRouteImport
      parentRoute: typeof AuthBestiesSiteIdRouteRoute
    }
    '/_auth/besties/$siteId/onboarding': {
      id: '/_auth/besties/$siteId/onboarding'
      path: '/onboarding'
      fullPath: '/besties/$siteId/onboarding'
      preLoaderRoute: typeof AuthBestiesSiteIdOnboardingRouteImport
      parentRoute: typeof AuthBestiesSiteIdRouteRoute
    }
    '/_auth/assets/$siteId/$assetKey': {
      id: '/_auth/assets/$siteId/$assetKey'
      path: '/$assetKey'
      fullPath: '/assets/$siteId/$assetKey'
      preLoaderRoute: typeof AuthAssetsSiteIdAssetKeyRouteImport
      parentRoute: typeof AuthAssetsSiteIdRouteRoute
    }
    '/_auth/sku-store/$siteId/$skuId': {
      id: '/_auth/sku-store/$siteId/$skuId'
      path: '/$skuId'
      fullPath: '/sku-store/$siteId/$skuId'
      preLoaderRoute: typeof AuthSkuStoreSiteIdSkuIdRouteRouteImport
      parentRoute: typeof AuthSkuStoreSiteIdRouteRoute
    }
    '/_auth/settings/$siteId/coupon-codes': {
      id: '/_auth/settings/$siteId/coupon-codes'
      path: '/coupon-codes'
      fullPath: '/settings/$siteId/coupon-codes'
      preLoaderRoute: typeof AuthSettingsSiteIdCouponCodesRouteRouteImport
      parentRoute: typeof AuthSettingsSiteIdRouteRoute
    }
    '/_auth/settings/$siteId/connectors': {
      id: '/_auth/settings/$siteId/connectors'
      path: '/connectors'
      fullPath: '/settings/$siteId/connectors'
      preLoaderRoute: typeof AuthSettingsSiteIdConnectorsRouteRouteImport
      parentRoute: typeof AuthSettingsSiteIdRouteRoute
    }
    '/_auth/settings/$siteId/_zeroAdmin': {
      id: '/_auth/settings/$siteId/_zeroAdmin'
      path: ''
      fullPath: '/settings/$siteId'
      preLoaderRoute: typeof AuthSettingsSiteIdZeroAdminRouteRouteImport
      parentRoute: typeof AuthSettingsSiteIdRouteRoute
    }
    '/_auth/people/$siteId/profiles': {
      id: '/_auth/people/$siteId/profiles'
      path: '/profiles'
      fullPath: '/people/$siteId/profiles'
      preLoaderRoute: typeof AuthPeopleSiteIdProfilesRouteRouteImport
      parentRoute: typeof AuthPeopleSiteIdRouteRoute
    }
    '/_auth/people/$siteId/lists': {
      id: '/_auth/people/$siteId/lists'
      path: '/lists'
      fullPath: '/people/$siteId/lists'
      preLoaderRoute: typeof AuthPeopleSiteIdListsRouteRouteImport
      parentRoute: typeof AuthPeopleSiteIdRouteRoute
    }
    '/_auth/people/$siteId/audiences': {
      id: '/_auth/people/$siteId/audiences'
      path: '/audiences'
      fullPath: '/people/$siteId/audiences'
      preLoaderRoute: typeof AuthPeopleSiteIdAudiencesRouteRouteImport
      parentRoute: typeof AuthPeopleSiteIdRouteRoute
    }
    '/_auth/dragon-tiles/$siteId/connectors': {
      id: '/_auth/dragon-tiles/$siteId/connectors'
      path: '/connectors'
      fullPath: '/dragon-tiles/$siteId/connectors'
      preLoaderRoute: typeof AuthDragonTilesSiteIdConnectorsRouteRouteImport
      parentRoute: typeof AuthDragonTilesSiteIdRouteRoute
    }
    '/_auth/dragon-tiles/$siteId/byoc': {
      id: '/_auth/dragon-tiles/$siteId/byoc'
      path: '/byoc'
      fullPath: '/dragon-tiles/$siteId/byoc'
      preLoaderRoute: typeof AuthDragonTilesSiteIdByocRouteRouteImport
      parentRoute: typeof AuthDragonTilesSiteIdRouteRoute
    }
    '/_auth/dragon-tiles/$siteId/broadcastV2': {
      id: '/_auth/dragon-tiles/$siteId/broadcastV2'
      path: '/broadcastV2'
      fullPath: '/dragon-tiles/$siteId/broadcastV2'
      preLoaderRoute: typeof AuthDragonTilesSiteIdBroadcastV2RouteRouteImport
      parentRoute: typeof AuthDragonTilesSiteIdRouteRoute
    }
    '/_auth/dragon-tiles/$siteId/broadcast': {
      id: '/_auth/dragon-tiles/$siteId/broadcast'
      path: '/broadcast'
      fullPath: '/dragon-tiles/$siteId/broadcast'
      preLoaderRoute: typeof AuthDragonTilesSiteIdBroadcastRouteRouteImport
      parentRoute: typeof AuthDragonTilesSiteIdRouteRoute
    }
    '/_auth/dragon-tiles/$siteId/$parentTile': {
      id: '/_auth/dragon-tiles/$siteId/$parentTile'
      path: '/$parentTile'
      fullPath: '/dragon-tiles/$siteId/$parentTile'
      preLoaderRoute: typeof AuthDragonTilesSiteIdParentTileRouteRouteImport
      parentRoute: typeof AuthDragonTilesSiteIdRouteRoute
    }
    '/_auth/sku-store/$siteId/$skuId/': {
      id: '/_auth/sku-store/$siteId/$skuId/'
      path: '/'
      fullPath: '/sku-store/$siteId/$skuId/'
      preLoaderRoute: typeof AuthSkuStoreSiteIdSkuIdIndexRouteImport
      parentRoute: typeof AuthSkuStoreSiteIdSkuIdRouteRoute
    }
    '/_auth/settings/$siteId/connectors/': {
      id: '/_auth/settings/$siteId/connectors/'
      path: '/'
      fullPath: '/settings/$siteId/connectors/'
      preLoaderRoute: typeof AuthSettingsSiteIdConnectorsIndexRouteImport
      parentRoute: typeof AuthSettingsSiteIdConnectorsRouteRoute
    }
    '/_auth/people/$siteId/profiles/': {
      id: '/_auth/people/$siteId/profiles/'
      path: '/'
      fullPath: '/people/$siteId/profiles/'
      preLoaderRoute: typeof AuthPeopleSiteIdProfilesIndexRouteImport
      parentRoute: typeof AuthPeopleSiteIdProfilesRouteRoute
    }
    '/_auth/people/$siteId/lists/': {
      id: '/_auth/people/$siteId/lists/'
      path: '/'
      fullPath: '/people/$siteId/lists/'
      preLoaderRoute: typeof AuthPeopleSiteIdListsIndexRouteImport
      parentRoute: typeof AuthPeopleSiteIdListsRouteRoute
    }
    '/_auth/people/$siteId/audiences/': {
      id: '/_auth/people/$siteId/audiences/'
      path: '/'
      fullPath: '/people/$siteId/audiences/'
      preLoaderRoute: typeof AuthPeopleSiteIdAudiencesIndexRouteImport
      parentRoute: typeof AuthPeopleSiteIdAudiencesRouteRoute
    }
    '/_auth/dragon-tiles/$siteId/connectors/': {
      id: '/_auth/dragon-tiles/$siteId/connectors/'
      path: '/'
      fullPath: '/dragon-tiles/$siteId/connectors/'
      preLoaderRoute: typeof AuthDragonTilesSiteIdConnectorsIndexRouteImport
      parentRoute: typeof AuthDragonTilesSiteIdConnectorsRouteRoute
    }
    '/_auth/sku-store/$siteId/$skuId/variants': {
      id: '/_auth/sku-store/$siteId/$skuId/variants'
      path: '/variants'
      fullPath: '/sku-store/$siteId/$skuId/variants'
      preLoaderRoute: typeof AuthSkuStoreSiteIdSkuIdVariantsRouteImport
      parentRoute: typeof AuthSkuStoreSiteIdSkuIdRouteRoute
    }
    '/_auth/sku-store/$siteId/$skuId/reviews': {
      id: '/_auth/sku-store/$siteId/$skuId/reviews'
      path: '/reviews'
      fullPath: '/sku-store/$siteId/$skuId/reviews'
      preLoaderRoute: typeof AuthSkuStoreSiteIdSkuIdReviewsRouteImport
      parentRoute: typeof AuthSkuStoreSiteIdSkuIdRouteRoute
    }
    '/_auth/sku-store/$siteId/$skuId/media': {
      id: '/_auth/sku-store/$siteId/$skuId/media'
      path: '/media'
      fullPath: '/sku-store/$siteId/$skuId/media'
      preLoaderRoute: typeof AuthSkuStoreSiteIdSkuIdMediaRouteImport
      parentRoute: typeof AuthSkuStoreSiteIdSkuIdRouteRoute
    }
    '/_auth/sku-store/$siteId/$skuId/mapping': {
      id: '/_auth/sku-store/$siteId/$skuId/mapping'
      path: '/mapping'
      fullPath: '/sku-store/$siteId/$skuId/mapping'
      preLoaderRoute: typeof AuthSkuStoreSiteIdSkuIdMappingRouteImport
      parentRoute: typeof AuthSkuStoreSiteIdSkuIdRouteRoute
    }
    '/_auth/sku-store/$siteId/$skuId/engagement': {
      id: '/_auth/sku-store/$siteId/$skuId/engagement'
      path: '/engagement'
      fullPath: '/sku-store/$siteId/$skuId/engagement'
      preLoaderRoute: typeof AuthSkuStoreSiteIdSkuIdEngagementRouteImport
      parentRoute: typeof AuthSkuStoreSiteIdSkuIdRouteRoute
    }
    '/_auth/sku-store/$siteId/$skuId/copy': {
      id: '/_auth/sku-store/$siteId/$skuId/copy'
      path: '/copy'
      fullPath: '/sku-store/$siteId/$skuId/copy'
      preLoaderRoute: typeof AuthSkuStoreSiteIdSkuIdCopyRouteImport
      parentRoute: typeof AuthSkuStoreSiteIdSkuIdRouteRoute
    }
    '/_auth/sku-store/$siteId/$skuId/associations': {
      id: '/_auth/sku-store/$siteId/$skuId/associations'
      path: '/associations'
      fullPath: '/sku-store/$siteId/$skuId/associations'
      preLoaderRoute: typeof AuthSkuStoreSiteIdSkuIdAssociationsRouteImport
      parentRoute: typeof AuthSkuStoreSiteIdSkuIdRouteRoute
    }
    '/_auth/settings/$siteId/coupon-codes/new': {
      id: '/_auth/settings/$siteId/coupon-codes/new'
      path: '/new'
      fullPath: '/settings/$siteId/coupon-codes/new'
      preLoaderRoute: typeof AuthSettingsSiteIdCouponCodesNewRouteImport
      parentRoute: typeof AuthSettingsSiteIdCouponCodesRouteRoute
    }
    '/_auth/settings/$siteId/coupon-codes/add-codes': {
      id: '/_auth/settings/$siteId/coupon-codes/add-codes'
      path: '/add-codes'
      fullPath: '/settings/$siteId/coupon-codes/add-codes'
      preLoaderRoute: typeof AuthSettingsSiteIdCouponCodesAddCodesRouteImport
      parentRoute: typeof AuthSettingsSiteIdCouponCodesRouteRoute
    }
    '/_auth/settings/$siteId/connectors/installed': {
      id: '/_auth/settings/$siteId/connectors/installed'
      path: '/installed'
      fullPath: '/settings/$siteId/connectors/installed'
      preLoaderRoute: typeof AuthSettingsSiteIdConnectorsInstalledRouteImport
      parentRoute: typeof AuthSettingsSiteIdConnectorsRouteRoute
    }
    '/_auth/settings/$siteId/connectors/all': {
      id: '/_auth/settings/$siteId/connectors/all'
      path: '/all'
      fullPath: '/settings/$siteId/connectors/all'
      preLoaderRoute: typeof AuthSettingsSiteIdConnectorsAllRouteImport
      parentRoute: typeof AuthSettingsSiteIdConnectorsRouteRoute
    }
    '/_auth/settings/$siteId/connectors/$connectorId': {
      id: '/_auth/settings/$siteId/connectors/$connectorId'
      path: '/$connectorId'
      fullPath: '/settings/$siteId/connectors/$connectorId'
      preLoaderRoute: typeof AuthSettingsSiteIdConnectorsConnectorIdRouteImport
      parentRoute: typeof AuthSettingsSiteIdConnectorsRouteRoute
    }
    '/_auth/settings/$siteId/_zeroAdmin/copy-frames': {
      id: '/_auth/settings/$siteId/_zeroAdmin/copy-frames'
      path: '/copy-frames'
      fullPath: '/settings/$siteId/copy-frames'
      preLoaderRoute: typeof AuthSettingsSiteIdZeroAdminCopyFramesRouteImport
      parentRoute: typeof AuthSettingsSiteIdZeroAdminRouteRoute
    }
    '/_auth/people/$siteId/lists/$listId': {
      id: '/_auth/people/$siteId/lists/$listId'
      path: '/$listId'
      fullPath: '/people/$siteId/lists/$listId'
      preLoaderRoute: typeof AuthPeopleSiteIdListsListIdRouteImport
      parentRoute: typeof AuthPeopleSiteIdListsRouteRoute
    }
    '/_auth/people/$siteId/audiences/new': {
      id: '/_auth/people/$siteId/audiences/new'
      path: '/new'
      fullPath: '/people/$siteId/audiences/new'
      preLoaderRoute: typeof AuthPeopleSiteIdAudiencesNewRouteImport
      parentRoute: typeof AuthPeopleSiteIdAudiencesRouteRoute
    }
    '/_auth/people/$siteId/audiences/exports': {
      id: '/_auth/people/$siteId/audiences/exports'
      path: '/exports'
      fullPath: '/people/$siteId/audiences/exports'
      preLoaderRoute: typeof AuthPeopleSiteIdAudiencesExportsRouteImport
      parentRoute: typeof AuthPeopleSiteIdAudiencesRouteRoute
    }
    '/_auth/exchanges/$siteId/$id/edit': {
      id: '/_auth/exchanges/$siteId/$id/edit'
      path: '/$id/edit'
      fullPath: '/exchanges/$siteId/$id/edit'
      preLoaderRoute: typeof AuthExchangesSiteIdIdEditRouteImport
      parentRoute: typeof AuthExchangesSiteIdRouteRoute
    }
    '/_auth/dragon-tiles/$siteId/new/$variant': {
      id: '/_auth/dragon-tiles/$siteId/new/$variant'
      path: '/new/$variant'
      fullPath: '/dragon-tiles/$siteId/new/$variant'
      preLoaderRoute: typeof AuthDragonTilesSiteIdNewVariantRouteImport
      parentRoute: typeof AuthDragonTilesSiteIdRouteRoute
    }
    '/_auth/dragon-tiles/$siteId/connectors/$parentTile': {
      id: '/_auth/dragon-tiles/$siteId/connectors/$parentTile'
      path: '/$parentTile'
      fullPath: '/dragon-tiles/$siteId/connectors/$parentTile'
      preLoaderRoute: typeof AuthDragonTilesSiteIdConnectorsParentTileRouteImport
      parentRoute: typeof AuthDragonTilesSiteIdConnectorsRouteRoute
    }
    '/_auth/dragon-tiles/$siteId/broadcast/list': {
      id: '/_auth/dragon-tiles/$siteId/broadcast/list'
      path: '/list'
      fullPath: '/dragon-tiles/$siteId/broadcast/list'
      preLoaderRoute: typeof AuthDragonTilesSiteIdBroadcastListRouteImport
      parentRoute: typeof AuthDragonTilesSiteIdBroadcastRouteRoute
    }
    '/_auth/dragon-tiles/$siteId/$frameId/$variant': {
      id: '/_auth/dragon-tiles/$siteId/$frameId/$variant'
      path: '/$frameId/$variant'
      fullPath: '/dragon-tiles/$siteId/$frameId/$variant'
      preLoaderRoute: typeof AuthDragonTilesSiteIdFrameIdVariantRouteImport
      parentRoute: typeof AuthDragonTilesSiteIdRouteRoute
    }
    '/_auth/connectors/$siteId/yotpo/install': {
      id: '/_auth/connectors/$siteId/yotpo/install'
      path: '/connectors/$siteId/yotpo/install'
      fullPath: '/connectors/$siteId/yotpo/install'
      preLoaderRoute: typeof AuthConnectorsSiteIdYotpoInstallRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/besties/$siteId/onboarding_/$brandId': {
      id: '/_auth/besties/$siteId/onboarding_/$brandId'
      path: '/onboarding/$brandId'
      fullPath: '/besties/$siteId/onboarding/$brandId'
      preLoaderRoute: typeof AuthBestiesSiteIdOnboardingBrandIdRouteImport
      parentRoute: typeof AuthBestiesSiteIdRouteRoute
    }
    '/_auth/people/$siteId/profiles/$profileId': {
      id: '/_auth/people/$siteId/profiles/$profileId'
      path: '/$profileId'
      fullPath: '/people/$siteId/profiles/$profileId'
      preLoaderRoute: typeof AuthPeopleSiteIdProfilesProfileIdRouteRouteImport
      parentRoute: typeof AuthPeopleSiteIdProfilesRouteRoute
    }
    '/_auth/generations/$siteId/new/pilot': {
      id: '/_auth/generations/$siteId/new/pilot'
      path: '/new/pilot'
      fullPath: '/generations/$siteId/new/pilot'
      preLoaderRoute: typeof AuthGenerationsSiteIdNewPilotRouteRouteImport
      parentRoute: typeof AuthGenerationsSiteIdRouteRoute
    }
    '/_auth/generations/$siteId/new/collection': {
      id: '/_auth/generations/$siteId/new/collection'
      path: '/new/collection'
      fullPath: '/generations/$siteId/new/collection'
      preLoaderRoute: typeof AuthGenerationsSiteIdNewCollectionRouteRouteImport
      parentRoute: typeof AuthGenerationsSiteIdRouteRoute
    }
    '/_auth/sku-store/$siteId/$skuId/stories/': {
      id: '/_auth/sku-store/$siteId/$skuId/stories/'
      path: '/stories'
      fullPath: '/sku-store/$siteId/$skuId/stories/'
      preLoaderRoute: typeof AuthSkuStoreSiteIdSkuIdStoriesIndexRouteImport
      parentRoute: typeof AuthSkuStoreSiteIdSkuIdRouteRoute
    }
    '/_auth/settings/$siteId/_zeroAdmin/sites/': {
      id: '/_auth/settings/$siteId/_zeroAdmin/sites/'
      path: '/sites'
      fullPath: '/settings/$siteId/sites/'
      preLoaderRoute: typeof AuthSettingsSiteIdZeroAdminSitesIndexRouteImport
      parentRoute: typeof AuthSettingsSiteIdZeroAdminRouteRoute
    }
    '/_auth/settings/$siteId/_zeroAdmin/onboarding/': {
      id: '/_auth/settings/$siteId/_zeroAdmin/onboarding/'
      path: '/onboarding'
      fullPath: '/settings/$siteId/onboarding/'
      preLoaderRoute: typeof AuthSettingsSiteIdZeroAdminOnboardingIndexRouteImport
      parentRoute: typeof AuthSettingsSiteIdZeroAdminRouteRoute
    }
    '/_auth/settings/$siteId/_zeroAdmin/notifications/': {
      id: '/_auth/settings/$siteId/_zeroAdmin/notifications/'
      path: '/notifications'
      fullPath: '/settings/$siteId/notifications/'
      preLoaderRoute: typeof AuthSettingsSiteIdZeroAdminNotificationsIndexRouteImport
      parentRoute: typeof AuthSettingsSiteIdZeroAdminRouteRoute
    }
    '/_auth/settings/$siteId/_zeroAdmin/notification-rejects/': {
      id: '/_auth/settings/$siteId/_zeroAdmin/notification-rejects/'
      path: '/notification-rejects'
      fullPath: '/settings/$siteId/notification-rejects/'
      preLoaderRoute: typeof AuthSettingsSiteIdZeroAdminNotificationRejectsIndexRouteImport
      parentRoute: typeof AuthSettingsSiteIdZeroAdminRouteRoute
    }
    '/_auth/settings/$siteId/_zeroAdmin/blueprints/': {
      id: '/_auth/settings/$siteId/_zeroAdmin/blueprints/'
      path: '/blueprints'
      fullPath: '/settings/$siteId/blueprints/'
      preLoaderRoute: typeof AuthSettingsSiteIdZeroAdminBlueprintsIndexRouteImport
      parentRoute: typeof AuthSettingsSiteIdZeroAdminRouteRoute
    }
    '/_auth/settings/$siteId/_zeroAdmin/accounts/': {
      id: '/_auth/settings/$siteId/_zeroAdmin/accounts/'
      path: '/accounts'
      fullPath: '/settings/$siteId/accounts/'
      preLoaderRoute: typeof AuthSettingsSiteIdZeroAdminAccountsIndexRouteImport
      parentRoute: typeof AuthSettingsSiteIdZeroAdminRouteRoute
    }
    '/_auth/people/$siteId/profiles/$profileId/': {
      id: '/_auth/people/$siteId/profiles/$profileId/'
      path: '/'
      fullPath: '/people/$siteId/profiles/$profileId/'
      preLoaderRoute: typeof AuthPeopleSiteIdProfilesProfileIdIndexRouteImport
      parentRoute: typeof AuthPeopleSiteIdProfilesProfileIdRouteRoute
    }
    '/_auth/people/$siteId/lists/$listId/': {
      id: '/_auth/people/$siteId/lists/$listId/'
      path: '/'
      fullPath: '/people/$siteId/lists/$listId/'
      preLoaderRoute: typeof AuthPeopleSiteIdListsListIdIndexRouteImport
      parentRoute: typeof AuthPeopleSiteIdListsListIdRoute
    }
    '/_auth/sku-store/$siteId/$skuId/stories/new': {
      id: '/_auth/sku-store/$siteId/$skuId/stories/new'
      path: '/stories/new'
      fullPath: '/sku-store/$siteId/$skuId/stories/new'
      preLoaderRoute: typeof AuthSkuStoreSiteIdSkuIdStoriesNewRouteImport
      parentRoute: typeof AuthSkuStoreSiteIdSkuIdRouteRoute
    }
    '/_auth/settings/$siteId/coupon-codes/new/unique': {
      id: '/_auth/settings/$siteId/coupon-codes/new/unique'
      path: '/unique'
      fullPath: '/settings/$siteId/coupon-codes/new/unique'
      preLoaderRoute: typeof AuthSettingsSiteIdCouponCodesNewUniqueRouteImport
      parentRoute: typeof AuthSettingsSiteIdCouponCodesNewRoute
    }
    '/_auth/settings/$siteId/coupon-codes/new/static': {
      id: '/_auth/settings/$siteId/coupon-codes/new/static'
      path: '/static'
      fullPath: '/settings/$siteId/coupon-codes/new/static'
      preLoaderRoute: typeof AuthSettingsSiteIdCouponCodesNewStaticRouteImport
      parentRoute: typeof AuthSettingsSiteIdCouponCodesNewRoute
    }
    '/_auth/settings/$siteId/coupon-codes/edit/$offerSlug': {
      id: '/_auth/settings/$siteId/coupon-codes/edit/$offerSlug'
      path: '/edit/$offerSlug'
      fullPath: '/settings/$siteId/coupon-codes/edit/$offerSlug'
      preLoaderRoute: typeof AuthSettingsSiteIdCouponCodesEditOfferSlugRouteImport
      parentRoute: typeof AuthSettingsSiteIdCouponCodesRouteRoute
    }
    '/_auth/settings/$siteId/_zeroAdmin/sites/$rjId': {
      id: '/_auth/settings/$siteId/_zeroAdmin/sites/$rjId'
      path: '/sites/$rjId'
      fullPath: '/settings/$siteId/sites/$rjId'
      preLoaderRoute: typeof AuthSettingsSiteIdZeroAdminSitesRjIdRouteImport
      parentRoute: typeof AuthSettingsSiteIdZeroAdminRouteRoute
    }
    '/_auth/settings/$siteId/_zeroAdmin/blueprints/$blueprintId': {
      id: '/_auth/settings/$siteId/_zeroAdmin/blueprints/$blueprintId'
      path: '/blueprints/$blueprintId'
      fullPath: '/settings/$siteId/blueprints/$blueprintId'
      preLoaderRoute: typeof AuthSettingsSiteIdZeroAdminBlueprintsBlueprintIdRouteImport
      parentRoute: typeof AuthSettingsSiteIdZeroAdminRouteRoute
    }
    '/_auth/settings/$siteId/_zeroAdmin/accounts/$accountId': {
      id: '/_auth/settings/$siteId/_zeroAdmin/accounts/$accountId'
      path: '/accounts/$accountId'
      fullPath: '/settings/$siteId/accounts/$accountId'
      preLoaderRoute: typeof AuthSettingsSiteIdZeroAdminAccountsAccountIdRouteImport
      parentRoute: typeof AuthSettingsSiteIdZeroAdminRouteRoute
    }
    '/_auth/people/$siteId/audiences/$audienceId/edit': {
      id: '/_auth/people/$siteId/audiences/$audienceId/edit'
      path: '/$audienceId/edit'
      fullPath: '/people/$siteId/audiences/$audienceId/edit'
      preLoaderRoute: typeof AuthPeopleSiteIdAudiencesAudienceIdEditRouteImport
      parentRoute: typeof AuthPeopleSiteIdAudiencesRouteRoute
    }
    '/_auth/genlab/$siteId/presets/edit/$presetId': {
      id: '/_auth/genlab/$siteId/presets/edit/$presetId'
      path: '/presets/edit/$presetId'
      fullPath: '/genlab/$siteId/presets/edit/$presetId'
      preLoaderRoute: typeof AuthGenlabSiteIdPresetsEditPresetIdRouteImport
      parentRoute: typeof AuthGenlabSiteIdRouteRoute
    }
    '/_auth/generations/$siteId/new/pilot/$stepId': {
      id: '/_auth/generations/$siteId/new/pilot/$stepId'
      path: '/$stepId'
      fullPath: '/generations/$siteId/new/pilot/$stepId'
      preLoaderRoute: typeof AuthGenerationsSiteIdNewPilotStepIdRouteImport
      parentRoute: typeof AuthGenerationsSiteIdNewPilotRouteRoute
    }
    '/_auth/generations/$siteId/new/collection/$stepId': {
      id: '/_auth/generations/$siteId/new/collection/$stepId'
      path: '/$stepId'
      fullPath: '/generations/$siteId/new/collection/$stepId'
      preLoaderRoute: typeof AuthGenerationsSiteIdNewCollectionStepIdRouteImport
      parentRoute: typeof AuthGenerationsSiteIdNewCollectionRouteRoute
    }
    '/_auth/dragon-tiles/$siteId/byoc/tile/$frameId': {
      id: '/_auth/dragon-tiles/$siteId/byoc/tile/$frameId'
      path: '/tile/$frameId'
      fullPath: '/dragon-tiles/$siteId/byoc/tile/$frameId'
      preLoaderRoute: typeof AuthDragonTilesSiteIdByocTileFrameIdRouteImport
      parentRoute: typeof AuthDragonTilesSiteIdByocRouteRoute
    }
    '/_auth/dragon-tiles/$siteId/broadcastV2/new/sms': {
      id: '/_auth/dragon-tiles/$siteId/broadcastV2/new/sms'
      path: '/new/sms'
      fullPath: '/dragon-tiles/$siteId/broadcastV2/new/sms'
      preLoaderRoute: typeof AuthDragonTilesSiteIdBroadcastV2NewSmsRouteImport
      parentRoute: typeof AuthDragonTilesSiteIdBroadcastV2RouteRoute
    }
    '/_auth/dragon-tiles/$siteId/broadcastV2/new/email': {
      id: '/_auth/dragon-tiles/$siteId/broadcastV2/new/email'
      path: '/new/email'
      fullPath: '/dragon-tiles/$siteId/broadcastV2/new/email'
      preLoaderRoute: typeof AuthDragonTilesSiteIdBroadcastV2NewEmailRouteImport
      parentRoute: typeof AuthDragonTilesSiteIdBroadcastV2RouteRoute
    }
    '/_auth/dragon-tiles/$siteId/broadcastV2/$broadcastId/sms': {
      id: '/_auth/dragon-tiles/$siteId/broadcastV2/$broadcastId/sms'
      path: '/$broadcastId/sms'
      fullPath: '/dragon-tiles/$siteId/broadcastV2/$broadcastId/sms'
      preLoaderRoute: typeof AuthDragonTilesSiteIdBroadcastV2BroadcastIdSmsRouteImport
      parentRoute: typeof AuthDragonTilesSiteIdBroadcastV2RouteRoute
    }
    '/_auth/dragon-tiles/$siteId/broadcastV2/$broadcastId/email': {
      id: '/_auth/dragon-tiles/$siteId/broadcastV2/$broadcastId/email'
      path: '/$broadcastId/email'
      fullPath: '/dragon-tiles/$siteId/broadcastV2/$broadcastId/email'
      preLoaderRoute: typeof AuthDragonTilesSiteIdBroadcastV2BroadcastIdEmailRouteImport
      parentRoute: typeof AuthDragonTilesSiteIdBroadcastV2RouteRoute
    }
    '/_auth/dragon-tiles/$siteId/$parentTile/tile/$frameId': {
      id: '/_auth/dragon-tiles/$siteId/$parentTile/tile/$frameId'
      path: '/tile/$frameId'
      fullPath: '/dragon-tiles/$siteId/$parentTile/tile/$frameId'
      preLoaderRoute: typeof AuthDragonTilesSiteIdParentTileTileFrameIdRouteImport
      parentRoute: typeof AuthDragonTilesSiteIdParentTileRouteRoute
    }
    '/_auth/people/$siteId/audiences/$audienceId/members/': {
      id: '/_auth/people/$siteId/audiences/$audienceId/members/'
      path: '/$audienceId/members'
      fullPath: '/people/$siteId/audiences/$audienceId/members/'
      preLoaderRoute: typeof AuthPeopleSiteIdAudiencesAudienceIdMembersIndexRouteImport
      parentRoute: typeof AuthPeopleSiteIdAudiencesRouteRoute
    }
    '/_auth/sku-store/$siteId/$skuId/stories/edit/$storyId': {
      id: '/_auth/sku-store/$siteId/$skuId/stories/edit/$storyId'
      path: '/stories/edit/$storyId'
      fullPath: '/sku-store/$siteId/$skuId/stories/edit/$storyId'
      preLoaderRoute: typeof AuthSkuStoreSiteIdSkuIdStoriesEditStoryIdRouteImport
      parentRoute: typeof AuthSkuStoreSiteIdSkuIdRouteRoute
    }
    '/_auth/settings/$siteId/coupon-codes/new/unique/shopify': {
      id: '/_auth/settings/$siteId/coupon-codes/new/unique/shopify'
      path: '/shopify'
      fullPath: '/settings/$siteId/coupon-codes/new/unique/shopify'
      preLoaderRoute: typeof AuthSettingsSiteIdCouponCodesNewUniqueShopifyRouteImport
      parentRoute: typeof AuthSettingsSiteIdCouponCodesNewUniqueRoute
    }
    '/_auth/settings/$siteId/coupon-codes/new/unique/foxy': {
      id: '/_auth/settings/$siteId/coupon-codes/new/unique/foxy'
      path: '/foxy'
      fullPath: '/settings/$siteId/coupon-codes/new/unique/foxy'
      preLoaderRoute: typeof AuthSettingsSiteIdCouponCodesNewUniqueFoxyRouteImport
      parentRoute: typeof AuthSettingsSiteIdCouponCodesNewUniqueRoute
    }
    '/_auth/settings/$siteId/coupon-codes/new/unique/csv': {
      id: '/_auth/settings/$siteId/coupon-codes/new/unique/csv'
      path: '/csv'
      fullPath: '/settings/$siteId/coupon-codes/new/unique/csv'
      preLoaderRoute: typeof AuthSettingsSiteIdCouponCodesNewUniqueCsvRouteImport
      parentRoute: typeof AuthSettingsSiteIdCouponCodesNewUniqueRoute
    }
    '/_auth/genlab/$siteId/presets/scene/edit/$presetId': {
      id: '/_auth/genlab/$siteId/presets/scene/edit/$presetId'
      path: '/presets/scene/edit/$presetId'
      fullPath: '/genlab/$siteId/presets/scene/edit/$presetId'
      preLoaderRoute: typeof AuthGenlabSiteIdPresetsSceneEditPresetIdRouteImport
      parentRoute: typeof AuthGenlabSiteIdRouteRoute
    }
    '/_auth/genlab/$siteId/presets/composition/edit/$presetId': {
      id: '/_auth/genlab/$siteId/presets/composition/edit/$presetId'
      path: '/presets/composition/edit/$presetId'
      fullPath: '/genlab/$siteId/presets/composition/edit/$presetId'
      preLoaderRoute: typeof AuthGenlabSiteIdPresetsCompositionEditPresetIdRouteImport
      parentRoute: typeof AuthGenlabSiteIdRouteRoute
    }
    '/_auth/genlab/$siteId/presets/casting/edit/$presetId': {
      id: '/_auth/genlab/$siteId/presets/casting/edit/$presetId'
      path: '/presets/casting/edit/$presetId'
      fullPath: '/genlab/$siteId/presets/casting/edit/$presetId'
      preLoaderRoute: typeof AuthGenlabSiteIdPresetsCastingEditPresetIdRouteImport
      parentRoute: typeof AuthGenlabSiteIdRouteRoute
    }
    '/_auth/dragon-tiles/$siteId/connectors/$parentTile/tile/$frameId': {
      id: '/_auth/dragon-tiles/$siteId/connectors/$parentTile/tile/$frameId'
      path: '/tile/$frameId'
      fullPath: '/dragon-tiles/$siteId/connectors/$parentTile/tile/$frameId'
      preLoaderRoute: typeof AuthDragonTilesSiteIdConnectorsParentTileTileFrameIdRouteImport
      parentRoute: typeof AuthDragonTilesSiteIdConnectorsParentTileRoute
    }
  }
}

interface AuthAssetsSiteIdRouteRouteChildren {
  AuthAssetsSiteIdAssetKeyRoute: typeof AuthAssetsSiteIdAssetKeyRoute
}

const AuthAssetsSiteIdRouteRouteChildren: AuthAssetsSiteIdRouteRouteChildren = {
  AuthAssetsSiteIdAssetKeyRoute: AuthAssetsSiteIdAssetKeyRoute,
}

const AuthAssetsSiteIdRouteRouteWithChildren =
  AuthAssetsSiteIdRouteRoute._addFileChildren(
    AuthAssetsSiteIdRouteRouteChildren,
  )

interface AuthBestiesSiteIdRouteRouteChildren {
  AuthBestiesSiteIdOnboardingRoute: typeof AuthBestiesSiteIdOnboardingRoute
  AuthBestiesSiteIdReportingRoute: typeof AuthBestiesSiteIdReportingRoute
  AuthBestiesSiteIdRevenueRoute: typeof AuthBestiesSiteIdRevenueRoute
  AuthBestiesSiteIdIndexRoute: typeof AuthBestiesSiteIdIndexRoute
  AuthBestiesSiteIdOnboardingBrandIdRoute: typeof AuthBestiesSiteIdOnboardingBrandIdRoute
}

const AuthBestiesSiteIdRouteRouteChildren: AuthBestiesSiteIdRouteRouteChildren =
  {
    AuthBestiesSiteIdOnboardingRoute: AuthBestiesSiteIdOnboardingRoute,
    AuthBestiesSiteIdReportingRoute: AuthBestiesSiteIdReportingRoute,
    AuthBestiesSiteIdRevenueRoute: AuthBestiesSiteIdRevenueRoute,
    AuthBestiesSiteIdIndexRoute: AuthBestiesSiteIdIndexRoute,
    AuthBestiesSiteIdOnboardingBrandIdRoute:
      AuthBestiesSiteIdOnboardingBrandIdRoute,
  }

const AuthBestiesSiteIdRouteRouteWithChildren =
  AuthBestiesSiteIdRouteRoute._addFileChildren(
    AuthBestiesSiteIdRouteRouteChildren,
  )

interface AuthCreativeSphereSiteIdRouteRouteChildren {
  AuthCreativeSphereSiteIdIndexRoute: typeof AuthCreativeSphereSiteIdIndexRoute
}

const AuthCreativeSphereSiteIdRouteRouteChildren: AuthCreativeSphereSiteIdRouteRouteChildren =
  {
    AuthCreativeSphereSiteIdIndexRoute: AuthCreativeSphereSiteIdIndexRoute,
  }

const AuthCreativeSphereSiteIdRouteRouteWithChildren =
  AuthCreativeSphereSiteIdRouteRoute._addFileChildren(
    AuthCreativeSphereSiteIdRouteRouteChildren,
  )

interface AuthDimensionsSiteIdRouteRouteChildren {
  AuthDimensionsSiteIdExchangesRoute: typeof AuthDimensionsSiteIdExchangesRoute
  AuthDimensionsSiteIdPeopleRoute: typeof AuthDimensionsSiteIdPeopleRoute
  AuthDimensionsSiteIdIndexRoute: typeof AuthDimensionsSiteIdIndexRoute
}

const AuthDimensionsSiteIdRouteRouteChildren: AuthDimensionsSiteIdRouteRouteChildren =
  {
    AuthDimensionsSiteIdExchangesRoute: AuthDimensionsSiteIdExchangesRoute,
    AuthDimensionsSiteIdPeopleRoute: AuthDimensionsSiteIdPeopleRoute,
    AuthDimensionsSiteIdIndexRoute: AuthDimensionsSiteIdIndexRoute,
  }

const AuthDimensionsSiteIdRouteRouteWithChildren =
  AuthDimensionsSiteIdRouteRoute._addFileChildren(
    AuthDimensionsSiteIdRouteRouteChildren,
  )

interface AuthDragonTilesSiteIdParentTileRouteRouteChildren {
  AuthDragonTilesSiteIdParentTileTileFrameIdRoute: typeof AuthDragonTilesSiteIdParentTileTileFrameIdRoute
}

const AuthDragonTilesSiteIdParentTileRouteRouteChildren: AuthDragonTilesSiteIdParentTileRouteRouteChildren =
  {
    AuthDragonTilesSiteIdParentTileTileFrameIdRoute:
      AuthDragonTilesSiteIdParentTileTileFrameIdRoute,
  }

const AuthDragonTilesSiteIdParentTileRouteRouteWithChildren =
  AuthDragonTilesSiteIdParentTileRouteRoute._addFileChildren(
    AuthDragonTilesSiteIdParentTileRouteRouteChildren,
  )

interface AuthDragonTilesSiteIdBroadcastRouteRouteChildren {
  AuthDragonTilesSiteIdBroadcastListRoute: typeof AuthDragonTilesSiteIdBroadcastListRoute
}

const AuthDragonTilesSiteIdBroadcastRouteRouteChildren: AuthDragonTilesSiteIdBroadcastRouteRouteChildren =
  {
    AuthDragonTilesSiteIdBroadcastListRoute:
      AuthDragonTilesSiteIdBroadcastListRoute,
  }

const AuthDragonTilesSiteIdBroadcastRouteRouteWithChildren =
  AuthDragonTilesSiteIdBroadcastRouteRoute._addFileChildren(
    AuthDragonTilesSiteIdBroadcastRouteRouteChildren,
  )

interface AuthDragonTilesSiteIdBroadcastV2RouteRouteChildren {
  AuthDragonTilesSiteIdBroadcastV2BroadcastIdEmailRoute: typeof AuthDragonTilesSiteIdBroadcastV2BroadcastIdEmailRoute
  AuthDragonTilesSiteIdBroadcastV2BroadcastIdSmsRoute: typeof AuthDragonTilesSiteIdBroadcastV2BroadcastIdSmsRoute
  AuthDragonTilesSiteIdBroadcastV2NewEmailRoute: typeof AuthDragonTilesSiteIdBroadcastV2NewEmailRoute
  AuthDragonTilesSiteIdBroadcastV2NewSmsRoute: typeof AuthDragonTilesSiteIdBroadcastV2NewSmsRoute
}

const AuthDragonTilesSiteIdBroadcastV2RouteRouteChildren: AuthDragonTilesSiteIdBroadcastV2RouteRouteChildren =
  {
    AuthDragonTilesSiteIdBroadcastV2BroadcastIdEmailRoute:
      AuthDragonTilesSiteIdBroadcastV2BroadcastIdEmailRoute,
    AuthDragonTilesSiteIdBroadcastV2BroadcastIdSmsRoute:
      AuthDragonTilesSiteIdBroadcastV2BroadcastIdSmsRoute,
    AuthDragonTilesSiteIdBroadcastV2NewEmailRoute:
      AuthDragonTilesSiteIdBroadcastV2NewEmailRoute,
    AuthDragonTilesSiteIdBroadcastV2NewSmsRoute:
      AuthDragonTilesSiteIdBroadcastV2NewSmsRoute,
  }

const AuthDragonTilesSiteIdBroadcastV2RouteRouteWithChildren =
  AuthDragonTilesSiteIdBroadcastV2RouteRoute._addFileChildren(
    AuthDragonTilesSiteIdBroadcastV2RouteRouteChildren,
  )

interface AuthDragonTilesSiteIdByocRouteRouteChildren {
  AuthDragonTilesSiteIdByocTileFrameIdRoute: typeof AuthDragonTilesSiteIdByocTileFrameIdRoute
}

const AuthDragonTilesSiteIdByocRouteRouteChildren: AuthDragonTilesSiteIdByocRouteRouteChildren =
  {
    AuthDragonTilesSiteIdByocTileFrameIdRoute:
      AuthDragonTilesSiteIdByocTileFrameIdRoute,
  }

const AuthDragonTilesSiteIdByocRouteRouteWithChildren =
  AuthDragonTilesSiteIdByocRouteRoute._addFileChildren(
    AuthDragonTilesSiteIdByocRouteRouteChildren,
  )

interface AuthDragonTilesSiteIdConnectorsParentTileRouteChildren {
  AuthDragonTilesSiteIdConnectorsParentTileTileFrameIdRoute: typeof AuthDragonTilesSiteIdConnectorsParentTileTileFrameIdRoute
}

const AuthDragonTilesSiteIdConnectorsParentTileRouteChildren: AuthDragonTilesSiteIdConnectorsParentTileRouteChildren =
  {
    AuthDragonTilesSiteIdConnectorsParentTileTileFrameIdRoute:
      AuthDragonTilesSiteIdConnectorsParentTileTileFrameIdRoute,
  }

const AuthDragonTilesSiteIdConnectorsParentTileRouteWithChildren =
  AuthDragonTilesSiteIdConnectorsParentTileRoute._addFileChildren(
    AuthDragonTilesSiteIdConnectorsParentTileRouteChildren,
  )

interface AuthDragonTilesSiteIdConnectorsRouteRouteChildren {
  AuthDragonTilesSiteIdConnectorsParentTileRoute: typeof AuthDragonTilesSiteIdConnectorsParentTileRouteWithChildren
  AuthDragonTilesSiteIdConnectorsIndexRoute: typeof AuthDragonTilesSiteIdConnectorsIndexRoute
}

const AuthDragonTilesSiteIdConnectorsRouteRouteChildren: AuthDragonTilesSiteIdConnectorsRouteRouteChildren =
  {
    AuthDragonTilesSiteIdConnectorsParentTileRoute:
      AuthDragonTilesSiteIdConnectorsParentTileRouteWithChildren,
    AuthDragonTilesSiteIdConnectorsIndexRoute:
      AuthDragonTilesSiteIdConnectorsIndexRoute,
  }

const AuthDragonTilesSiteIdConnectorsRouteRouteWithChildren =
  AuthDragonTilesSiteIdConnectorsRouteRoute._addFileChildren(
    AuthDragonTilesSiteIdConnectorsRouteRouteChildren,
  )

interface AuthDragonTilesSiteIdRouteRouteChildren {
  AuthDragonTilesSiteIdParentTileRouteRoute: typeof AuthDragonTilesSiteIdParentTileRouteRouteWithChildren
  AuthDragonTilesSiteIdBroadcastRouteRoute: typeof AuthDragonTilesSiteIdBroadcastRouteRouteWithChildren
  AuthDragonTilesSiteIdBroadcastV2RouteRoute: typeof AuthDragonTilesSiteIdBroadcastV2RouteRouteWithChildren
  AuthDragonTilesSiteIdByocRouteRoute: typeof AuthDragonTilesSiteIdByocRouteRouteWithChildren
  AuthDragonTilesSiteIdConnectorsRouteRoute: typeof AuthDragonTilesSiteIdConnectorsRouteRouteWithChildren
  AuthDragonTilesSiteIdIndexRoute: typeof AuthDragonTilesSiteIdIndexRoute
  AuthDragonTilesSiteIdFrameIdVariantRoute: typeof AuthDragonTilesSiteIdFrameIdVariantRoute
  AuthDragonTilesSiteIdNewVariantRoute: typeof AuthDragonTilesSiteIdNewVariantRoute
}

const AuthDragonTilesSiteIdRouteRouteChildren: AuthDragonTilesSiteIdRouteRouteChildren =
  {
    AuthDragonTilesSiteIdParentTileRouteRoute:
      AuthDragonTilesSiteIdParentTileRouteRouteWithChildren,
    AuthDragonTilesSiteIdBroadcastRouteRoute:
      AuthDragonTilesSiteIdBroadcastRouteRouteWithChildren,
    AuthDragonTilesSiteIdBroadcastV2RouteRoute:
      AuthDragonTilesSiteIdBroadcastV2RouteRouteWithChildren,
    AuthDragonTilesSiteIdByocRouteRoute:
      AuthDragonTilesSiteIdByocRouteRouteWithChildren,
    AuthDragonTilesSiteIdConnectorsRouteRoute:
      AuthDragonTilesSiteIdConnectorsRouteRouteWithChildren,
    AuthDragonTilesSiteIdIndexRoute: AuthDragonTilesSiteIdIndexRoute,
    AuthDragonTilesSiteIdFrameIdVariantRoute:
      AuthDragonTilesSiteIdFrameIdVariantRoute,
    AuthDragonTilesSiteIdNewVariantRoute: AuthDragonTilesSiteIdNewVariantRoute,
  }

const AuthDragonTilesSiteIdRouteRouteWithChildren =
  AuthDragonTilesSiteIdRouteRoute._addFileChildren(
    AuthDragonTilesSiteIdRouteRouteChildren,
  )

interface AuthExchangesSiteIdRouteRouteChildren {
  AuthExchangesSiteIdNewRoute: typeof AuthExchangesSiteIdNewRoute
  AuthExchangesSiteIdIdEditRoute: typeof AuthExchangesSiteIdIdEditRoute
}

const AuthExchangesSiteIdRouteRouteChildren: AuthExchangesSiteIdRouteRouteChildren =
  {
    AuthExchangesSiteIdNewRoute: AuthExchangesSiteIdNewRoute,
    AuthExchangesSiteIdIdEditRoute: AuthExchangesSiteIdIdEditRoute,
  }

const AuthExchangesSiteIdRouteRouteWithChildren =
  AuthExchangesSiteIdRouteRoute._addFileChildren(
    AuthExchangesSiteIdRouteRouteChildren,
  )

interface AuthGenerationsSiteIdNewCollectionRouteRouteChildren {
  AuthGenerationsSiteIdNewCollectionStepIdRoute: typeof AuthGenerationsSiteIdNewCollectionStepIdRoute
}

const AuthGenerationsSiteIdNewCollectionRouteRouteChildren: AuthGenerationsSiteIdNewCollectionRouteRouteChildren =
  {
    AuthGenerationsSiteIdNewCollectionStepIdRoute:
      AuthGenerationsSiteIdNewCollectionStepIdRoute,
  }

const AuthGenerationsSiteIdNewCollectionRouteRouteWithChildren =
  AuthGenerationsSiteIdNewCollectionRouteRoute._addFileChildren(
    AuthGenerationsSiteIdNewCollectionRouteRouteChildren,
  )

interface AuthGenerationsSiteIdNewPilotRouteRouteChildren {
  AuthGenerationsSiteIdNewPilotStepIdRoute: typeof AuthGenerationsSiteIdNewPilotStepIdRoute
}

const AuthGenerationsSiteIdNewPilotRouteRouteChildren: AuthGenerationsSiteIdNewPilotRouteRouteChildren =
  {
    AuthGenerationsSiteIdNewPilotStepIdRoute:
      AuthGenerationsSiteIdNewPilotStepIdRoute,
  }

const AuthGenerationsSiteIdNewPilotRouteRouteWithChildren =
  AuthGenerationsSiteIdNewPilotRouteRoute._addFileChildren(
    AuthGenerationsSiteIdNewPilotRouteRouteChildren,
  )

interface AuthGenerationsSiteIdRouteRouteChildren {
  AuthGenerationsSiteIdIndexRoute: typeof AuthGenerationsSiteIdIndexRoute
  AuthGenerationsSiteIdNewCollectionRouteRoute: typeof AuthGenerationsSiteIdNewCollectionRouteRouteWithChildren
  AuthGenerationsSiteIdNewPilotRouteRoute: typeof AuthGenerationsSiteIdNewPilotRouteRouteWithChildren
}

const AuthGenerationsSiteIdRouteRouteChildren: AuthGenerationsSiteIdRouteRouteChildren =
  {
    AuthGenerationsSiteIdIndexRoute: AuthGenerationsSiteIdIndexRoute,
    AuthGenerationsSiteIdNewCollectionRouteRoute:
      AuthGenerationsSiteIdNewCollectionRouteRouteWithChildren,
    AuthGenerationsSiteIdNewPilotRouteRoute:
      AuthGenerationsSiteIdNewPilotRouteRouteWithChildren,
  }

const AuthGenerationsSiteIdRouteRouteWithChildren =
  AuthGenerationsSiteIdRouteRoute._addFileChildren(
    AuthGenerationsSiteIdRouteRouteChildren,
  )

interface AuthGenlabSiteIdRouteRouteChildren {
  AuthGenlabSiteIdIndexRoute: typeof AuthGenlabSiteIdIndexRoute
  AuthGenlabSiteIdPresetsEditPresetIdRoute: typeof AuthGenlabSiteIdPresetsEditPresetIdRoute
  AuthGenlabSiteIdPresetsCastingEditPresetIdRoute: typeof AuthGenlabSiteIdPresetsCastingEditPresetIdRoute
  AuthGenlabSiteIdPresetsCompositionEditPresetIdRoute: typeof AuthGenlabSiteIdPresetsCompositionEditPresetIdRoute
  AuthGenlabSiteIdPresetsSceneEditPresetIdRoute: typeof AuthGenlabSiteIdPresetsSceneEditPresetIdRoute
}

const AuthGenlabSiteIdRouteRouteChildren: AuthGenlabSiteIdRouteRouteChildren = {
  AuthGenlabSiteIdIndexRoute: AuthGenlabSiteIdIndexRoute,
  AuthGenlabSiteIdPresetsEditPresetIdRoute:
    AuthGenlabSiteIdPresetsEditPresetIdRoute,
  AuthGenlabSiteIdPresetsCastingEditPresetIdRoute:
    AuthGenlabSiteIdPresetsCastingEditPresetIdRoute,
  AuthGenlabSiteIdPresetsCompositionEditPresetIdRoute:
    AuthGenlabSiteIdPresetsCompositionEditPresetIdRoute,
  AuthGenlabSiteIdPresetsSceneEditPresetIdRoute:
    AuthGenlabSiteIdPresetsSceneEditPresetIdRoute,
}

const AuthGenlabSiteIdRouteRouteWithChildren =
  AuthGenlabSiteIdRouteRoute._addFileChildren(
    AuthGenlabSiteIdRouteRouteChildren,
  )

interface AuthMarketingCalendarSiteIdRouteRouteChildren {
  AuthMarketingCalendarSiteIdNewRoute: typeof AuthMarketingCalendarSiteIdNewRoute
  AuthMarketingCalendarSiteIdIndexRoute: typeof AuthMarketingCalendarSiteIdIndexRoute
}

const AuthMarketingCalendarSiteIdRouteRouteChildren: AuthMarketingCalendarSiteIdRouteRouteChildren =
  {
    AuthMarketingCalendarSiteIdNewRoute: AuthMarketingCalendarSiteIdNewRoute,
    AuthMarketingCalendarSiteIdIndexRoute:
      AuthMarketingCalendarSiteIdIndexRoute,
  }

const AuthMarketingCalendarSiteIdRouteRouteWithChildren =
  AuthMarketingCalendarSiteIdRouteRoute._addFileChildren(
    AuthMarketingCalendarSiteIdRouteRouteChildren,
  )

interface AuthPeopleSiteIdAudiencesRouteRouteChildren {
  AuthPeopleSiteIdAudiencesExportsRoute: typeof AuthPeopleSiteIdAudiencesExportsRoute
  AuthPeopleSiteIdAudiencesNewRoute: typeof AuthPeopleSiteIdAudiencesNewRoute
  AuthPeopleSiteIdAudiencesIndexRoute: typeof AuthPeopleSiteIdAudiencesIndexRoute
  AuthPeopleSiteIdAudiencesAudienceIdEditRoute: typeof AuthPeopleSiteIdAudiencesAudienceIdEditRoute
  AuthPeopleSiteIdAudiencesAudienceIdMembersIndexRoute: typeof AuthPeopleSiteIdAudiencesAudienceIdMembersIndexRoute
}

const AuthPeopleSiteIdAudiencesRouteRouteChildren: AuthPeopleSiteIdAudiencesRouteRouteChildren =
  {
    AuthPeopleSiteIdAudiencesExportsRoute:
      AuthPeopleSiteIdAudiencesExportsRoute,
    AuthPeopleSiteIdAudiencesNewRoute: AuthPeopleSiteIdAudiencesNewRoute,
    AuthPeopleSiteIdAudiencesIndexRoute: AuthPeopleSiteIdAudiencesIndexRoute,
    AuthPeopleSiteIdAudiencesAudienceIdEditRoute:
      AuthPeopleSiteIdAudiencesAudienceIdEditRoute,
    AuthPeopleSiteIdAudiencesAudienceIdMembersIndexRoute:
      AuthPeopleSiteIdAudiencesAudienceIdMembersIndexRoute,
  }

const AuthPeopleSiteIdAudiencesRouteRouteWithChildren =
  AuthPeopleSiteIdAudiencesRouteRoute._addFileChildren(
    AuthPeopleSiteIdAudiencesRouteRouteChildren,
  )

interface AuthPeopleSiteIdListsListIdRouteChildren {
  AuthPeopleSiteIdListsListIdIndexRoute: typeof AuthPeopleSiteIdListsListIdIndexRoute
}

const AuthPeopleSiteIdListsListIdRouteChildren: AuthPeopleSiteIdListsListIdRouteChildren =
  {
    AuthPeopleSiteIdListsListIdIndexRoute:
      AuthPeopleSiteIdListsListIdIndexRoute,
  }

const AuthPeopleSiteIdListsListIdRouteWithChildren =
  AuthPeopleSiteIdListsListIdRoute._addFileChildren(
    AuthPeopleSiteIdListsListIdRouteChildren,
  )

interface AuthPeopleSiteIdListsRouteRouteChildren {
  AuthPeopleSiteIdListsListIdRoute: typeof AuthPeopleSiteIdListsListIdRouteWithChildren
  AuthPeopleSiteIdListsIndexRoute: typeof AuthPeopleSiteIdListsIndexRoute
}

const AuthPeopleSiteIdListsRouteRouteChildren: AuthPeopleSiteIdListsRouteRouteChildren =
  {
    AuthPeopleSiteIdListsListIdRoute:
      AuthPeopleSiteIdListsListIdRouteWithChildren,
    AuthPeopleSiteIdListsIndexRoute: AuthPeopleSiteIdListsIndexRoute,
  }

const AuthPeopleSiteIdListsRouteRouteWithChildren =
  AuthPeopleSiteIdListsRouteRoute._addFileChildren(
    AuthPeopleSiteIdListsRouteRouteChildren,
  )

interface AuthPeopleSiteIdProfilesProfileIdRouteRouteChildren {
  AuthPeopleSiteIdProfilesProfileIdIndexRoute: typeof AuthPeopleSiteIdProfilesProfileIdIndexRoute
}

const AuthPeopleSiteIdProfilesProfileIdRouteRouteChildren: AuthPeopleSiteIdProfilesProfileIdRouteRouteChildren =
  {
    AuthPeopleSiteIdProfilesProfileIdIndexRoute:
      AuthPeopleSiteIdProfilesProfileIdIndexRoute,
  }

const AuthPeopleSiteIdProfilesProfileIdRouteRouteWithChildren =
  AuthPeopleSiteIdProfilesProfileIdRouteRoute._addFileChildren(
    AuthPeopleSiteIdProfilesProfileIdRouteRouteChildren,
  )

interface AuthPeopleSiteIdProfilesRouteRouteChildren {
  AuthPeopleSiteIdProfilesProfileIdRouteRoute: typeof AuthPeopleSiteIdProfilesProfileIdRouteRouteWithChildren
  AuthPeopleSiteIdProfilesIndexRoute: typeof AuthPeopleSiteIdProfilesIndexRoute
}

const AuthPeopleSiteIdProfilesRouteRouteChildren: AuthPeopleSiteIdProfilesRouteRouteChildren =
  {
    AuthPeopleSiteIdProfilesProfileIdRouteRoute:
      AuthPeopleSiteIdProfilesProfileIdRouteRouteWithChildren,
    AuthPeopleSiteIdProfilesIndexRoute: AuthPeopleSiteIdProfilesIndexRoute,
  }

const AuthPeopleSiteIdProfilesRouteRouteWithChildren =
  AuthPeopleSiteIdProfilesRouteRoute._addFileChildren(
    AuthPeopleSiteIdProfilesRouteRouteChildren,
  )

interface AuthPeopleSiteIdRouteRouteChildren {
  AuthPeopleSiteIdAudiencesRouteRoute: typeof AuthPeopleSiteIdAudiencesRouteRouteWithChildren
  AuthPeopleSiteIdListsRouteRoute: typeof AuthPeopleSiteIdListsRouteRouteWithChildren
  AuthPeopleSiteIdProfilesRouteRoute: typeof AuthPeopleSiteIdProfilesRouteRouteWithChildren
}

const AuthPeopleSiteIdRouteRouteChildren: AuthPeopleSiteIdRouteRouteChildren = {
  AuthPeopleSiteIdAudiencesRouteRoute:
    AuthPeopleSiteIdAudiencesRouteRouteWithChildren,
  AuthPeopleSiteIdListsRouteRoute: AuthPeopleSiteIdListsRouteRouteWithChildren,
  AuthPeopleSiteIdProfilesRouteRoute:
    AuthPeopleSiteIdProfilesRouteRouteWithChildren,
}

const AuthPeopleSiteIdRouteRouteWithChildren =
  AuthPeopleSiteIdRouteRoute._addFileChildren(
    AuthPeopleSiteIdRouteRouteChildren,
  )

interface AuthSettingsSiteIdZeroAdminRouteRouteChildren {
  AuthSettingsSiteIdZeroAdminCopyFramesRoute: typeof AuthSettingsSiteIdZeroAdminCopyFramesRoute
  AuthSettingsSiteIdZeroAdminAccountsAccountIdRoute: typeof AuthSettingsSiteIdZeroAdminAccountsAccountIdRoute
  AuthSettingsSiteIdZeroAdminBlueprintsBlueprintIdRoute: typeof AuthSettingsSiteIdZeroAdminBlueprintsBlueprintIdRoute
  AuthSettingsSiteIdZeroAdminSitesRjIdRoute: typeof AuthSettingsSiteIdZeroAdminSitesRjIdRoute
  AuthSettingsSiteIdZeroAdminAccountsIndexRoute: typeof AuthSettingsSiteIdZeroAdminAccountsIndexRoute
  AuthSettingsSiteIdZeroAdminBlueprintsIndexRoute: typeof AuthSettingsSiteIdZeroAdminBlueprintsIndexRoute
  AuthSettingsSiteIdZeroAdminNotificationRejectsIndexRoute: typeof AuthSettingsSiteIdZeroAdminNotificationRejectsIndexRoute
  AuthSettingsSiteIdZeroAdminNotificationsIndexRoute: typeof AuthSettingsSiteIdZeroAdminNotificationsIndexRoute
  AuthSettingsSiteIdZeroAdminOnboardingIndexRoute: typeof AuthSettingsSiteIdZeroAdminOnboardingIndexRoute
  AuthSettingsSiteIdZeroAdminSitesIndexRoute: typeof AuthSettingsSiteIdZeroAdminSitesIndexRoute
}

const AuthSettingsSiteIdZeroAdminRouteRouteChildren: AuthSettingsSiteIdZeroAdminRouteRouteChildren =
  {
    AuthSettingsSiteIdZeroAdminCopyFramesRoute:
      AuthSettingsSiteIdZeroAdminCopyFramesRoute,
    AuthSettingsSiteIdZeroAdminAccountsAccountIdRoute:
      AuthSettingsSiteIdZeroAdminAccountsAccountIdRoute,
    AuthSettingsSiteIdZeroAdminBlueprintsBlueprintIdRoute:
      AuthSettingsSiteIdZeroAdminBlueprintsBlueprintIdRoute,
    AuthSettingsSiteIdZeroAdminSitesRjIdRoute:
      AuthSettingsSiteIdZeroAdminSitesRjIdRoute,
    AuthSettingsSiteIdZeroAdminAccountsIndexRoute:
      AuthSettingsSiteIdZeroAdminAccountsIndexRoute,
    AuthSettingsSiteIdZeroAdminBlueprintsIndexRoute:
      AuthSettingsSiteIdZeroAdminBlueprintsIndexRoute,
    AuthSettingsSiteIdZeroAdminNotificationRejectsIndexRoute:
      AuthSettingsSiteIdZeroAdminNotificationRejectsIndexRoute,
    AuthSettingsSiteIdZeroAdminNotificationsIndexRoute:
      AuthSettingsSiteIdZeroAdminNotificationsIndexRoute,
    AuthSettingsSiteIdZeroAdminOnboardingIndexRoute:
      AuthSettingsSiteIdZeroAdminOnboardingIndexRoute,
    AuthSettingsSiteIdZeroAdminSitesIndexRoute:
      AuthSettingsSiteIdZeroAdminSitesIndexRoute,
  }

const AuthSettingsSiteIdZeroAdminRouteRouteWithChildren =
  AuthSettingsSiteIdZeroAdminRouteRoute._addFileChildren(
    AuthSettingsSiteIdZeroAdminRouteRouteChildren,
  )

interface AuthSettingsSiteIdConnectorsRouteRouteChildren {
  AuthSettingsSiteIdConnectorsConnectorIdRoute: typeof AuthSettingsSiteIdConnectorsConnectorIdRoute
  AuthSettingsSiteIdConnectorsAllRoute: typeof AuthSettingsSiteIdConnectorsAllRoute
  AuthSettingsSiteIdConnectorsInstalledRoute: typeof AuthSettingsSiteIdConnectorsInstalledRoute
  AuthSettingsSiteIdConnectorsIndexRoute: typeof AuthSettingsSiteIdConnectorsIndexRoute
}

const AuthSettingsSiteIdConnectorsRouteRouteChildren: AuthSettingsSiteIdConnectorsRouteRouteChildren =
  {
    AuthSettingsSiteIdConnectorsConnectorIdRoute:
      AuthSettingsSiteIdConnectorsConnectorIdRoute,
    AuthSettingsSiteIdConnectorsAllRoute: AuthSettingsSiteIdConnectorsAllRoute,
    AuthSettingsSiteIdConnectorsInstalledRoute:
      AuthSettingsSiteIdConnectorsInstalledRoute,
    AuthSettingsSiteIdConnectorsIndexRoute:
      AuthSettingsSiteIdConnectorsIndexRoute,
  }

const AuthSettingsSiteIdConnectorsRouteRouteWithChildren =
  AuthSettingsSiteIdConnectorsRouteRoute._addFileChildren(
    AuthSettingsSiteIdConnectorsRouteRouteChildren,
  )

interface AuthSettingsSiteIdCouponCodesNewUniqueRouteChildren {
  AuthSettingsSiteIdCouponCodesNewUniqueCsvRoute: typeof AuthSettingsSiteIdCouponCodesNewUniqueCsvRoute
  AuthSettingsSiteIdCouponCodesNewUniqueFoxyRoute: typeof AuthSettingsSiteIdCouponCodesNewUniqueFoxyRoute
  AuthSettingsSiteIdCouponCodesNewUniqueShopifyRoute: typeof AuthSettingsSiteIdCouponCodesNewUniqueShopifyRoute
}

const AuthSettingsSiteIdCouponCodesNewUniqueRouteChildren: AuthSettingsSiteIdCouponCodesNewUniqueRouteChildren =
  {
    AuthSettingsSiteIdCouponCodesNewUniqueCsvRoute:
      AuthSettingsSiteIdCouponCodesNewUniqueCsvRoute,
    AuthSettingsSiteIdCouponCodesNewUniqueFoxyRoute:
      AuthSettingsSiteIdCouponCodesNewUniqueFoxyRoute,
    AuthSettingsSiteIdCouponCodesNewUniqueShopifyRoute:
      AuthSettingsSiteIdCouponCodesNewUniqueShopifyRoute,
  }

const AuthSettingsSiteIdCouponCodesNewUniqueRouteWithChildren =
  AuthSettingsSiteIdCouponCodesNewUniqueRoute._addFileChildren(
    AuthSettingsSiteIdCouponCodesNewUniqueRouteChildren,
  )

interface AuthSettingsSiteIdCouponCodesNewRouteChildren {
  AuthSettingsSiteIdCouponCodesNewStaticRoute: typeof AuthSettingsSiteIdCouponCodesNewStaticRoute
  AuthSettingsSiteIdCouponCodesNewUniqueRoute: typeof AuthSettingsSiteIdCouponCodesNewUniqueRouteWithChildren
}

const AuthSettingsSiteIdCouponCodesNewRouteChildren: AuthSettingsSiteIdCouponCodesNewRouteChildren =
  {
    AuthSettingsSiteIdCouponCodesNewStaticRoute:
      AuthSettingsSiteIdCouponCodesNewStaticRoute,
    AuthSettingsSiteIdCouponCodesNewUniqueRoute:
      AuthSettingsSiteIdCouponCodesNewUniqueRouteWithChildren,
  }

const AuthSettingsSiteIdCouponCodesNewRouteWithChildren =
  AuthSettingsSiteIdCouponCodesNewRoute._addFileChildren(
    AuthSettingsSiteIdCouponCodesNewRouteChildren,
  )

interface AuthSettingsSiteIdCouponCodesRouteRouteChildren {
  AuthSettingsSiteIdCouponCodesAddCodesRoute: typeof AuthSettingsSiteIdCouponCodesAddCodesRoute
  AuthSettingsSiteIdCouponCodesNewRoute: typeof AuthSettingsSiteIdCouponCodesNewRouteWithChildren
  AuthSettingsSiteIdCouponCodesEditOfferSlugRoute: typeof AuthSettingsSiteIdCouponCodesEditOfferSlugRoute
}

const AuthSettingsSiteIdCouponCodesRouteRouteChildren: AuthSettingsSiteIdCouponCodesRouteRouteChildren =
  {
    AuthSettingsSiteIdCouponCodesAddCodesRoute:
      AuthSettingsSiteIdCouponCodesAddCodesRoute,
    AuthSettingsSiteIdCouponCodesNewRoute:
      AuthSettingsSiteIdCouponCodesNewRouteWithChildren,
    AuthSettingsSiteIdCouponCodesEditOfferSlugRoute:
      AuthSettingsSiteIdCouponCodesEditOfferSlugRoute,
  }

const AuthSettingsSiteIdCouponCodesRouteRouteWithChildren =
  AuthSettingsSiteIdCouponCodesRouteRoute._addFileChildren(
    AuthSettingsSiteIdCouponCodesRouteRouteChildren,
  )

interface AuthSettingsSiteIdRouteRouteChildren {
  AuthSettingsSiteIdZeroAdminRouteRoute: typeof AuthSettingsSiteIdZeroAdminRouteRouteWithChildren
  AuthSettingsSiteIdConnectorsRouteRoute: typeof AuthSettingsSiteIdConnectorsRouteRouteWithChildren
  AuthSettingsSiteIdCouponCodesRouteRoute: typeof AuthSettingsSiteIdCouponCodesRouteRouteWithChildren
  AuthSettingsSiteIdBillingRoute: typeof AuthSettingsSiteIdBillingRoute
  AuthSettingsSiteIdEmailRoute: typeof AuthSettingsSiteIdEmailRoute
  AuthSettingsSiteIdFeatureFlagsRoute: typeof AuthSettingsSiteIdFeatureFlagsRoute
  AuthSettingsSiteIdGeneralRoute: typeof AuthSettingsSiteIdGeneralRoute
  AuthSettingsSiteIdMachineApplicationsRoute: typeof AuthSettingsSiteIdMachineApplicationsRoute
  AuthSettingsSiteIdMockConfigRoute: typeof AuthSettingsSiteIdMockConfigRoute
  AuthSettingsSiteIdRecommendationExclusionsRoute: typeof AuthSettingsSiteIdRecommendationExclusionsRoute
  AuthSettingsSiteIdReportingRoute: typeof AuthSettingsSiteIdReportingRoute
  AuthSettingsSiteIdSeedBestiesSitesRoute: typeof AuthSettingsSiteIdSeedBestiesSitesRoute
  AuthSettingsSiteIdSmsRegistrationRoute: typeof AuthSettingsSiteIdSmsRegistrationRoute
  AuthSettingsSiteIdTextRoute: typeof AuthSettingsSiteIdTextRoute
  AuthSettingsSiteIdIndexRoute: typeof AuthSettingsSiteIdIndexRoute
}

const AuthSettingsSiteIdRouteRouteChildren: AuthSettingsSiteIdRouteRouteChildren =
  {
    AuthSettingsSiteIdZeroAdminRouteRoute:
      AuthSettingsSiteIdZeroAdminRouteRouteWithChildren,
    AuthSettingsSiteIdConnectorsRouteRoute:
      AuthSettingsSiteIdConnectorsRouteRouteWithChildren,
    AuthSettingsSiteIdCouponCodesRouteRoute:
      AuthSettingsSiteIdCouponCodesRouteRouteWithChildren,
    AuthSettingsSiteIdBillingRoute: AuthSettingsSiteIdBillingRoute,
    AuthSettingsSiteIdEmailRoute: AuthSettingsSiteIdEmailRoute,
    AuthSettingsSiteIdFeatureFlagsRoute: AuthSettingsSiteIdFeatureFlagsRoute,
    AuthSettingsSiteIdGeneralRoute: AuthSettingsSiteIdGeneralRoute,
    AuthSettingsSiteIdMachineApplicationsRoute:
      AuthSettingsSiteIdMachineApplicationsRoute,
    AuthSettingsSiteIdMockConfigRoute: AuthSettingsSiteIdMockConfigRoute,
    AuthSettingsSiteIdRecommendationExclusionsRoute:
      AuthSettingsSiteIdRecommendationExclusionsRoute,
    AuthSettingsSiteIdReportingRoute: AuthSettingsSiteIdReportingRoute,
    AuthSettingsSiteIdSeedBestiesSitesRoute:
      AuthSettingsSiteIdSeedBestiesSitesRoute,
    AuthSettingsSiteIdSmsRegistrationRoute:
      AuthSettingsSiteIdSmsRegistrationRoute,
    AuthSettingsSiteIdTextRoute: AuthSettingsSiteIdTextRoute,
    AuthSettingsSiteIdIndexRoute: AuthSettingsSiteIdIndexRoute,
  }

const AuthSettingsSiteIdRouteRouteWithChildren =
  AuthSettingsSiteIdRouteRoute._addFileChildren(
    AuthSettingsSiteIdRouteRouteChildren,
  )

interface AuthSkuStoreSiteIdSkuIdRouteRouteChildren {
  AuthSkuStoreSiteIdSkuIdAssociationsRoute: typeof AuthSkuStoreSiteIdSkuIdAssociationsRoute
  AuthSkuStoreSiteIdSkuIdCopyRoute: typeof AuthSkuStoreSiteIdSkuIdCopyRoute
  AuthSkuStoreSiteIdSkuIdEngagementRoute: typeof AuthSkuStoreSiteIdSkuIdEngagementRoute
  AuthSkuStoreSiteIdSkuIdMappingRoute: typeof AuthSkuStoreSiteIdSkuIdMappingRoute
  AuthSkuStoreSiteIdSkuIdMediaRoute: typeof AuthSkuStoreSiteIdSkuIdMediaRoute
  AuthSkuStoreSiteIdSkuIdReviewsRoute: typeof AuthSkuStoreSiteIdSkuIdReviewsRoute
  AuthSkuStoreSiteIdSkuIdVariantsRoute: typeof AuthSkuStoreSiteIdSkuIdVariantsRoute
  AuthSkuStoreSiteIdSkuIdIndexRoute: typeof AuthSkuStoreSiteIdSkuIdIndexRoute
  AuthSkuStoreSiteIdSkuIdStoriesNewRoute: typeof AuthSkuStoreSiteIdSkuIdStoriesNewRoute
  AuthSkuStoreSiteIdSkuIdStoriesIndexRoute: typeof AuthSkuStoreSiteIdSkuIdStoriesIndexRoute
  AuthSkuStoreSiteIdSkuIdStoriesEditStoryIdRoute: typeof AuthSkuStoreSiteIdSkuIdStoriesEditStoryIdRoute
}

const AuthSkuStoreSiteIdSkuIdRouteRouteChildren: AuthSkuStoreSiteIdSkuIdRouteRouteChildren =
  {
    AuthSkuStoreSiteIdSkuIdAssociationsRoute:
      AuthSkuStoreSiteIdSkuIdAssociationsRoute,
    AuthSkuStoreSiteIdSkuIdCopyRoute: AuthSkuStoreSiteIdSkuIdCopyRoute,
    AuthSkuStoreSiteIdSkuIdEngagementRoute:
      AuthSkuStoreSiteIdSkuIdEngagementRoute,
    AuthSkuStoreSiteIdSkuIdMappingRoute: AuthSkuStoreSiteIdSkuIdMappingRoute,
    AuthSkuStoreSiteIdSkuIdMediaRoute: AuthSkuStoreSiteIdSkuIdMediaRoute,
    AuthSkuStoreSiteIdSkuIdReviewsRoute: AuthSkuStoreSiteIdSkuIdReviewsRoute,
    AuthSkuStoreSiteIdSkuIdVariantsRoute: AuthSkuStoreSiteIdSkuIdVariantsRoute,
    AuthSkuStoreSiteIdSkuIdIndexRoute: AuthSkuStoreSiteIdSkuIdIndexRoute,
    AuthSkuStoreSiteIdSkuIdStoriesNewRoute:
      AuthSkuStoreSiteIdSkuIdStoriesNewRoute,
    AuthSkuStoreSiteIdSkuIdStoriesIndexRoute:
      AuthSkuStoreSiteIdSkuIdStoriesIndexRoute,
    AuthSkuStoreSiteIdSkuIdStoriesEditStoryIdRoute:
      AuthSkuStoreSiteIdSkuIdStoriesEditStoryIdRoute,
  }

const AuthSkuStoreSiteIdSkuIdRouteRouteWithChildren =
  AuthSkuStoreSiteIdSkuIdRouteRoute._addFileChildren(
    AuthSkuStoreSiteIdSkuIdRouteRouteChildren,
  )

interface AuthSkuStoreSiteIdRouteRouteChildren {
  AuthSkuStoreSiteIdSkuIdRouteRoute: typeof AuthSkuStoreSiteIdSkuIdRouteRouteWithChildren
  AuthSkuStoreSiteIdMappingRoute: typeof AuthSkuStoreSiteIdMappingRoute
  AuthSkuStoreSiteIdIndexRoute: typeof AuthSkuStoreSiteIdIndexRoute
}

const AuthSkuStoreSiteIdRouteRouteChildren: AuthSkuStoreSiteIdRouteRouteChildren =
  {
    AuthSkuStoreSiteIdSkuIdRouteRoute:
      AuthSkuStoreSiteIdSkuIdRouteRouteWithChildren,
    AuthSkuStoreSiteIdMappingRoute: AuthSkuStoreSiteIdMappingRoute,
    AuthSkuStoreSiteIdIndexRoute: AuthSkuStoreSiteIdIndexRoute,
  }

const AuthSkuStoreSiteIdRouteRouteWithChildren =
  AuthSkuStoreSiteIdRouteRoute._addFileChildren(
    AuthSkuStoreSiteIdRouteRouteChildren,
  )

interface AuthBrandOnboardingSiteIdRouteChildren {
  AuthBrandOnboardingSiteIdStepIdRoute: typeof AuthBrandOnboardingSiteIdStepIdRoute
}

const AuthBrandOnboardingSiteIdRouteChildren: AuthBrandOnboardingSiteIdRouteChildren =
  {
    AuthBrandOnboardingSiteIdStepIdRoute: AuthBrandOnboardingSiteIdStepIdRoute,
  }

const AuthBrandOnboardingSiteIdRouteWithChildren =
  AuthBrandOnboardingSiteIdRoute._addFileChildren(
    AuthBrandOnboardingSiteIdRouteChildren,
  )

interface AuthRouteRouteChildren {
  AuthPreviewTestRoute: typeof AuthPreviewTestRoute
  AuthAssetsSiteIdRouteRoute: typeof AuthAssetsSiteIdRouteRouteWithChildren
  AuthBestiesSiteIdRouteRoute: typeof AuthBestiesSiteIdRouteRouteWithChildren
  AuthBlocksSiteIdRouteRoute: typeof AuthBlocksSiteIdRouteRoute
  AuthCreativeSphereSiteIdRouteRoute: typeof AuthCreativeSphereSiteIdRouteRouteWithChildren
  AuthDimensionsSiteIdRouteRoute: typeof AuthDimensionsSiteIdRouteRouteWithChildren
  AuthDragonTilesSiteIdRouteRoute: typeof AuthDragonTilesSiteIdRouteRouteWithChildren
  AuthExchangesSiteIdRouteRoute: typeof AuthExchangesSiteIdRouteRouteWithChildren
  AuthGenerationsSiteIdRouteRoute: typeof AuthGenerationsSiteIdRouteRouteWithChildren
  AuthGenlabSiteIdRouteRoute: typeof AuthGenlabSiteIdRouteRouteWithChildren
  AuthMarketingCalendarSiteIdRouteRoute: typeof AuthMarketingCalendarSiteIdRouteRouteWithChildren
  AuthPeopleSiteIdRouteRoute: typeof AuthPeopleSiteIdRouteRouteWithChildren
  AuthSettingsSiteIdRouteRoute: typeof AuthSettingsSiteIdRouteRouteWithChildren
  AuthSkuStoreSiteIdRouteRoute: typeof AuthSkuStoreSiteIdRouteRouteWithChildren
  AuthAppleMessagesConnectRoute: typeof AuthAppleMessagesConnectRoute
  AuthBrandOnboardingSiteIdRoute: typeof AuthBrandOnboardingSiteIdRouteWithChildren
  AuthComposeTextSiteIdRoute: typeof AuthComposeTextSiteIdRoute
  AuthDocsSiteIdRoute: typeof AuthDocsSiteIdRoute
  AuthSettingsNotificationRejectsRoute: typeof AuthSettingsNotificationRejectsRoute
  AuthSettingsNotificationsRoute: typeof AuthSettingsNotificationsRoute
  AuthDocsIndexRoute: typeof AuthDocsIndexRoute
  AuthConnectorsSiteIdYotpoInstallRoute: typeof AuthConnectorsSiteIdYotpoInstallRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthPreviewTestRoute: AuthPreviewTestRoute,
  AuthAssetsSiteIdRouteRoute: AuthAssetsSiteIdRouteRouteWithChildren,
  AuthBestiesSiteIdRouteRoute: AuthBestiesSiteIdRouteRouteWithChildren,
  AuthBlocksSiteIdRouteRoute: AuthBlocksSiteIdRouteRoute,
  AuthCreativeSphereSiteIdRouteRoute:
    AuthCreativeSphereSiteIdRouteRouteWithChildren,
  AuthDimensionsSiteIdRouteRoute: AuthDimensionsSiteIdRouteRouteWithChildren,
  AuthDragonTilesSiteIdRouteRoute: AuthDragonTilesSiteIdRouteRouteWithChildren,
  AuthExchangesSiteIdRouteRoute: AuthExchangesSiteIdRouteRouteWithChildren,
  AuthGenerationsSiteIdRouteRoute: AuthGenerationsSiteIdRouteRouteWithChildren,
  AuthGenlabSiteIdRouteRoute: AuthGenlabSiteIdRouteRouteWithChildren,
  AuthMarketingCalendarSiteIdRouteRoute:
    AuthMarketingCalendarSiteIdRouteRouteWithChildren,
  AuthPeopleSiteIdRouteRoute: AuthPeopleSiteIdRouteRouteWithChildren,
  AuthSettingsSiteIdRouteRoute: AuthSettingsSiteIdRouteRouteWithChildren,
  AuthSkuStoreSiteIdRouteRoute: AuthSkuStoreSiteIdRouteRouteWithChildren,
  AuthAppleMessagesConnectRoute: AuthAppleMessagesConnectRoute,
  AuthBrandOnboardingSiteIdRoute: AuthBrandOnboardingSiteIdRouteWithChildren,
  AuthComposeTextSiteIdRoute: AuthComposeTextSiteIdRoute,
  AuthDocsSiteIdRoute: AuthDocsSiteIdRoute,
  AuthSettingsNotificationRejectsRoute: AuthSettingsNotificationRejectsRoute,
  AuthSettingsNotificationsRoute: AuthSettingsNotificationsRoute,
  AuthDocsIndexRoute: AuthDocsIndexRoute,
  AuthConnectorsSiteIdYotpoInstallRoute: AuthConnectorsSiteIdYotpoInstallRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  DemoRoute: DemoRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  BlastroConnectRoute: BlastroConnectRoute,
  BlastroSiteIdConnectRoute: BlastroSiteIdConnectRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
